import React from 'react';
import ReactDOM from 'react-dom';

import '../assets/css/q2cui_oss.css';
import '../assets/css/oswidget.css';

import '../assets/css/omt-dashboard.css';
import '../assets/css/profile.css';

//--slickgrid css
import '../vendors/slickgrid/jquery-ui-1.11.3.oss.css';
import '../vendors/slickgrid/slick.grid_oss.css';
import '../vendors/slickgrid/slick-oss-theme.css';
import '../vendors/slickgrid/controls/slick.columnpicker.css';
import '../vendors/slistbox/listbox.css';

import spinning_small from '../assets/images/spinning_small.gif';
import spinning_large from '../assets/images/spinning_large.gif';
import bmui_sampleScreen from '../assets/images/bmui_sampleScreen.png';
import bmtBanner from "../assets/images/bmt-banner.jpg";

import '../vendors/slickgrid/lib/jquery.event.drag-2.3.0.js';
import '../vendors/slickgrid/lib/jquery-ui-1.12.1.custom.min.js';
import '../vendors/slickgrid/slick.core.js';
import '../vendors/slickgrid/slick.grid.js';
import '../vendors/slickgrid/plugins/slick.autotooltips.js';
import '../vendors/slickgrid/controls/slick.columnpicker.js';
import '../vendors/slickgrid/slick.colfix.js';

import '../vendors/slickgrid/plugins/slick.cellrangedecorator.js';
import '../vendors/slickgrid/plugins/slick.cellrangeselector.js';
import '../vendors/slickgrid/plugins/slick.cellselectionmodel.js';
import '../vendors/slickgrid/plugins/slick.rowselectionmodel.js';
import '../vendors/slickgrid/plugins/slick.checkboxselectcolumn.js';
import '../vendors/slickgrid/plugins/slick.cellexternalcopymanager.js';
import '../vendors/slickgrid/slick.editors.js';

import '../vendors/jquery.tokeninput.js';
import '../vendors/jquery.highlight-4.js';
import '../vendors/q2cui_oss.js';
import GlobalFooter from '../common/global-footer';
import { ExpandAllIcon, CollapseAllIcon } from "../common/icons.jsx";
import { Cases3WModal } from "../common/components.jsx";
import * as _ from "lodash";

var moment = require('moment');
var numeral = require('numeral');

import { drillDownResizehandler, formatChartName } from "./bmtUtils.jsx";

// osWidget_locales.js
//import {I18NFile} from '../common/osWidget_locales_HPI.js'

//jsx vendors
import DocTree  from '../vendors/DocTree.jsx';

// js common
import * as OSWidgetLib from '../common/osWidgetLib.js';

//jsx common 
import JSONTree from '../common/jsonViewer.jsx';
import {fmDate, fmDateTime} from '../common/formatter.jsx';
import {OSSMenu, showInitialLoadError} from '../common/mainMenueComponents.jsx';
import {DateChooser} from '../common/dateChooser.jsx';
import {SearchableMultiSelectBox, Tab, TabBar, FieldsCustomizer, ReadOnlyTextAreaBox, AdvancedListCustomizer, ExcelFilter} from '../common/components.jsx';
import {dedupAndCapValues, ADHOC_STRING_MAX_VALUES} from './bmtAdhocLimits.js';

import {InitOSSMenu, ShowInternalWidget} from '../common/main.jsx';
import {OrderNotes_Open} from '../notes/notes.jsx'

import {ToastContainer, toast} from 'react-toastify';

const exportExcelMaxLimit = 60000;
const MIN_DD_HEIGHT = 200;


    var runningCalls = 0;
    function reflectActivity (incrDecr)
    {
      runningCalls = runningCalls + incrDecr;
      if (runningCalls > 0) {
        $("#spinningIcon").show();
      } else {
        $("#spinningIcon").hide();
      }
    }

    function errorHandler(statusText, responseObj, responseText)
    {
      var errMsg;
      if (statusText == "timeout") {
        errMsg=T('warn_timeout');
        $('#errorPaneText').html(T('warn_timeout'));
      } else {
         if (responseObj) {
            errMsg=T('warn_error_occured') +':  '+ T(responseObj.message);
            $('#errorPaneText').html(T('warn_error_occured') +':&nbsp;&nbsp'+ T(responseObj.message));
         } else {
            errMsg=T('warn_error_occured');
            $('#errorPaneText').html(T('warn_error_occured'));
         }
         $('#errorPane').show();
         $('#loading').hide();
      }

      // If there is no content in main we need to push error content
      if ( $('#initialLoading').length && errMsg) {
        showInitialLoadError('backlog',
                             errMsg,
                             'initialLoading');
      }
    }

    function authErrorMessage() {
      console.log('Unauthorized access. Showing denied message');
      ReactDOM.render(
        <div id="errorPane" >
          <div id="errorPaneText" className="alert alert-danger errorPaneWidget2" role="alert">
            Access Denied!
            <br/>
            You have to request access to OSS / Sandy in order to use the Backlog Management UI.
            <br/>
            Click <b><a href="https://accessmanager.austin.hp.com/uam/">Request Access</a></b> and you will be redirected to UAM where you can select the appropriate OSS SANDY access profile.
            <br/>
          </div>
        </div>,
        document.getElementById('main')
      );
      return;
    }

function preFormatColumns(drilldownColumns, omtFields2HeadeProp, omtFields2int){
  return drilldownColumns.slice(3).map( function(column, i) {
    var field = 'f_'+i;
    var colHeader = column;
    
    if (omtFields2HeadeProp[ column ] ) {
        colHeader = omtFields2HeadeProp[ column ];
    }
    var type = 'enum';
    try { 
        var type = omtFields2int[ column ].type;
    } catch (e) {
    }    

    if (column == "HP Order No" || column == "HPOrderNo" ) {
      return { id: field, field: field, type: type, name: colHeader, sortable: true, formatter: HPOrderNoFormatter, minWidth: 125, frozen: true };
    } else
    if (column == "ServiceNotificationNo" && UserSettings.tenant == "HPICS") {
      return { id: field, field: field, type: type, name: colHeader, sortable: true, formatter: HideRepeatedFormatter, minWidth: 125, frozen: true };
    } else
    if (column == "ParentOrderNo" || column == "ICOrderNo") {
      return { id: field, field: field, type: type, name: colHeader, sortable: true, formatter: B2BFormatter, minWidth: 125 };
    } else
    if (column == "Blocks") {
      return { id: field, field: field, type: type, name: colHeader, sortable: true, formatter: BlocksFormatter, minWidth: 125 };
    } else
    if (["SAP Order No","Purchase Order No","Purchase Order Date", "Account", "Customer Name"].indexOf(column) > -1 ) { 
        return { id: field, field: field, type: type, name: colHeader, sortable: true, formatter: HideRepeatedFormatter };
    } else
    if (["SAPOrderNo","PurchaseOrderNo","PurchaseOrderDate", "Account", "CustomerName"].indexOf(column) > -1 ) { 
        return { id: field, field: field, type: type, name: colHeader, sortable: true, formatter: HideRepeatedFormatter };
    } else
    if (column == "Net Item Price (USD)"){ 
        return { id: field, field: field, type: type, name: colHeader, sortable: true, cssClass: 'right-align' };
    } else {
        return { id: field, field: field, type: type,name: colHeader, sortable: true };
    }
  })
}

function createCompactData(drilldownColumns, sortbyIndex) {

  var now = new Date();
  var watchedOrders = drilldownColumns.watched;

  return drilldownColumns.rows.map( function(row) {

    var formattedRow = [];
  
    var noteColor   = "#999";
  
    var subscribed  = false;
    var pinned      = false;
    for (var i = 0; i < watchedOrders.length; i++) {
      if (watchedOrders[i].legacy_order_no == row[0]) {
        if (watchedOrders[i].options == "pinned") {
          pinned = true;
        } else {
          subscribed = true;
        }
      }
    }
  
    var t = new Date( row[1].replace(" ", "T").concat("Z") );
    var timeDiff = ((now - t) / 1000) / 3600.0;
    if (timeDiff <  12.0) { noteColor = "#0b0" }
    else if (timeDiff <  48.0) { noteColor = "#ffd500" }
    else if (timeDiff >= 48.0) { noteColor = "#0096d6" }                    
  
    //console.log(row[0], row[1]);
    if (sortbyIndex == 3) {
      formattedRow.push( { lno: row[0], order: row[3], sortBy: "order", noteColor: noteColor, pinned: pinned, subscribed: subscribed} );
      formattedRow.push( row[4] );
    } else {
      formattedRow.push( row[4] );
      formattedRow.push( { lno: row[0], order: row[3], sortBy: "sn_no", noteColor: noteColor, pinned: pinned, subscribed: subscribed} );
    }
  
    return formattedRow.concat(row.slice(5));
  });
}

//------------------------------------------------------------------------
//  RDataGrid    -   a data grid based on SlickGrid wrapped in a
//                   reactjs component
//
//------------------------------------------------------------------------
class RDataGrid extends React.PureComponent {

  constructor(props) {
    super(props);
    this.grid = null;

    this.colFilter = [];
    this.colFilters = [];
    this.reOrderedColumns = [];
    this.popUpColumnCount = 0

    this.state = {
      filteredRows: -1
    }

    this._textWidth          = this._textWidth.bind(this);
    this.downloadDataXLSX    = this.downloadDataXLSX.bind(this);
    this.handleCustomizeGrid = this.handleCustomizeGrid.bind(this);
    this.preDefTplDownload   = this.preDefTplDownload.bind(this);
    this.handleApplyFilter   = this.handleApplyFilter.bind(this);
    this.handleCancelFilter  = this.handleCancelFilter.bind(this);
    this.handleFilterButton  = this.handleFilterButton.bind(this)
    this.handleClearFilter   = this.handleClearFilter.bind(this);
    this.popUpColumnCounter  = this.popUpColumnCounter.bind(this);
  }
  
  handleCustomizeGrid(e) {
      console.log('handleCustomizeGrid:',e); 
      //$('#ossCustomizeGridModal').modal('show');
      if (this.props.onCustomize) {
          this.props.onCustomize();
      }
  }
  
  _textWidth(txt, charWidth ) {
  
      var xw = charWidth[ 'x' ];
      var w = 0;
      for (var i = 0, len = txt.length; i < len; i++) {
        var c = txt[i];
        if (charWidth[ c ]) {
            w += charWidth[ c ]
        } else {
            w += xw;  
        }      
      }
      //console.log('textWidth "'+txt+'" = ', w);
      return (w+1);
  }

  popUpColumnCounter(value) {
    typeof(value) !== 'undefined' ?
      value != 0 ? this.popUpColumnCount = this.popUpColumnCount + value : this.popUpColumnCount = 0
    :  "";
    return this.popUpColumnCount
  }

  handleApplyFilter(jsonParam) {
    let selectedItems = jsonParam.selectedItems
    let colno         = jsonParam.props.colno
    let filterDetails = jsonParam.filterDetails

    if (filterDetails.clearAllFilter) {
      this.colFilters = []
    } else if (filterDetails.clearFilter) {
      this.colFilters[colno] = {}
    } else {
      // console.log("GOt selectedItems ",selectedItems)
      this.colFilters[colno] = {...filterDetails}
      this.colFilters[colno]["validFilterContents"] = [...selectedItems]
      // console.log("colFilters ",this.colFilters)
    }

    this.popUpColumnCounter(0)
    window.MainGrid = null;
    this.data = this.formatData(this.props.compactData, this.props.columns, this.colFilter, this.charWidth(this.props.id), this.colFilters);
    window.DrillDownData = this.data.fRows;
    var id = '#' + this.props.id;
    this.showGrid(id,  this.data.fRows, this.data.fColumns, this.data.colValsForFilter, this.props.options, this.colFilters);

  }

  setColorForFilter(jsonParam) {

    var color = 'transparent'
    var filterStrokeColor = '#fff'
    $("#"+jsonParam.props.id).css("background-color", "#767676");
    $("#"+jsonParam.props.id).css("color", "#fff");

    if( jsonParam.filterExist ) {
      color = '#d1f1ff' ;
      filterStrokeColor = '#0096d6'
      $("#"+jsonParam.props.id).css("background-color", "#d1f1ff");
      $("#"+jsonParam.props.id).css("color", "#0096d6");
    }

    return {color: color, filterStrokeColor: filterStrokeColor }
  }

  handleFilterButton(jsonParam) {
    {/*!(jsonParam.isFilterOpen) ? this.popUpColumnCounter(1) : return false ;*/}
    if (!(jsonParam.isFilterOpen)) {
      this.popUpColumnCounter(1);
    } else {
      return false;
    }
    let popUpColumnCount = this.popUpColumnCounter();
    if (popUpColumnCount < 2 ) {
      !(jsonParam.isFilterOpen) && $("#"+jsonParam.props.id).css("z-index", "12")
      return true
    } else {
      alert("Only one filter popup can be open at any given time!!!");
    }
  }

  getXAndYCoord(jsonParam) {
    let event  = jsonParam.event;
    let window = jsonParam.window;

    let xValue = event.clientX;
    let yValue = event.clientY;
    let maxPopUpHeight = 200
    let xMaxValue     = window.innerWidth
    let yMaxValue     = window.innerHeight

    let popUpXCord     = xValue > (xMaxValue -300)  ? (xMaxValue -300) : xValue ;
    let popUpYCord     = yValue > (yMaxValue -420)  ? (yMaxValue -420) : yValue-20 ;

    return { popUpXCord:popUpXCord,
             popUpYCord:popUpYCord,
             maxPopUpHeight:maxPopUpHeight
           }
  }

  handleCancelFilter(jsonParam) {
    this.popUpColumnCounter(0);
    $("#"+jsonParam.props.id).css("z-index", "11");
  }

  componentWillUnmount() {
      window.MainGrid = null;              
  }
                                      
  componentDidMount() {
    window.MainGrid = null; 
    if (this.props.id) {
      var id = '#' + this.props.id;

      if (this.props.embedInto) { 
        var embedHeight = $(this.props.embedInto).height();                   
        var embedWidth  = $(this.props.embedInto).width(); 
        $(id)
            .css("height", (embedHeight - 23) +'px')
            .css("width",  (embedWidth -   0) +'px');
      }
      
      if (this.props.compactData) {
        this.data = this.formatData(this.props.compactData, this.props.columns, this.colFilter, this.charWidth(this.props.id), this.colFilters )
      }

      // GEGA i dont like this, replace in future as global vars are a headache
      // memo to myself, look for window.DrillDownData in the code
      window.DrillDownData = this.data.fRows;

      for (var i=0; i<this.data.colVals.length; i++) {
          this.colFilter.push(null);
      } 
      {/*console.log("this.colFilter=", this.colFilter);*/}
      
      this.showGrid(id,  this.data.fRows, this.data.fColumns, this.data.colVals, this.props.options);

    } else {
      console.warn ('RDataGrid needs an id to work.');
    }
  }

  charWidth(id) {
    var charWidth = {};
    var charList = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789_-+=/?;:,.[]{}()!@#$%^&*";
    var grid = document.getElementById(id);
    var cell = document.createElement('div');
    cell.className = 'slick-cell'
    cell.style.padding = '0px';
    var txt = document.createTextNode('x');
    cell.appendChild(txt);
    grid.insertAdjacentElement('afterend',cell);
    for (var i = 0, len = charList.length; i < len; i++) {
      var c  = charList[i];
      txt.nodeValue = charList[i];
      charWidth[c] = parseFloat(getComputedStyle(cell, null).width.replace("px", ""));
      //console.log( c, this.charWidth[c] );
    }
    cell.remove();
    //console.log(charWidth);
    return charWidth;
  }

  formatDataOld(compactData, columns, colFilter, charWidth) {

    var colLen = [];
    var colVals = [];
    for (var j=0; j < columns.length; j++) {
        colLen[j] = 4;
       colVals.push({});
    }
    var rows = [];
    var val = "";
    for (var i=0; i < compactData.length; i++) {
      var row = {};
      var skip = false;
      for (var j=0; j < compactData[i].length; j++) {
        if ( !UserSettings.memberOf("ShowRestrictedFields")
          && ( columns[j].name.includes("Price") ||
               columns[j].name.includes("Tax") )
        ) { 
            val = "";
        } else {          
            val = compactData[i][j];
        }

        row[ columns[j].field ] = val;

        if (   columns[j].name == "HPOrderNo"
            || columns[j].name == "HP Order No"
        ) {
            val = compactData[i][j].order;
        }
        colVals[j][val] = true;
        if (colFilter[j] ) {
            if (colFilter[j] != val) skip = true;
        }  
          
        var textWidth = this._textWidth( compactData[i][j], charWidth );
        if (textWidth > colLen[j]) {
            colLen[j] = textWidth;
        }
      }
      if (!skip) {
          rows.push(row);
      }

    }

    for (var j=0; j < columns.length; j++) {
      var columns = [...columns];
      columns[j].width = colLen[j];
      if (columns[j].width > 150) {
          columns[j].width = 150;
      }
    }
    return { fRows:    rows, 
             fColumns: columns, 
             colVals:  colVals
    }
  }

  formatData(compactData, columns, colFilter, charWidth, colFilters) {

    var colLen = [];
    var colValsForFilter = [];
    var colVals = [];
    var filterExist = false

    for (var j=0; j < columns.length; j++) {
      colLen[j] = 4;
      colVals.push({});
      colValsForFilter.push({});
    }
    var rows = [];
    var val = "";

    for (var i=0; i < compactData.length; i++) {
      var row = {};
      var skip = false;
      var valForLastFilter = ""
      var skipCount = 0
      var tColValsForFilter = [] ;
      var lastFilterCol = -1;

      for (var j=0; j < compactData[i].length; j++) {
        if ( !UserSettings.memberOf("ShowRestrictedFields")
          && ( columns[j].name.includes("Price") ||
               columns[j].name.includes("Tax") )
        ) {
            val = "";
        } else {
            val = compactData[i][j];
        }

        row[ columns[j].field ] = val;

        if (   columns[j].name == "HPOrderNo"
            || columns[j].name == "HP Order No"
        ) {
            val = compactData[i][j].order;
        }
        colVals[j][val] = true;
        if (colFilters && colFilters[j] && colFilters[j]["validFilterContents"] && colFilters[j]["validFilterContents"].includes(val)) {
          skip = true ;
          skipCount++;
          lastFilterCol = j
          valForLastFilter = val
          filterExist = true
        }
        tColValsForFilter.push(val)

        var textWidth = this._textWidth( compactData[i][j], charWidth );
        if (textWidth > colLen[j]) {
            colLen[j] = textWidth;
        }
        // if (!skip) colVals[j][val] = true;
      }
      if (!skip) {
          rows.push(row);
          for (var j=0; j < tColValsForFilter.length; j++) {
            colValsForFilter[j][tColValsForFilter[j]] = true
          }
          // colValsForFilter={ ...colValsForFilter , ...tColValsForFilter}
      }
      if (skip &&  skipCount == 1 && lastFilterCol != -1 ) {
        colValsForFilter[lastFilterCol][valForLastFilter] = true
      }
    }

    for (var j=0; j < columns.length; j++) {
      var columns = [...columns];
      columns[j].width = colLen[j];
      if (columns[j].name) {
        columns[j].width = Math.max(this._textWidth(columns[j].name, charWidth), colLen[j]);
      }
      if (columns[j].width > 150) {
          columns[j].width = 150;
      }
    }
    if (filterExist) {
      $("#clearFilterButton").show();
      this.colFilters["clearFilter"]=false
    } else $("#clearFilterButton").hide();

    return { fRows:    rows,
             fColumns: columns,
             colVals:  colVals,
             colValsForFilter: colValsForFilter
    }
  }

  handleClearFilter(e) {
    this.handleApplyFilter({selectedItems :[], props : {colno :0}, filterDetails: { clearAllFilter:true } })
  }
  showGridOld(id, data, columns, colvals, options ) {

    if (this.grid) {

      this.grid.destroy();
      this.grid = [];
    }

    var checkboxSelector = new Slick.CheckboxSelectColumn({
        cssClass: "slick-cell-checkboxsel"
    });
      
    var selectorColDef = checkboxSelector.getColumnDefinition();
    
    selectorColDef.name = "<input type='checkbox' style='marginLeft: 2px'>"
    selectorColDef.frozen = true;
    
    columns.unshift( selectorColDef );      

    if (this.props.compactData.length == data.length) {
        this.setState( { filteredRows: -1 });
    } else {
        this.setState( { filteredRows: data.length } );       
    }

    this.grid = new Slick.Grid (id,  data, columns, options);

    //this.grid.onColumnsResized.subscribe (this._onColumnResize);
    //this.grid.onSort.subscribe (this._onSort);

    //this.grid.setSelectionModel( new Slick.RowSelectionModel( { selectActiveRow: false } ) );
    this.grid.setSelectionModel( new Slick.CellSelectionModel() );

    this.grid.registerPlugin( new Slick.AutoTooltips({ enableForHeaderCells: true }) );
    this.grid.registerPlugin( checkboxSelector );
    this.grid.registerPlugin( new Slick.CellExternalCopyManager({ readOnlyMode : true }) );

    
    var self = this;

    this.grid.onHeaderRowCellRendered.subscribe(function(e, args) {

        $(args.node).empty();
        if (args.column.field == "sel") return;

        var colno = parseInt(args.column.id.substr(2));

        var selectList = document.createElement("select");
        selectList.setAttribute("data-colno", colno);

        var na = false;
        if (self.props.columns[ colno ].type  == "double" ) { 
            selectList.setAttribute("title", "Auto filter not possible due to data type");
            na = true;
        }
        var option = document.createElement("option");
        option.value = na ? "_n/a_" : "_all_";
        option.text  = na ? "n/a" : "all";
        option.setAttribute("style","background-color: #aaaaaa");
        
        selectList.appendChild(option);       
        var vals = Object.keys(colvals[colno]);
        vals.sort();
        var used = false;
        for(var i = 0; !na && i < vals.length; i++) {
            var option = document.createElement("option");
            option.value = vals[i];
            option.text  = vals[i];
            if (self.colFilter[colno] ) {
                used = true;
                if (self.colFilter[colno] == vals[i]) option.selected = true;                 
            }  
            selectList.appendChild(option);       
        }
        args.node.appendChild(selectList);
        if (used) {
            selectList.setAttribute("style","background-color: #d1f1ff");   
        } else {
            selectList.setAttribute("style","background-color: #aaaaaa");  
        }
        selectList.onchange = function(e) {
            var selectList = e.target;
            var colno = selectList.getAttribute("data-colno");
            var val = selectList.options[selectList.selectedIndex].value;
            if (val == "_all_") {
                selectList.setAttribute("style","background-color: #aaaaaa");  
                self.colFilter[ colno ] = null;
            } else {
                selectList.setAttribute("style","background-color: #d1f1ff");  
                self.colFilter[ colno ] = val;
            }
            //console.log("colno", colno, val, "colFilter:", self.colFilter);

            var n = document.getElementById(self.props.id);
            while (n.lastElementChild) {
                n.removeChild(n.lastElementChild);
            }            
            window.MainGrid = null;
            self.data = self.formatData(self.props.compactData, self.props.columns, self.colFilter, self.charWidth(self.props.id));
            window.DrillDownData = self.data.fRows;
            var id = '#' + self.props.id;
            //console.log("self.showGrid  self.props.options=",self.props.options, "self.data=", self.data);
            self.showGrid(id,  self.data.fRows, self.data.fColumns, self.data.colVals, self.props.options);
        };
    });


    this.grid.onSelectedRowsChanged.subscribe(function (e, args) {
    
        console.log("onSelectedRowsChanged:", e, args);
        if (args.rows && args.rows.length > 0) {
           $("#massupdatecount").html( args.rows.length + " item(s)");
           $("#massUpdateButton").show();
           
        } else {
           $("#massUpdateButton").hide();
        }
    });
    
    this.grid.onCellChange.subscribe(function (e, args) {
        console.log("onCellChange:", e, args);
    });


    var columnpicker = new Slick.Controls.ColumnPicker(columns, this.grid, options);
    var self = this;
    this.grid.onColumnsReordered.subscribe(function (e, args) {
        console.log('RDataGrid onColumnsReordered:',e,args);
        console.log( self.grid.getColumns() );
    });
    window.MainGrid = this.grid;
    this.grid.onSort.subscribe(function (e, args) {
      var cols = args.sortCols;
      var l = cols.length
    
      for (var i = 0; i < l; i++) {
      
          var field = cols[i].sortCol.field;
          
          var isNum = true; 
          self.data.fRows.sort(function (row) {
              
              if (row[field].order) {
                  isNum = false;
              } else
              if (!row[field].match(/^-?[£$¤]?[\d,.]+%?$/)) {
                  isNum = false;
              }    
          });
          
          cols[i].sortCol.isNum = isNum;
          //console.log(i, isNum);
      }

      self.data.fRows.sort(function (dataRow1, dataRow2) {
        for (var i = 0; i < l; i++) {
          var field = cols[i].sortCol.field;
          var sign = cols[i].sortAsc ? 1 : -1;
          
          var value1 = dataRow1[field];
          if (value1.order) {
              value1 = value1.order;
          }
          var value2 = dataRow2[field];
          if (value2.order) {    
              value2 = value2.order;
          }
        
          if (cols[i].sortCol.isNum) {
              var aa = parseFloat(value1.replace(/[^0-9.-]/g,''));
              if (isNaN(aa)) aa = 0;
              var bb = parseFloat(value2.replace(/[^0-9.-]/g,''));
              if (isNaN(bb)) bb = 0;
              
              var result = (aa == bb ? 0 : (aa > bb ? 1 : -1)) * sign;
          } else {                                   
              var result = (value1 == value2 ? 0 : (value1 > value2 ? 1 : -1)) * sign;
          }    
          if (result != 0) {
            return result;
          }
        }
        return 0;
      });
      window.DrillDownData = self.data.fRows;
      
      self.grid.invalidate();
      self.grid.render();
    });

    //    onDblClick()...

    this.grid.onContextMenu.subscribe(function (e, args) {
      e.preventDefault();
      var cell = self.grid.getCellFromEvent(e);
      console.log('grid.onClick:', args);          
      console.log( self.data.fRows [ cell.row] );
      self.props.onClick( self.data.fRows[cell.row], self.props.freezeViewSo );
    });
                    
    this.grid.init();
    this.grid.resizeCanvas();
    this.grid.onViewportChanged.notify();
    var topPanelHeight = $('.topPanel') ? ($('.topPanel').height() - 4) : 0;
    var drilldown_height = $(window).height() - 95 - topPanelHeight;
    drilldown_height = Math.max(MIN_DD_HEIGHT, drilldown_height);
    $("#drilldownPanel").css({ height: ( drilldown_height) + 'px' });

    var drilldown_width  = $("#drilldownPanel").width();
    var widthCorrection = 2;
    if (navigator.userAgent.match(/Trident/)) {
         widthCorrection = 1;
    }
    $("#drilldowndata").css( { 
        height: (drilldown_height - 23) + 'px',
        width:  (drilldown_width  - widthCorrection) + 'px' 
    });
    if (window.MainGrid) {
        window.MainGrid.resizeCanvas();
        window.MainGrid.onViewportChanged.notify ();
    }


  }

  showGrid(id, data, columns, colvals, options, colFilters ) {

    if (this.grid) {

      this.grid.destroy();
      this.grid = [];
    }

    var checkboxSelector = new Slick.CheckboxSelectColumn({
        cssClass: "slick-cell-checkboxsel"
    });

    var selectorColDef = checkboxSelector.getColumnDefinition();

    selectorColDef.name = "<input type='checkbox' style='marginLeft: 2px'>"
    selectorColDef.frozen = true;

    columns.unshift( selectorColDef );

    var whichColumns = columns
    if(this.reOrderedColumns && this.reOrderedColumns.length !=0 ) {
      whichColumns = this.reOrderedColumns
      columns.length != this.reOrderedColumns.length ? whichColumns.unshift( selectorColDef ):""
    }

    if (this.props.compactData.length == data.length) {
        this.setState( { filteredRows: -1 });
    } else {
        this.setState( { filteredRows: data.length } );
    }

    this.grid = new Slick.Grid (id,  data, whichColumns, options);

    //this.grid.onColumnsResized.subscribe (this._onColumnResize);
    //this.grid.onSort.subscribe (this._onSort);

    //this.grid.setSelectionModel( new Slick.RowSelectionModel( { selectActiveRow: false } ) );
    this.grid.setSelectionModel( new Slick.CellSelectionModel() );

    this.grid.registerPlugin( new Slick.AutoTooltips({ enableForHeaderCells: true }) );
    this.grid.registerPlugin( checkboxSelector );
    this.grid.registerPlugin( new Slick.CellExternalCopyManager({ readOnlyMode : true }) );


    var self = this;

    this.grid.onHeaderCellRendered.subscribe(function(e, args) {

      {/*$(args.node).empty();*/}
      if (args.column.field == "sel") return;
      if (args.column.name == "") return;

      var colno = parseInt(args.column.id.substr(2));

      let fOptions = {}
      if( args.column.type == 'date'
          || args.column.name == "Purchase Order Date") {
        fOptions = {
                    enableBetween :true,
                    enableGt :true,
                    enableLt :true,
                    type:'date'
        }
      } else
      if (args.column.name == "Ordered Qty") {
        fOptions = {
                    enableBetween :true,
                    enableGt :true,
                    enableLt :true,
                    type:'int'
        }
      } else
      if (args.column.name == "Net Item Price (USD)") {
        fOptions = {
                    enableBetween :true,
                    enableGt :true,
                    enableLt :true,
                    type:'double'
        }
      }
      var vals = Object.keys(colvals[colno]);

      const filterContainer = document.createElement('div');
      filterContainer.addEventListener('click', (e) => {
        e.stopPropagation();
      });
      filterContainer.addEventListener('contextmenu', (e) => {
        e.preventDefault();
        e.stopPropagation();
      });

      filterContainer.style.position = 'absolute';
      filterContainer.style.top = '0';
      filterContainer.style.right = '2px';


      args.node.appendChild(filterContainer);

      ReactDOM.render(<ExcelFilter  data={vals}
                                    handleApplyFilter={self.handleApplyFilter}
                                    handleCancelFilter={self.handleCancelFilter}
                                    handleFilterButton={self.handleFilterButton}
                                    colno={colno}
                                    colFilters={self.colFilters}
                                    column={args.column}
                                    options={fOptions}
                                    id={args.node.id}
                                    setColorForFilter={self.setColorForFilter}
                                    getXAndYCoord={self.getXAndYCoord}
                                    />, filterContainer);

    });


    this.grid.onSelectedRowsChanged.subscribe(function (e, args) {

        console.log("onSelectedRowsChanged:", e, args);
        if (args.rows && args.rows.length > 0) {
           $("#massupdatecount").html( args.rows.length + " item(s)");
           $("#massUpdateButton").show();

        } else {
           $("#massUpdateButton").hide();
        }
    });

    this.grid.onCellChange.subscribe(function (e, args) {
        console.log("onCellChange:", e, args);
    });


    var columnpicker = new Slick.Controls.ColumnPicker(columns, this.grid, options);
    var self = this;
    this.grid.onColumnsReordered.subscribe(function (e, args) {
        console.log('RDataGrid onColumnsReordered:',e,args);
        console.log( self.grid.getColumns() );
        self.popUpColumnCounter(0);
        self.reOrderedColumns = self.grid.getColumns();
    });
    window.MainGrid = this.grid;
    this.grid.onSort.subscribe(function (e, args) {
      var cols = args.sortCols;
      var l = cols.length

      for (var i = 0; i < l; i++) {

          var field = cols[i].sortCol.field;

          var isNum = true;
          self.data.fRows.sort(function (row) {

              if (row[field].order) {
                  isNum = false;
              } else
              if (!row[field].match(/^-?[£$¤]?[\d,.]+%?$/)) {
                  isNum = false;
              }
          });

          cols[i].sortCol.isNum = isNum;
          //console.log(i, isNum);
      }

      self.data.fRows.sort(function (dataRow1, dataRow2) {
        for (var i = 0; i < l; i++) {
          var field = cols[i].sortCol.field;
          var sign = cols[i].sortAsc ? 1 : -1;

          var value1 = dataRow1[field];
          if (value1.order) {
              value1 = value1.order;
          }
          var value2 = dataRow2[field];
          if (value2.order) {
              value2 = value2.order;
          }

          if (cols[i].sortCol.isNum) {
              var aa = parseFloat(value1.replace(/[^0-9.-]/g,''));
              if (isNaN(aa)) aa = 0;
              var bb = parseFloat(value2.replace(/[^0-9.-]/g,''));
              if (isNaN(bb)) bb = 0;

              var result = (aa == bb ? 0 : (aa > bb ? 1 : -1)) * sign;
          } else {
              var result = (value1 == value2 ? 0 : (value1 > value2 ? 1 : -1)) * sign;
          }
          if (result != 0) {
            return result;
          }
        }
        return 0;
      });
      window.DrillDownData = self.data.fRows;

      self.grid.invalidate();
      self.grid.render();
    });

    //    onDblClick()...

    this.grid.onContextMenu.subscribe(function (e, args) {
      e.preventDefault();
      var cell = self.grid.getCellFromEvent(e);
      console.log('grid.onClick:', args);
      console.log( self.data.fRows [ cell.row] );
      self.props.onClick( self.data.fRows[cell.row], self.props.freezeViewSo );
    });

    this.grid.init();
    this.grid.resizeCanvas();
    this.grid.onViewportChanged.notify();
    var topPanelHeight = $('.topPanel') ? ($('.topPanel').height() - 4) : 0;
    var drilldown_height = $(window).height() - 95 - topPanelHeight;
    drilldown_height = Math.max(MIN_DD_HEIGHT, drilldown_height);
    $("#drilldownPanel").css({ height: ( drilldown_height) + 'px' });

    var drilldown_width  = $("#drilldownPanel").width();
    var widthCorrection = 2;
    if (navigator.userAgent.match(/Trident/)) {
         widthCorrection = 1;
    }
    $("#drilldowndata").css( {
        height: (drilldown_height - 23) + 'px',
        width:  (drilldown_width  - widthCorrection) + 'px'
    });
    if (window.MainGrid) {
        window.MainGrid.resizeCanvas();
        window.MainGrid.onViewportChanged.notify ();
    }


  }

  componentDidUpdate(prevProps, prevState) {
    var id = '#' + this.props.id;
    //this.showGrid(id,  this.data, this.props.columns, this.data.colVals, this.props.options);

    if (prevProps.freezeViewSo !== this.props.freezeViewSo) {
      window.MainGrid = null;
      this.data = this.formatData(this.props.compactData, this.props.columns, this.colFilter, this.charWidth(this.props.id), this.colFilters)
      window.DrillDownData = this.data.fRows;
      this.showGrid(id,  this.data.fRows, this.data.fColumns, this.props.options);
    }
  }

  // Make use of the new fast_xlsx library to download the data in xlsx
  downloadDataXLSX(stdColFlag, omtDetailData, compactData) {

    if (stdColFlag) {
      var columns = Object.assign({}, omtDetailData);
      var compactDataProp = [...compactData]
      var fileName = this.props.exportexcelreq.alertname + "_" + this.props.exportexcelreq.type + "_preDefTpl.xlsx";
    } else {
      var columns = Object.assign({}, this.props.columns);
      var compactDataProp = [...this.props.compactData];
      var fileName = this.props.exportexcelreq.alertname + "_" + this.props.exportexcelreq.type + ".xlsx";
    }
  
    var requestDetails = {         
      data:         compactDataProp,
      columns:      columns,
      area:         "drilldown", 
      headers:      "",
      title:        "",
      locale:       "",
      tenant:       "",
      stdcolflag:   stdColFlag
    };
  
    // Make a POST request using fetch (our own POST wrapper function does not work)
    fetch('/os/ossui/v1/in/sendExcel', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestDetails),
    })
    .then(response => {
      if (!response.ok) {
        toast.error(`Excel Dowload HTTP error! Status: ${response.status}`);
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return response.blob(); // Get the response as a Blob
    })
    .then(blob => {

      if (!blob) {
        throw new Error('Invalid blob data');
      }

      // Sanitize and define the filename
      const sanitizedFileName = fileName.replace(/[<>:"/\\|?*\x00-\x1F]/g, "_");

      // Create a URL and initiate download from memory
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = sanitizedFileName;
      a.click();
      window.URL.revokeObjectURL(url); // Clean up the URL object after download
      toast.success("Success! Excel Download Triggered!");
    })
  .catch(error => {
    console.error('Error:', error);
    toast.error("Excel Dowload error: ", error);
  });
}
  
  handleMassChange(e) {
      console.log('handleMassChange:',e); 

      $('#doingMassUpdate_plannerNotes').hide();
      $('#doingMassUpdate_csrNotes').hide();
      $('#doingMassUpdate_backOfficeNotes').hide();
      $('#doingMassUpdate_customerNotes').hide();

      $('#massUpdateResult_plannerNotes').hide();
      $('#massUpdateResult_csrNotes').hide();
      $('#massUpdateResult_backOfficeNotes').hide();
      $('#massUpdateResult_customerNotes').hide();
      $('#massUserStatus_result').hide();
      $('#massMigration_result').hide();

      $('#ossMassUpdateModal').modal('show');
  }

  preDefTplDownload() {
    //console.log('preDefTplDownload');
    var drilldownDetails    = {...this.props.drilldownDetails}
    var omtFields2HeadeProp = this.props.omtFields2HeadeProp;
    var omtFields2int       = this.props.omtFields2int;

    drilldownDetails.override = true;
    drilldownDetails.caller = "preDefTplDownload";

    var self = this;
    POST('/os/ossui/v1/in/omtDetail', drilldownDetails, function(resp) {
      var drilldownColumnsRows = preFormatColumns(resp.data.columns, omtFields2HeadeProp, omtFields2int );
      var compactData          = createCompactData(resp.data, 3)

      self.downloadDataXLSX(true, drilldownColumnsRows, compactData);
    });
  }

  render() {
    if (this.props.embedInto) { 
        var embedHeight = $(this.props.embedInto).height();                   
        var embedWidth  = $(this.props.embedInto).width(); 
        //GEGA TODO modify props is not allowed
        //this.props.style.height = (embedHeight - 23) +'px';
        //this.props.style.width  = (embedWidth  - 0) +'px';
        console.log(embedHeight, embedWidth);
    }

    $(window).resize( function() {
      drillDownResizehandler(window.MainGrid);
    });

    var nrRows = null;

    if (this.props.compactData) {
      nrRows = this.props.compactData.length;
    } else {
      nrRows = this.data;
    }
    console.log(this.props.nrOfRealRows);
    
    var exportexcelReq = this.props.exportexcelreq;
    
    var exportExcelURL = "/os/ossui/v1/in/exportDashboardTemplate/"+exportexcelReq.type+"/preDefTemplate/"+exportexcelReq.alertid+"/"+I18N.locale;
    var exportLargeDataExcelURL = "/os/ossui/v1/in/exportDashboardTemplate/"+exportexcelReq.type+"/preDefTemplateSmall/"+exportexcelReq.alertid+"/"+I18N.locale;

    var warningTxt = null;
    if (this.props.nrOfRealRows > exportExcelMaxLimit ) { 
      warningTxt = <span style={{"backgroundColor":"#ff7777", "color":"#000000", "padding":"2px 5px 1px 5px","marginLeft":"15px"}}> !! Only {exportExcelMaxLimit} rows shown (out of {this.props.nrOfRealRows}) !! </span>;
    }

    // freeze view switcher for CS
    var switchFreezeViewTxt = null;
    if ( this.props.freezeViewSo == false ) {
      switchFreezeViewTxt = "Switch to Service Notification View";
    } else {
      switchFreezeViewTxt = "Switch to Sales Order View";
    }
    var switchFreezeViewHTML = "";
    if ( UserSettings.tenant == 'HPICS') {
      switchFreezeViewHTML =  <div className="btn-group" style={{ "marginRight": "10px"}}><a href="#" data-toggle="dropdown" className="dropdown-toggle">                                        
                                <i className="glyphicon glyphicon-list" style={{"color": "#fff"}} />      
                                </a>                                                                                
                                <ul className="dropdown-menu">
                                  <li><a onClick={this.props.switchFreezeView}>{ switchFreezeViewTxt }</a></li>
                                </ul>                
                              </div>
    }


    var rowsMsg = "";
    if (nrRows != null) {
        if (this.state.filteredRows != -1) {
            rowsMsg =  this.state.filteredRows+' out of '+nrRows+' rows     for    '+ this.props.exportexcelreq.alertname;
        } else {
            rowsMsg =  nrRows+' rows     for    '+ this.props.exportexcelreq.alertname;
        }
    }

    return (
      <div id="rdatagrid" style={{"paddingBottom": "20px"}}>

        <svg display="none">
          <symbol id="bell-ring-outline" viewBox="0 0 24 24" off_preserveaspectratio="xMidYMid meet" style={{'msTransform': 'rotate(360deg)', 'WebkitTransform': 'rotate(360deg)', 'transform': 'rotate(360deg)'}}>
            <path d="M10 21h4a2 2 0 0 1-2 2a2 2 0 0 1-2-2m11-2v1H3v-1l2-2v-6c0-3.1 2.03-5.83 5-6.71V4a2 2 0 0 1 2-2a2 2 0 0 1 2 2v.29c2.97.88 5 3.61 5 6.71v6l2 2m-4-8a5 5 0 0 0-5-5a5 5 0 0 0-5 5v7h10v-7m2.75-7.81l-1.42 1.42A8.982 8.982 0 0 1 21 11h2c0-2.93-1.16-5.75-3.25-7.81M1 11h2c0-2.4.96-4.7 2.67-6.39L4.25 3.19A10.96 10.96 0 0 0 1 11z" fill="currentColor"/>
          </symbol>
          <symbol id="bell-ring" viewBox="0 0 24 24" off_preserveaspectratio="xMidYMid meet" style={{'msTransform': 'rotate(360deg)', 'WebkitTransform': 'rotate(360deg)', 'transform': 'rotate(360deg)'}}>
            <path d="M21 19v1H3v-1l2-2v-6c0-3.1 2.03-5.83 5-6.71V4a2 2 0 0 1 2-2a2 2 0 0 1 2 2v.29c2.97.88 5 3.61 5 6.71v6l2 2m-7 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2m9.75-17.81l-1.42 1.42A8.982 8.982 0 0 1 21 11h2c0-2.93-1.16-5.75-3.25-7.81M1 11h2c0-2.4.96-4.7 2.67-6.39L4.25 3.19A10.96 10.96 0 0 0 1 11z" fill="currentColor"/>
          </symbol>
          <symbol id="pin" viewBox="0 0 24 24" off_preserveaspectratio="xMidYMid meet" style={{'msTransform': 'rotate(360deg)', 'WebkitTransform': 'rotate(360deg)', 'transform': 'rotate(360deg)'}}>
            <path d="M19 17c0-2.038-1.188-3.836-3-4.92V5h.5a1.5 1.5 0 0 0 0-3h-9a1.5 1.5 0 0 0 0 3H8v7.08C6.188 13.164 5 14.962 5 17h6v4c0 .55.45 1 1 1s1-.45 1-1v-4h6z" fill="currentColor"/>    
          </symbol>
        </svg>  

       <div className="GridHeader">
         { switchFreezeViewHTML }
         <div className="btn-group"><a href="#" data-toggle="dropdown" className="dropdown-toggle">                                        
           <i className="glyphicon glyphicon-circle-arrow-down" style={{"color": "#fff"}} />      
           </a>                                                                                
           <ul className="dropdown-menu">
              <li><a href={exportLargeDataExcelURL}>Export large data by pre-defined template</a></li>
              <li><a onClick={() => this.preDefTplDownload()}>Export Data by Pre-Defined Template</a></li>  
              <li><a onClick={() => this.downloadDataXLSX(false)}>Export drill down data as shown</a></li>
           </ul>                
         </div> 
            &nbsp;&nbsp;&nbsp;&nbsp;
            { rowsMsg } 
            { warningTxt }
            &nbsp;&nbsp;&nbsp;

            <span id='clearFilterButton' style={{color: 'black', 'backgroundColor':  '#e0ffe0',
              display: 'none',
              cursor: 'pointer',
              margin: '0px 20px',
              padding: '1px 5px'
             }} onClick={this.handleClearFilter}>clear all filters
            </span>

            <span id='massUpdateButton' style={{color: 'black', 'backgroundColor':  '#e0ffe0',
              display: 'none',
              cursor: 'pointer',
              margin: '0px 20px',
              padding: '1px 5px'
             }} onClick={this.handleMassChange}>
             mass update: <span id='massupdatecount'>0</span>
            </span>
             &nbsp;&nbsp;&nbsp;
            <span style={{color: 'white', float: 'right'}}>
              right-click on row for detail in widget &nbsp;&nbsp;&nbsp;&nbsp; 
              <a onClick={this.handleCustomizeGrid} style={{ color: 'white'}} title="customize displayed columns"><i className="glyphicon glyphicon-cog"/></a>
            </span>
        </div>
       <div id={this.props.id} style={this.props.style}></div>
     </div>      
    );
  }

};

RDataGrid.OlddefaultProps = {
  id: null,
  charWidth: null,
  style: {
    position:'relative',
    height:  '400px',
    width:   '400px'
  },
  options: {   // SlickGrid options
    editable: true,
    asyncEditorLoading: false,
    autoEdit: false,
    enableCellNavigation: true,
    enableColumnReorder:  true,
    multiColumnSort:      true,
    forceFitColumns:      false,
    showHeaderRow:        true,
    headerRowHeight:      20,
    explicitInitialization: true

  },
}

RDataGrid.defaultProps = {
  id: null,
  charWidth: null,
  style: {
    position:'relative',
    height:  '400px',
    width:   '400px'
  },
  options: {   // SlickGrid options
    editable: true,
    asyncEditorLoading: false,
    autoEdit: false,
    enableCellNavigation: true,
    enableColumnReorder:  true,  
    multiColumnSort:      true,    
    forceFitColumns:      false,
    showHeaderRow:        false,
    createPreHeaderPanel: false,
    headerRowHeight:      20,
    explicitInitialization: true

  },  
}


    //------------------------------------------------------------------------
    //  AlertRow
    //
    //------------------------------------------------------------------------
    export class AlertRow extends React.PureComponent {

      constructor(props) {
        super(props);
        this.handleAlertRedirect = this.handleAlertRedirect.bind(this);
        this.handleDrillDownStateChange = this.handleDrillDownStateChange.bind(this);
        this.drill = this.drill.bind(this);

        this.state = {}
      }      

      handleAlertRedirect(alertId) {
        //window.open("alertEdit.html?id="+alertId,"OSS Alert Maintenance " +alertId)
        var self = this;
        window.legacystate.logParams.e = "BMT_Alert_Redirect";
        var oLog = {lprms:{}};
        oLog['lprms'] = window.legacystate.logParams;
        window.open("alertEdit.html?id="+alertId,"OSS Alert Maintenance " +alertId);
        //UserSettings.update('bm.lprms', oLog, (function(){window.open("alertEdit.html?id="+alertId,"OSS Alert Maintenance " +alertId)})(self));
      }

      handleDrillDownStateChange(drilldown, drilldownData, loadingDrilldown, drilldownExportExcelReq){
        this.setState({
          activeDrilldownType: drilldown.type
        })
        this.props.drillDownStateChange(drilldown, drilldownData, loadingDrilldown, drilldownExportExcelReq);
      }

      drill(type, omtConditions,alertname,alertid,drilldownTplName,dashboardId) {


        return function(e) {
          $(".omtValues").removeClass("omtDrilling");
          $('#errorPane').hide();
          $('#loading').show();
          $(e.target).addClass("omtDrilling");
          //console.log('drill:', type, omtConditions);

          var handleDrillDownStateChange = this.handleDrillDownStateChange;
          
          var drilldown = { type: type, 
                            tplName: drilldownTplName,
                            omtConditions: omtConditions,
                            dashboardId: dashboardId
                          };

          var drilldownExportExcelReq = {
                            type:type,
                            alertname:alertname,
                            alertid:alertid,
                            dilldownTplName:drilldownTplName
                          };
          
          handleDrillDownStateChange(drilldown, null, true, drilldownExportExcelReq);  

          POST('/os/ossui/v1/in/omtDetail', drilldown, function(resp) {

            handleDrillDownStateChange(drilldown, resp.data, false, drilldownExportExcelReq);
           
          });
        }.bind(this);
      }

      render() {
        var omtConditions = null;
        var values = [];
        var total = null;
        var numFormat = '0,0';

        if (this.props.omtConditions) {
          omtConditions = this.props.omtConditions;
          if ( omtConditions.displayValues == 'dollar' ) {
              numFormat = '$0,0';
          }
        }

        if (!this.props.show && this.props.dashboardId != -1) {
          return (null);
        }
       
        if (this.props.caller == "salesConsole") {
          var val = [null, null, null, null, null, null];

          if (this.props.waiting) {
            val[0] = <img key={this.props.alertname + 'spin0'} src={spinning_small} height="12" width="12" style={{ margin: "0px" }} />;
            val[1] = <img key={this.props.alertname + 'spin1'} src={spinning_small} height="12" width="12" style={{ margin: "0px" }} />;
            val[2] = <img key={this.props.alertname + 'spin2'} src={spinning_small} height="12" width="12" style={{ margin: "0px" }} />;
            val[3] = <img key={this.props.alertname + 'spin3'} src={spinning_small} height="12" width="12" style={{ margin: "0px" }} />;
            val[4] = <img key={this.props.alertname + 'spin4'} src={spinning_small} height="12" width="12" style={{ margin: "0px" }} />;
            val[5] = <img key={this.props.alertname + 'spin5'} src={spinning_small} height="12" width="12" style={{ margin: "0px" }} />;
          } else if (this.props.refreshNeeded) {
            return (
             <tr className="omtTable">
              <td className="omtAlert" key={this.props.alertname + 'name'} >{formatChartName(this.props.alertname)}</td>
              <td className="omtRed" key={this.props.alertname + 'red'}     >Refresh</td>
              <td className="omtOrange" key={this.props.alertname + 'orange'}  >Refresh</td>
              <td className="omtYellow" key={this.props.alertname + 'yellow'}  >Refresh</td>
              <td className="omtLime" key={this.props.alertname + 'lime'}  >Refresh</td>
              <td className="omtGreen" key={this.props.alertname + 'green'}   >Refresh</td>
              <td className="omtTotal" key={this.props.alertname + 'total'}   >Refresh</td>
             </tr>
            )
          } else {
            values = this.props.values;
            var total = 0;

            // omtNumbersAll leaves props.bucketLabels out whenever the alert profile
            // cannot be resolved, so salesConsole never fills alertbucket[7]. Older
            // cached entries can lack it too -- treat missing labels as "no label".
            var bucketLabels = values[7] || [];

            if (typeof values[0] == 'object' && values[0] != null) {
                val[0] = <em title={values[0].errText}>{values[0].indError}</em>
                total = 'E';
            } else {
              if (values[0] == null) {
                 val[0] = <span>&nbsp;</span>
              } else if (values[0] == 0) {
                 val[0] = <span style={{ "paddingRight": "6px" }}>{numeral(values[0]).format(numFormat)}</span>
              } else {
                 val[0] = <a className="omtValues" key={this.props.alertname + 'triggerV'}
                   onClick={this.drill('trigger', omtConditions, this.props.alertname, this.props.alertid, this.props.drilldownTplName, this.props.dashboardId)}
                   style={{ "cursor": "pointer" }}>{numeral(values[0]).format(numFormat)}</a>;
                 if (values[0]) total += values[0];
              }
            }

            if (typeof values[1] == 'object' && values[1] != null) {
               val[1] = <em title={values[1].errText}>{values[1].indError}</em>
               total = 'E';
            } else {
              if (values[1] == null) {
                val[1] = <span>&nbsp;</span>
              } else if (values[1] == 0) {
                if (bucketLabels[0] != '' && bucketLabels[0] != null) { 
                  val[1] = <span style={{ "paddingRight": "6px" }} >{numeral(values[1]).format(numFormat)}<span className="labelPopup">{bucketLabels[0]}</span></span>
                } else { 
                  val[1] = <span style={{ "paddingRight": "6px" }} >{numeral(values[1]).format(numFormat)}</span>
                }
              } else {
                if (bucketLabels[0] != '' && bucketLabels[0] != null) { 
                  val[1] = <a className="omtValues" key={this.props.alertname + 'redV'}
                    onClick={this.drill('red', omtConditions, this.props.alertname, this.props.alertid, this.props.drilldownTplName, this.props.dashboardId)}
                    style={{ "cursor": "pointer" }}>{numeral(values[1]).format(numFormat)}<span className="labelPopup">{bucketLabels[0]}</span></a>;
                    //if (values[1]) total += values[1];
                } else { 
                  val[1] = <a className="omtValues" key={this.props.alertname + 'redV'}
                    onClick={this.drill('red', omtConditions, this.props.alertname, this.props.alertid, this.props.drilldownTplName, this.props.dashboardId)}
                    style={{ "cursor": "pointer" }}>{numeral(values[1]).format(numFormat)}</a>;
                    //if (values[1]) total += values[1];      
                }
              }
            }

            if (typeof values[2] == 'object' && values[2] != null) {
               val[2] = <em title={values[2].errText}>{values[2].indError}</em>
               total = 'E';
            } else {
              if (values[2] == null) {
                 val[2] = <span>&nbsp;</span>
              } else if (values[2] == 0) {
                if (bucketLabels[1] != '' && bucketLabels[1] != null) {
                   val[2] = <span style={{ "paddingRight": "6px" }} >{numeral(values[2]).format(numFormat)}<span className="labelPopup">{bucketLabels[1]}</span></span>
                } else {
                   val[2] = <span style={{ "paddingRight": "6px" }} >{numeral(values[2]).format(numFormat)}</span>
                }
              } else {
                if (bucketLabels[1] != '' && bucketLabels[1] != null) {
                   val[2] = <a className="omtValues" key={this.props.alertname + 'orangeV'}
                     onClick={this.drill('orange', omtConditions, this.props.alertname, this.props.alertid, this.props.drilldownTplName, this.props.dashboardId)}
                     style={{ "cursor": "pointer" }}>{numeral(values[2]).format(numFormat)}<span className="labelPopup">{bucketLabels[1]}</span></a>;
                     //if (values[2]) total += values[2];
                } else {
                   val[2] = <a className="omtValues" key={this.props.alertname + 'orangeV'}
                     onClick={this.drill('orange', omtConditions, this.props.alertname, this.props.alertid, this.props.drilldownTplName, this.props.dashboardId)}
                     style={{ "cursor": "pointer" }}>{numeral(values[2]).format(numFormat)}</a>;
                     //if (values[2]) total += values[2];
                }
              }
            }

            if (typeof values[3] == 'object' && values[3] != null) {
               val[3] = <em title={values[3].errText}>{values[3].indError}</em>
               total = 'E';
            } else {
               if (values[3] == null) {
                  val[3] = <span>&nbsp;</span>
               } else if (values[3] == 0) {
                  if (bucketLabels[2] != ''  && bucketLabels[2] != null) {
                     val[3] = <span style={{ "paddingRight": "6px" }} >{numeral(values[3]).format(numFormat)}<span className="labelPopup">{bucketLabels[2]}</span></span>
                  } else {
                     val[3] = <span style={{ "paddingRight": "6px" }}>{numeral(values[3]).format(numFormat)}</span>
                  }
               } else {
                 if (bucketLabels[2] != '' && bucketLabels[2] != null) {
                    val[3] = <a className="omtValues" key={this.props.alertname + 'yellowV'}
                      onClick={this.drill('yellow', omtConditions, this.props.alertname, this.props.alertid, this.props.drilldownTplName, this.props.dashboardId)}
                      style={{ "cursor": "pointer" }}>{numeral(values[3]).format(numFormat)}<span className="labelPopup">{bucketLabels[2]}</span></a>;
                      //if (values[3]) total += values[3];
                 } else {
                    val[3] = <a className="omtValues" key={this.props.alertname + 'yellowV'}
                      onClick={this.drill('yellow', omtConditions, this.props.alertname, this.props.alertid, this.props.drilldownTplName, this.props.dashboardId)}
                      style={{ "cursor": "pointer" }}>{numeral(values[3]).format(numFormat)}</a>;
                      //if (values[3]) total += values[3];
                 }
               }
            }

            if (typeof values[4] == 'object' && values[4] != null) {
               val[4] = <em title={values[4].errText}>{values[4].indError}</em>
               total = 'E';
            } else {
               if (values[4] == null) {
                  val[4] = <span>&nbsp;</span>
               } else if (values[4] == 0) {
                  if (bucketLabels[3] != ''  && bucketLabels[3] != null) {
                     val[4] = <span style={{ "paddingRight": "6px" }} >{numeral(values[4]).format(numFormat)}<span className="labelPopup">{bucketLabels[3]}</span></span>
                  } else {
                     val[4] = <span style={{ "paddingRight": "6px" }}>{numeral(values[4]).format(numFormat)}</span>
                  }
               } else {
                 if (bucketLabels[3] != ''  && bucketLabels[3] != null) {
                    val[4] = <a className="omtValues" key={this.props.alertname + 'limeV'}
                      onClick={this.drill('lime', omtConditions, this.props.alertname, this.props.alertid, this.props.drilldownTplName, this.props.dashboardId)}
                      style={{ "cursor": "pointer" }}>{numeral(values[4]).format(numFormat)}<span className="labelPopup">{bucketLabels[3]}</span></a>;
                      //if (values[4]) total += values[4];
                 } else {
                    val[4] = <a className="omtValues" key={this.props.alertname + 'limeV'}
                      onClick={this.drill('lime', omtConditions, this.props.alertname, this.props.alertid, this.props.drilldownTplName, this.props.dashboardId)}
                      style={{ "cursor": "pointer" }}>{numeral(values[4]).format(numFormat)}</a>;
                      //if (values[4]) total += values[4];
                 }
               }
            }

            if (typeof values[5] == 'object' && values[5] != null) {
               val[5] = <em title={values[5].errText}>{values[5].indError}</em>
               total = 'E';
            } else {
              if (values[5] == null) {
                 val[5] = <span>&nbsp;</span>
              } else if (values[5] == 0) {
                if (bucketLabels[4] != ''  && bucketLabels[4] != null) {
                   val[5] = <span style={{ "paddingRight": "6px" }} >{numeral(values[5]).format(numFormat)}<span className="labelPopup">{bucketLabels[4]}</span></span>
                } else {
                   val[5] = <span style={{ "paddingRight": "6px" }}>{numeral(values[5]).format(numFormat)}</span>
                }
              } else {
                if (bucketLabels[4] != ''  && bucketLabels[4] != null) {
                   val[5] = <a className="omtValues" key={this.props.alertname + 'greenV'}
                     onClick={this.drill('green', omtConditions, this.props.alertname, this.props.alertid, this.props.drilldownTplName, this.props.dashboardId)}
                     style={{ "cursor": "pointer" }}>{numeral(values[5]).format(numFormat)}<span className="labelPopup">{bucketLabels[4]}</span></a>;
                     //if (values[5]) total += values[5];
                } else {
                   val[5] = <a className="omtValues" key={this.props.alertname + 'greenV'}
                     onClick={this.drill('green', omtConditions, this.props.alertname, this.props.alertid, this.props.drilldownTplName, this.props.dashboardId)}
                     style={{ "cursor": "pointer" }}>{numeral(values[5]).format(numFormat)}</a>;
                     //if (values[5]) total += values[5];
                }
              }
            }

          }
          //console.log(this.props);
          var type = this.state.activeDrilldownType ? this.state.activeDrilldownType : "all";
          var locale = I18N.locale;
          var exportURL = "/os/ossui/v1/in/exportDashboardTemplate/" + type + "/preDefTemplate/" + this.props.alertid + "/" + locale;
          var tmpLimit = exportExcelMaxLimit;
          //if (omtConditions && omtConditions.displayValues && omtConditions.displayValues != 'items') {
          //    tmpLimit = tmpLimit / 4;
          //}
          var totalCmp = total;
          var nrRowsTotal = -1;
          if (0 && values[6]) {
            nrRowsTotal = 0;
            if (values[6][0] != null) { nrRowsTotal = nrRowsTotal + values[6][0]; }
            if (values[6][1] != null) { nrRowsTotal = nrRowsTotal + values[6][1]; }
            if (values[6][2] != null) { nrRowsTotal = nrRowsTotal + values[6][2]; }
            if (values[6][3] != null) { nrRowsTotal = nrRowsTotal + values[6][3]; }
            if (values[6][4] != null) { nrRowsTotal = nrRowsTotal + values[6][4]; }
            if (values[6][5] != null) { nrRowsTotal = nrRowsTotal + values[6][5]; }

            if (omtConditions && omtConditions.displayValues && omtConditions.displayValues != 'items') {
              // use number of rows as total comparison
              totalCmp = nrRowsTotal;
            }
          }
          //console.log('JOLO ',this.props.alertname,' exportExcelMaxLimit=',exportExcelMaxLimit, 'tmpLimit=', tmpLimit, 'nrRowsTotal=',nrRowsTotal, values);
          //console.log(values);
          //console.log(total);
          //console.log(val);

          if (total != null && total != 'E' ) {
            var exportIcon = <a href={exportURL}
            ><i className="glyphicon glyphicon-circle-arrow-down" style={{ "color": "#0096d6", "fontSize": "13px" }}
              /></a>;
            if (totalCmp > tmpLimit) {
              exportIcon = <a disabled title={'Export Limit of ' + exportExcelMaxLimit + ' items reached'}
              ><i className="glyphicon glyphicon-circle-arrow-down" style={{ "color": "#767676", "fontSize": "13px" }}
                /></a>;
            }
            if (total == 0) {
              total = (
                <span>{numeral(total).format(numFormat)}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<a disabled><i className="glyphicon glyphicon-circle-arrow-down" style={{ "color": "#e0e0e0" }} /></a></span>
              )

            } else {
              var drillType = 'all'
              if (values[0] > 0) {
                // tigger(Y/N) alert
                drillType = 'trigger'
              }
              total = (
                <span> <a className="omtValues" key={this.props.alertname + 'allV'}
                  onClick={this.drill(drillType, omtConditions, this.props.alertname, this.props.alertid, this.props.drilldownTplName, this.props.dashboardId)}
                  style={{ "cursor": "pointer" }}
                >{numeral(total).format(numFormat)}</a>&nbsp;&nbsp;&nbsp;{exportIcon}</span>
              )
            }
          }

          // tigger(Y/N) alerts only fill the trigger bucket, the traffic light 0s carry no information
          if (values[8] === 'trigger') {
            for (var b = 1; b <= 5; b++) {
              if (values[b] == 0) { val[b] = <span>&nbsp;</span>; }
            }
          }

          return (
           <tr className="omtTable">
             <td className="omtAlert" key={this.props.alertname + 'name'}    ><a onClick={this.handleAlertRedirect.bind(null, this.props.alertid)} style={{ "color": "#fff", "cursor": "pointer" }}>{formatChartName(this.props.alertname)}</a></td>
             <td className="omtRed" key={this.props.alertname + 'red'}     >{val[1]}</td>
             <td className="omtOrange" key={this.props.alertname + 'orange'} >{val[2]}</td>
             <td className="omtYellow" key={this.props.alertname + 'yellow'}  >{val[3]}</td>
             <td className="omtLime" key={this.props.alertname + 'lime'}   >{val[4]}</td>
             <td className="omtGreen" key={this.props.alertname + 'green'}  >{val[5]}</td>
             <td className="omtTotal" key={this.props.alertname + 'total'}   >{total}</td>
           </tr>
          )

    	  } else {

          var val = [ null, null, null, null];

          if (this.props.waiting) {
            val[0] = <img key={this.props.alertname+'spin0'} src={spinning_small} height="12" width="12" style={{ margin: "0px" }}/>;
            val[1] = <img key={this.props.alertname+'spin1'} src={spinning_small} height="12" width="12" style={{ margin: "0px" }}/>;
            val[2] = <img key={this.props.alertname+'spin2'} src={spinning_small} height="12" width="12" style={{ margin: "0px" }}/>;
            val[3] = <img key={this.props.alertname+'spin3'} src={spinning_small} height="12" width="12" style={{ margin: "0px" }}/>;
          } else if (this.props.refreshNeeded) {
          return (
            <tr className="omtTable">
              <td className="omtAlert"   key={this.props.alertname+'name'} >{formatChartName(this.props.alertname)}</td>
              <td className="omtRed"     key={this.props.alertname+'red'}     >Refresh</td>
              <td className="omtYellow"  key={this.props.alertname+'yellow'}  >Refresh</td>
              <td className="omtGreen"   key={this.props.alertname+'green'}   >Refresh</td>
              <td className="omtTotal"   key={this.props.alertname+'total'}   >Refresh</td>
            </tr>
            )
          } else {
            values = this.props.values;
            var total = 0;

            if (typeof values[0] == 'object' && values[0] != null) {
              val[0] = <em title={values[0].errText}>{values[0].indError}</em>
              total = 'E';
            } else {
              if (values[0] == null) {
                val[0] = <span>&nbsp;</span>
              } else if (values[0] == 0) {
                val[0] = <span style={{"paddingRight":"6px"}}>{numeral(values[0]).format(numFormat)}</span>
              } else {
                val[0] = <a className="omtValues" key={this.props.alertname+'triggerV'}
                          onClick={this.drill('trigger', omtConditions, this.props.alertname, this.props.alertid,this.props.drilldownTplName,this.props.dashboardId)} 
                          style={{ "cursor": "pointer" }}>{numeral(values[0]).format(numFormat)}</a>;
                if (values[0]) total += values[0];
              }
            }

              if (typeof values[1] == 'object' && values[1] != null) {
                val[1] = <em title={values[1].errText}>{values[1].indError}</em>
                total = 'E';
              } else {
                if (values[1] == null) {
                  val[1] = <span>&nbsp;</span>
                } else if (values[1] == 0) {
                  val[1] = <span style={{"paddingRight":"6px"}}>{numeral(values[1]).format(numFormat)}</span>
                } else {
                  val[1] = <a className="omtValues" key={this.props.alertname+'redV'}
                          onClick={this.drill('red'    , omtConditions, this.props.alertname, this.props.alertid,this.props.drilldownTplName,this.props.dashboardId)} 
                          style={{ "cursor": "pointer" }}>{numeral(values[1]).format(numFormat)}</a>;
                  //if (values[1]) total += values[1];
                }
              }

              if (typeof values[2] == 'object' && values[2] != null) {
                 val[2] = <em title={values[2].errText}>{values[2].indError}</em>
                 total = 'E';
              } else {
                  if (values[2] == null) {
                  val[2] = <span>&nbsp;</span>
                } else if (values[2] == 0) {
                  val[2] = <span style={{"paddingRight":"6px"}}>{numeral(values[2]).format(numFormat)}</span>
                } else {
                 val[2] = <a className="omtValues" key={this.props.alertname+'yellowV'}
                          onClick={this.drill('yellow' , omtConditions, this.props.alertname, this.props.alertid,this.props.drilldownTplName,this.props.dashboardId)} 
                          style={{ "cursor": "pointer" }}>{numeral(values[2]).format(numFormat)}</a>;
                 //if (values[2]) total += values[2];
                }
               }

               if (typeof values[3] == 'object' && values[3] != null) {
                 val[3] = <em title={values[3].errText}>{values[3].indError}</em>
                 total = 'E';
               } else {
                 if (values[3] == null) {
                   val[3] = <span>&nbsp;</span>
                 } else if (values[3] == 0) {
                   val[3] = <span style={{"paddingRight":"6px"}}>{numeral(values[3]).format(numFormat)}</span>
                 } else {
                   val[3] = <a className="omtValues" key={this.props.alertname+'greenV'}
                          onClick={this.drill('green'  , omtConditions, this.props.alertname, this.props.alertid,this.props.drilldownTplName,this.props.dashboardId)}
                          style={{ "cursor": "pointer" }}>{numeral(values[3]).format(numFormat)}</a>;
                   //if (values[3]) total += values[3];
                 }
               }

        }
        //console.log(this.props);
        var type = this.state.activeDrilldownType ? this.state.activeDrilldownType : "all";
        var locale = I18N.locale;
        var exportURL = "/os/ossui/v1/in/exportDashboardTemplate/"+type+"/preDefTemplate/"+this.props.alertid+"/"+locale;
        var tmpLimit = exportExcelMaxLimit;
        //if (omtConditions && omtConditions.displayValues && omtConditions.displayValues != 'items') {
        //    tmpLimit = tmpLimit / 4;
        //}
        var totalCmp = total;
        var nrRowsTotal = -1;
        if (0 && values[4]) {
            nrRowsTotal = 0;
            if (values[4][0] != null) { nrRowsTotal = nrRowsTotal + values[4][0]; }
            if (values[4][1] != null) { nrRowsTotal = nrRowsTotal + values[4][1]; }
            if (values[4][2] != null) { nrRowsTotal = nrRowsTotal + values[4][2]; }
            if (values[4][3] != null) { nrRowsTotal = nrRowsTotal + values[4][3]; }

            if (omtConditions && omtConditions.displayValues && omtConditions.displayValues != 'items') {
               // use number of rows as total comparison
               totalCmp = nrRowsTotal;
            }  
        }
        //console.log('JOLO ',this.props.alertname,' exportExcelMaxLimit=',exportExcelMaxLimit, 'tmpLimit=', tmpLimit, 'nrRowsTotal=',nrRowsTotal, values);
        //console.log(values);
        //console.log(total);
        //console.log(val);

          if(total != null && total != 'E') {
            var exportIcon = <a href={exportURL}
                                      ><i className="glyphicon glyphicon-circle-arrow-down" style={{"color":"#0096d6","fontSize":"13px"}}
                            /></a>;
            if (totalCmp > tmpLimit) {
              exportIcon = <a disabled title={'Export Limit of '+exportExcelMaxLimit+' items reached'}
                                ><i className="glyphicon glyphicon-circle-arrow-down" style={{"color":"#767676","fontSize":"13px"}}
                           /></a>;
                  }
            if (total == 0) {
              total = (
              <span>{numeral(total).format(numFormat)}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<a disabled><i className="glyphicon glyphicon-circle-arrow-down" style={{"color":"#e0e0e0"}}/></a></span>
              )

            } else {
              var drillType = 'all'  
              if (values[0] > 0) {
                  // tigger(Y/N) alert
                 drillType ='trigger'
              }
              total = (
                        <span> <a className="omtValues" key={this.props.alertname+'allV'}
                                  onClick={this.drill(drillType, omtConditions, this.props.alertname, this.props.alertid,this.props.drilldownTplName,this.props.dashboardId)}
                                  style={{ "cursor": "pointer" }}
                                >{numeral(total).format(numFormat)}</a>&nbsp;&nbsp;&nbsp;{exportIcon}</span>
                      )
            }
          }

         // tigger(Y/N) alerts only fill the trigger bucket, the traffic light 0s carry no information
         if (values[5] === 'trigger') {
           for (var b = 1; b <= 3; b++) {
             if (values[b] == 0) { val[b] = <span>&nbsp;</span>; }
           }
         }

         return (
          <tr className="omtTable">
            <td className="omtAlert"   key={this.props.alertname+'name'}    ><a onClick={this.handleAlertRedirect.bind(null, this.props.alertid)} style={{"color": "#fff", "cursor": "pointer" }}>{formatChartName(this.props.alertname)}</a></td>
            <td className="omtRed"     key={this.props.alertname+'red'}     >{val[1]}</td>
            <td className="omtYellow"  key={this.props.alertname+'yellow'}  >{val[2]}</td>
            <td className="omtGreen"   key={this.props.alertname+'green'}   >{val[3]}</td>
            <td className="omtTotal"   key={this.props.alertname+'total'}   >{total }</td>
          </tr>
         )
        }
      }
    };
    
    //------------------------------------------------------------------------
    //  ShowAlerts   --  render all alerts and trigger refesh of
    //                   alert numbers
    //
    //------------------------------------------------------------------------
    export class ShowAlerts extends React.PureComponent {

      constructor(props) {
        super(props);

        this.state = {
          cache: {},
          separators: [],
          displayedAlerts: [],
          customViewAlerts: [],
          myCustomDashboardView: {},
          customViewEditorSubtitle: "",
          showCustomViewEditor: false,
          isCustomized: false
        };        

        this.cleanCustomViewAlerts  = this.cleanCustomViewAlerts.bind(this);
        this.handleCustomViewSave   = this.handleCustomViewSave.bind(this);
        this.handleCustomViewCancel = this.handleCustomViewCancel.bind(this);
        this.handleCustomViewBtn    = this.handleCustomViewBtn.bind(this);
        this.handleSwitchView       = this.handleSwitchView.bind(this);
        this.handleRefreshBtn       = this.handleRefreshBtn.bind(this);
        this.handleDropdownChange   = this.handleDropdownChange.bind(this);
        this.handleFilterMode       = this.handleFilterMode.bind(this);
        this.handleToggleSeparator  = this.handleToggleSeparator.bind(this);
      }

      componentDidMount() {
        console.log("BMT_DEBUG ShowAlerts_componentDidMount");
        this.props.getAndShowDashboard();
      }

      async componentDidUpdate(prevProps, prevState) {
        if (prevProps.dashboardId !== this.props.dashboardId) {
          console.log("BMT_DEBUG ShowAlerts_componentDidUpdate >> this.props.dashboardId")
          this.props.getAndShowDashboard();
        }

        if (!(_.isEqual(prevProps.alertList, this.props.alertList))) {
          console.log("BMT_DEBUG ShowAlerts_componentDidUpdate >> this.props.alertList")

          var myCustomDashboardView = {}
          var displayedAlerts = [];
          var customViewAlerts = [];
          var separators = [];
          var isCustomized = false;
          var view = "S";
          var subtitle = ""

          myCustomDashboardView = await UserSettings.get("bm.myCustomDashboardViews." + this.props.dashboardId);

          for (var i = 0; i < this.props.alertList.length; i++) {
            if (this.props.alertList[i].alert_id == 0) {
              this.props.alertList[i].color = 2;
              this.props.alertList[i].id = btoa(this.props.alertList[i].name);
              this.props.alertList[i].expanded = true;

            } else {
              this.props.alertList[i].color = 1;
              this.props.alertList[i].id = this.props.alertList[i].alert_id.toString();
            }

            this.props.alertList[i].hide = false;
          }

          if (myCustomDashboardView && myCustomDashboardView.view)
              view = myCustomDashboardView.view;

          if (myCustomDashboardView
              && myCustomDashboardView.alerts
              && myCustomDashboardView.alerts.length > 0)
          {
            for (var i = 0; i < myCustomDashboardView.alerts.length; i++) {
              for (var j = 0; j < this.props.alertList.length; j++) {
                if (myCustomDashboardView.alerts[i].id == this.props.alertList[j].id) {
                  if (!myCustomDashboardView.alerts[i].hide)
                    customViewAlerts.push(this.props.alertList[j])
                  else
                    this.props.alertList[j].hide = true;
                  break;
                }
              }
            }

            isCustomized = true;

            if (_.isEqual(customViewAlerts, this.props.alertList)) {
              isCustomized = false;
            } else {
              isCustomized = true;
            }

            this.setState({myCustomDashboardView: {
              view: view,
              alerts: [...myCustomDashboardView.alerts]
            }});

          } else {
            this.setState({myCustomDashboardView: {
              view: view,
              alerts: this.cleanCustomViewAlerts([...this.props.alertList])
            }});
          }

          if (view == "S") {
            for (var i = 0; i < this.props.alertList.length; i++)
              if (this.props.alertList[i].alert_id == 0)
                separators.push(this.props.alertList[i]);

            this.setState({displayedAlerts: [...this.props.alertList]});
            this.setState({customViewAlerts: [...this.props.alertList]});

          } else if (view == "C") {
            for (var i = 0; i < customViewAlerts.length; i++)
              if (customViewAlerts[i].alert_id == 0)
                separators.push(customViewAlerts[i]);

            this.setState({displayedAlerts: [...customViewAlerts]});
            this.setState({customViewAlerts: [...customViewAlerts]});
          }

          if (this.props.alertDashboards) {
            for (var i = 0; i < this.props.alertDashboards.length; i++) {
              if (this.props.alertDashboards[i].dashboard_id == this.props.dashboardId) {
                var preText = "(The standard dashboard was last modified on ", postText = ")";
                subtitle = this.props.alertDashboards[i].last_changed_on
                  ? preText + fmDate(this.props.alertDashboards[i].last_changed_on) + postText
                  : (this.props.alertDashboards[i].created_on
                    ? preText + fmDate(this.props.alertDashboards[i].created_on) + postText
                    : preText + "1 Nov 2015" + postText);
                break;
              }
            }
          }

          this.setState({separators: separators});
          this.setState({isCustomized: isCustomized});
          this.setState({customViewEditorSubtitle: subtitle});
        }
      }

      cleanCustomViewAlerts(alerts) {
        var cleanAlerts = [];
        var validKeys = ["id", "name", "color", "hide"];

        for (var i = 0; i < alerts.length; i++) {
          var alert = {}

          Object.keys(alerts[i]).forEach(function(key) {
            if (validKeys.includes(key))
              alert[key] = alerts[i][key];
          });

          cleanAlerts.push(alert);
        }

        return cleanAlerts;
      }

      handleCustomViewSave(list) {
        var separators = [];
        var newDisplayedAlerts = [];
        var isCustomized = false;
        var view = "S";

        for (var i = 0; i < list.length; i++) {
          for (var j = 0; j < this.props.alertList.length; j++) {
            if (list[i].id == this.props.alertList[j].id) {
              if (!list[i].hide){
                newDisplayedAlerts.push(this.props.alertList[j]);
                if (this.props.alertList[j].alert_id == 0) {
                  this.props.alertList[j].expanded = true;
                  separators.push(this.props.alertList[j]);
                }
              }
              break;
            }
          }
        }

        if (newDisplayedAlerts.length <= 0) {
          view = "C";
          isCustomized = true;

          for (var i = 0; i < this.props.alertList.length; i++)
            if (this.props.alertList[i].alert_id == 0)
              separators.push(this.props.alertList[i]);

          this.setState({customViewAlerts: [...this.props.alertList]});
          this.setState({displayedAlerts: []});

        } else {
          if (_.isEqual(newDisplayedAlerts, this.props.alertList)) {
            view = "S";
            isCustomized = false;

          } else {
            view = "C";
            isCustomized = true;
          }

          this.setState({customViewAlerts: newDisplayedAlerts});
          this.setState({displayedAlerts: newDisplayedAlerts});
        }

        this.setState({separators: separators});
        this.setState({isCustomized: isCustomized});
        this.setState({showCustomViewEditor: false});
        this.setState({myCustomDashboardView: {view: view, alerts: this.cleanCustomViewAlerts(list)}});

        UserSettings.update("bm.myCustomDashboardViews." + this.props.dashboardId,
          {view: view, alerts: this.cleanCustomViewAlerts(list)}, function() {
          console.log("UserSettings (bm.myCustomDashboardViews." + this.props.dashboardId + "): SAVED");
          this.props.getAndShowDashboard();
        }.bind(this))
      }

      handleCustomViewCancel() {
        this.setState({
          showCustomViewEditor: false
        });
      }

      handleCustomViewBtn() {
        this.setState({
          showCustomViewEditor: true
        });
      }

      handleSwitchView() {
        var separators = [];
        var newDisplayedAlerts = [];
        var myCustomDashboardView = _.cloneDeep(this.state.myCustomDashboardView);

        if (myCustomDashboardView.view == "C") {
          newDisplayedAlerts = [...this.props.alertList];
          myCustomDashboardView.view = "S";

        } else if (myCustomDashboardView.view == "S") {
          newDisplayedAlerts = [...this.state.customViewAlerts];
          myCustomDashboardView.view = "C";
        }

        for (var i = 0; i < newDisplayedAlerts.length; i++)
          if (newDisplayedAlerts[i].alert_id == 0)
            separators.push(newDisplayedAlerts[i]);

        this.setState({separators: separators});
        this.setState({displayedAlerts: newDisplayedAlerts});
        this.setState({myCustomDashboardView: myCustomDashboardView});

        UserSettings.update("bm.myCustomDashboardViews." + this.props.dashboardId,
          {view: myCustomDashboardView.view, alerts: this.cleanCustomViewAlerts(myCustomDashboardView.alerts)}, function() {
          console.log("UserSettings (bm.myCustomDashboardViews." + this.props.dashboardId + "): SAVED");
          this.props.getAndShowDashboard();
        }.bind(this))
      }

      handleToggleSeparator(name, expanded) {
        var newDisplayedAlerts = [];
        var separators = [...this.state.separators];
        var separatorFound = false;
        var separatorCollapsed = false;

        for (var i = 0; i < separators.length; i++) {
          if (separators[i].name == name) {
            if (separators[i].expanded)
              separators[i].expanded = false;
            else
              separators[i].expanded = true;
          }
        }

        for (var i = 0; i < this.state.customViewAlerts.length; i++) {
          for (var j = 0; j < separators.length; j++) {
            if (this.state.customViewAlerts[i].name == separators[j].name) {
              separatorCollapsed = false;
              if (separators[j].expanded == false)
                separatorCollapsed = true;
              newDisplayedAlerts.push(this.state.customViewAlerts[i]);
              break;
            }
          }

          if (!separatorCollapsed && this.state.customViewAlerts[i].alert_id != 0) {
            newDisplayedAlerts.push(this.state.customViewAlerts[i]);
          }
        }

        this.setState({separators: separators});
        this.setState({displayedAlerts: newDisplayedAlerts});

        if (!expanded)
          this.props.getAndShowDashboard();
      }

      handleRefreshBtn() {
        if (this.props.filterMode && this.props.filterMode == "no") {
          $('#matchingRows').text('');
          this.props.getCurrentAdhocFilters();
         }
        this.props.eraseCachedAlerts();
      }

      handleDropdownChange(event) {
        this.props.handleDisplayValueChange(event.target.value);
      }

      handleFilterMode(newMode) {
        console.log('handleFilterMode', newMode);
        if (newMode == 'no') {
            $('#matchingRows').text('');
        }
        this.props.handleFilterModeChange(newMode);
      }
     
      render() {
        var self = this;

        let adhocFilters = this.props.adhocFilters

        var profileId = this.props.profileId;
        var displayValues = this.props.displayValues;
        var drilldownTplNameProp = this.props.drilldownTplName;
        var alertNumbersLoading = this.props.alertNumbersLoading;

        var self = this
        let cachedAlerts = this.props.cachedAlerts;
        var notice = <tr className="omtTable" style={{display:'none' }}>Refresh Please</tr>

        var alertRows = this.state.displayedAlerts.map(function(alert, index) {

          // OMT/dashboard values depend on this input:
          var omtConditions = {
            profile:       profileId,
            alert:         alert.alert_id,
            adhoc:         adhocFilters,
            displayValues: displayValues
          }

          //explnation for below: omtConditions should not be referenced by cleanCondition !! 
          let cleanCondition = JSON.parse( JSON.stringify( omtConditions ) );

          // If we have adhocfilters that have no values selected, we remove them from the OMT Condition
          var i = cleanCondition.adhoc.length;
          while (i--) {
              if (cleanCondition.adhoc[i].values.length == 0) { 
                cleanCondition.adhoc.splice(i, 1);
              } 
          }
          var cleanConditionJSON = JSON.stringify(cleanCondition);
          //GEGA maybe we want to replace "Refresh" to be shown
          //notice = <tr className="omtTable">Refresh Please</tr>

          var drilldownTplName = drilldownTplNameProp[alert.alert_id];

          if (alert.alert_id == 0) {
            if (!alert.expanded) {
              var toggleStateIcon = "glyphicon glyphicon-chevron-up"
            } else {
              var toggleStateIcon = "glyphicon glyphicon-chevron-down"
            }

            if ( alert.expanded
              && self.state.displayedAlerts
              && (
                   (self.state.displayedAlerts[index+1] && self.state.displayedAlerts[index+1].alert_id == 0)
                || (!self.state.displayedAlerts[index+1])
              )
            )
              return  <tr value={alert.name} style={{backgroundColor: "#ddd"}}>
                        <td className="omtSeparatorCol" colspan="7" key={alert.name} style={{color: "#85929E", cursor: "default"}}>
                          {alert.name}
                          <i className={toggleStateIcon} style={{color:"#85929E", fontSize:"11px", paddingLeft:"5px"}} />
                        </td>
                      </tr>
            else
              return  <tr className="omtSeparatorRow" value={alert.name} onClick={e => self.handleToggleSeparator(e.currentTarget.innerText, alert.expanded)}>
                        <td className="omtSeparatorCol" colspan="7" key={alert.name} >
                          {alert.name}
                          <i className={toggleStateIcon} style={{color:"#555", fontSize:"11px", paddingLeft:"5px"}} />
                        </td>
                      </tr>
          }

          if (cachedAlerts[ cleanConditionJSON ] && alertNumbersLoading[cleanConditionJSON] == false ) {

            return (
              //Case when there are cached values and all alerts have been fetched and loaded
              <AlertRow key={'main'+alert.name} 
                        alertname={alert.name} 
                        alertid={alert.alert_id} 
                        drilldown={self.props.drilldown}
                        drilldownTplName={drilldownTplName} 
                        drilldownExportExcelReq={self.props.drilldownExportExcelReq}
                        drillDownStateChange={self.props.drillDownStateChange}
                        waiting={false} 
                        values={cachedAlerts[ cleanConditionJSON ]} 
                        omtConditions={omtConditions}
                        dashboardId={self.props.dashboardId}
                        caller={self.props.caller}
                        show={alert.show} />
            )

          } else if (!cachedAlerts[ cleanConditionJSON ] 
                  && alertNumbersLoading[cleanConditionJSON] == undefined) {

            return (
              //Case when we detect that a manual refresh is needed as no cached values are available and no alert is beeing fetched
              <AlertRow key={'main'+alert.name} 
                        alertname={alert.name} 
                        alertid={alert.alert_id} 
                        drilldown={self.props.drilldown}
                        drilldownTplName={drilldownTplName} 
                        drilldownExportExcelReq={self.props.drilldownExportExcelReq}
                        drillDownStateChange={self.props.drillDownStateChange}
                        refreshNeeded={true} 
                        dashboardId={self.props.dashboardId}
                        caller={self.props.caller}
                        show={alert.show} />
            )
          } else {

            return (
              //Case when there are no cached values but alerts are beeing fetched but still loading
              <AlertRow key={'main'+alert.name} 
                        alertname={alert.name} 
                        alertid={alert.alert_id} 
                        drilldown={self.props.drilldown}
                        drilldownTplName={drilldownTplName} 
                        drilldownExportExcelReq={self.props.drilldownExportExcelReq}
                        drillDownStateChange={self.props.drillDownStateChange}
                        waiting={true} 
                        values={[]} 
                        dashboardId={self.props.dashboardId}
                        caller={self.props.caller} 
                        show={alert.show} />
            )
          }

        });
        
        var filterMode = 'dynamic';
        var filterModeTitle = 'dynamic filter';
        var filterSpinningStyle = { 'marginLeft': '10px' }
        
        if (this.props.filterMode) {        
            filterMode = this.props.filterMode;
        }
        var filterModeIcon = "glyphicon glyphicon-transfer";
        var filterModeIconStyle = { color: '#fff' };
        if (filterMode == 'grey') {
            filterModeIcon = "glyphicon glyphicon-transfer";
            filterModeIconStyle = { color: '#ccc' };
            filterModeTitle = 'dynamic filter (grey out)';
        }
        if (filterMode == 'no') {
            filterModeIcon = "glyphicon glyphicon-pause";
            filterModeIconStyle = { color: '#fff' };
            filterModeTitle = 'no dynamic filter';
            filterSpinningStyle = { 'marginLeft': '10px', 'display':'none' }
        }       

        var valueOption = null;
        if (UserSettings.memberOf("ShowRestrictedFields")) {
            valueOption = <option value="dollar">value (dollar)</option>
        }

        var switchBtn = <i title="Switch View"
                           onClick={self.handleSwitchView}
                           className="glyphicon glyphicon-transfer"
                           style={{ margin: "0px 2px", verticalAlign: "middle",
                                    color: "#0096d6", cursor: "pointer" }} />

        return (
          <div>
            <div className="flex-container">
              <div className="flex-item">
                <button id='refreshButton' type="button" className="btn btn-danger" onClick={self.handleRefreshBtn}>Refresh</button>
                {
                  self.props.dashboardId && self.props.dashboardId != -1 ?
                    <>
                      <button id="customViewButton" type="button" className="btn btn-primary"
                              onClick={self.handleCustomViewBtn} title="Customize Dashboard View"
                              style={{marginLeft: "5px", borderRadius: "0px 0px 0px 5px"}}>
                        <i className="glyphicon glyphicon-cog" style={{marginTop: "2px"}}/>
                      </button>
                      <span style={{border: "1px solid #0096d6", borderRadius: "0px 5px 0px 0px", padding: "4px", verticalAlign: "middle"}}>
                        {
                          this.state.myCustomDashboardView.view && this.state.myCustomDashboardView.view == "C" ?
                            <span>custom view {switchBtn}</span>
                          : <span>standard view {this.state.isCustomized ? switchBtn : null}</span>
                        }
                      </span>
                    </>
                  : null
                }
              </div>
              <div className="flex-item">  
                <div className="btn-group pull-left" style={{'display':'inline', 'marginLeft':'2px', 'marginRight':'6px'}}>
                  <button className="btn btn-primary  dropdown-toggle" type="button" id="dynmode" title={filterModeTitle} data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                    <i className={filterModeIcon} style={filterModeIconStyle} />
                  </button>
                  <ul className="dropdown-menu" aria-labelledby="dynmode">
                      <li><a href="#" onClick={self.handleFilterMode.bind(null,'dynamic')}><i className="glyphicon glyphicon-transfer" /> dynamic filter</a></li>
                      <li><a href="#" onClick={self.handleFilterMode.bind(null,'grey')}   ><i className="glyphicon glyphicon-transfer" style={{'color':'#999'}} /> dynamic filter (grey out)</a></li>
                      <li><a href="#" onClick={self.handleFilterMode.bind(null,'no')}     ><i className="glyphicon glyphicon-pause"    /> no dynamic filter</a></li>
                  </ul>                   
                </div>  
                <span id='matchingRows' style={{'marginLeft':'2px', 'marginTop':'4px', 'display': 'inline-block'}}>
                </span>
                <img id='spinning_nested' src={spinning_small} 
                    style={filterSpinningStyle}
                    height="12" width="12"/>
              </div>
              <div className="flex-item">
                <div className="btn-group">
                  <select className="form-control" defaultValue={this.props.displayValues} onChange={this.handleDropdownChange}>
                    <option value="items">number of items</option>
                    <option value="orders">number of orders</option>
                    <option value="sumqty">sum of ordered qty</option>
                    {valueOption}
                  </select>
                </div>
                <div className="bmtHint pull-right">
                  <span className="ico-info glyphicon glyphicon-info-sign"></span>
                  <span className="info-tooltip">Click on the dashboard or chart numbers to display more data</span>
                </div>
              </div>
            </div>
            <div id="bmt-results">
              <table className="table">
                <thead>
                  <tr>
                    <th>Alert/Bucket</th>
                    { self.props.caller == "salesConsole" 
                      ? <th colSpan="5">traffic light</th> 
                      : <th colSpan="3">traffic light</th>
                    }
                    <th>total</th>
                  </tr>
                </thead>
                <tbody>
                  {notice}
                  {alertRows}
                </tbody>
              </table>
            </div>
            {
              this.state.showCustomViewEditor ?
                <AdvancedListCustomizer
                  title="Customize Dashboard View"
                  subtitle={this.state.customViewEditorSubtitle}
                  selectedList={this.state.myCustomDashboardView.alerts}
                  standardList={this.props.alertList}
                  onSave={this.handleCustomViewSave}
                  onCancel={this.handleCustomViewCancel} />
              : null
            }
          </div>
        )
      }
    };

    //------------------------------------------------------------------------
    //  DateFilterBox
    //
    //------------------------------------------------------------------------
    class DateFilterBox extends React.PureComponent {

      constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.handleFocus = this.handleFocus.bind(this);
      }      

      split( val ) {
        return val.split( /,\s*/ );
      }
    
      handleChange() {

        var mode  = $('#'+this.props.id+'_mode').val();
        var date1 = $('#'+this.props.id+'_date1').val();
        var date2 = $('#'+this.props.id+'_date2').val();

        var a = '';
        var b = '';
        if (mode =="yesterday") {
            a = moment().startOf('day').subtract(1, 'day').format('YYYY-MM-DD');
            b = a;
        } else
        if (mode =="today") {
            a =  moment().startOf('day').format('YYYY-MM-DD');
            b = a;
        } else
        if (mode =="tomorrow") {
            a =  moment().startOf('day').add(1, 'day').format('YYYY-MM-DD');              
            b = a;
        } else
        if (mode =="lastWeek") {
            a = moment().startOf('week').subtract(1, 'week').format('YYYY-MM-DD');
            b = moment().startOf('week').subtract(0, 'week').subtract(1, 'day').format('YYYY-MM-DD');
        } else
        if (mode =="currentWeek") {
            a = moment().startOf('week').subtract(0, 'week').format('YYYY-MM-DD');
            b = moment().startOf('week').add(1, 'week').subtract(1, 'day').format('YYYY-MM-DD');
        } else
        if (mode =="nextWeek") {
            a = moment().startOf('week').add(1, 'week').format('YYYY-MM-DD');
            b = moment().startOf('week').add(2, 'week').subtract(1, 'day').format('YYYY-MM-DD');
        } else
        if (mode =="lastMonth") {
            a = moment().startOf('month').subtract(1, 'month').format('YYYY-MM-DD');
            b = moment().startOf('month').subtract(1, 'day').format('YYYY-MM-DD');
        } else
        if (mode =="currentMonth") {
            a = moment().startOf('month').format('YYYY-MM-DD');
            b = moment().startOf('month').add(1, 'month').subtract(1, 'day').format('YYYY-MM-DD');
        } else
        if (mode =="nextMonth") {
            a = moment().startOf('month').add(1, 'month').format('YYYY-MM-DD');
            b = moment().startOf('month').add(2, 'month').subtract(1, 'day').format('YYYY-MM-DD');
        }


        if (mode !='custom') {
            $('#'+this.props.id+'_date1').val(a);
            $('#'+this.props.id+'_date2').val(b);
        }

        console.log('DateFilterBox.handleChange:', mode, date1, date2);
        
        if (mode == "custom") {
            $('#'+this.props.id+'_date1').css("color","#000000");
            $('#'+this.props.id+'_date2').css("color","#000000");
        } else {
            $('#'+this.props.id+'_date1').css("color","#cccccc");
            $('#'+this.props.id+'_date2').css("color","#cccccc");
        }
        
        if (this.props.onChange) {
            this.props.onChange( mode, date1, date2 );
        }                                             
      }
  
      handleFocus() {
          console.log('DateFilterBox.handleFocus:');
          $('#'+this.props.id+"_mode").val('custom');
          //$('#'+this.props.id+"_mode option[value='custom']").attr("selected", true);
          this.handleChange();          
      }

      componentDidMount() {
          console.log('DateFilterBox this.props.values:', this.props.id, this.props.values);
          if (this.props.values) {   
              console.log(this.props.id, 'this.props.values:', typeof  this.props.values, this.props.values);
              if ( (typeof  this.props.values == "string")                                                   
                   &&                                     
                   this.props.values.match(/^##date/)
              ) {                                    
                  // format: '##date:2017-06-04:2017-06-22:mode'
                  var ranges = this.props.values.substr(7).split(':');
                  console.log(ranges);
                  if (ranges[2] == undefined || ranges[2] == "undefined") {
                      ranges[2] = 'lastMonth';
                  }
                  $('#'+this.props.id+"_mode").val(  ranges[2] );     
                  $('#'+this.props.id+"_date1").val( ranges[0] );
                  $('#'+this.props.id+"_date2").val( ranges[1] );
              }                                                  
          }          
          this.handleChange();
      }
          
      render() {
      
          var self = this;
          var id = this.props.id;
          
          return (
               <div>
                    <select id={id+'_mode'}
                       onChange={self.handleChange}
                       style={{
                           "width":"100%",
                           "border":"solid 1px #d8d8d8"
                       }}
                    >
                        <option value="yesterday">yesterday</option>
                        <option value="today">today</option>
                        <option value="tomorrow">tomorrow</option>
                        <option value="lastWeek">last week</option>
                        <option value="currentWeek">current week</option>
                        <option value="nextWeek">next week</option>
                        <option value="lastMonth">last month</option>
                        <option value="currentMonth">current month</option>
                        <option value="nextMonth">next month</option>
                        <option value="custom">custom range</option>
                    </select>
                    <br/>
                    <br/>
                    from:
                    <br/>
                    <DateChooser id={id+'_date1'} dateValue="" placeholder="" 
                                 onChange={self.handleChange}
                                 onFocus={self.handleFocus}
                                 style={{"display":"inline", "width":"98%", "fontSize":"11px", "padding":"3px", "height":"21px"  }}/>
                    <br/>
                    to:
                    <br/>
                    <DateChooser id={id+'_date2'} dateValue="" placeholder="" 
                                 onChange={self.handleChange}
                                 onFocus={self.handleFocus}
                                 style={{"display":"inline", "width":"98%", "fontSize":"11px", "padding":"3px", "height":"21px"  }}/>
               </div>                                      
          )    
      }
    };


    //------------------------------------------------------------------------
    //  AdhocFilters
    //
    //------------------------------------------------------------------------
    export class AdhocFilters extends React.PureComponent {

      constructor(props) {
        super(props);
        this.state = {
          adhocPasteBanners: {},  // { [afilter.name]: { totalCount, kept, dropped, timerId } }
        };
        this.handleStartAddingAdhoc = this.handleStartAddingAdhoc.bind(this);
        this.handleAddingAdhoc = this.handleAddingAdhoc.bind(this);
        this.handleCollapse= this.handleCollapse.bind(this);
        this.showPasteBanner = this.showPasteBanner.bind(this);
        this.handleStringPaste = this.handleStringPaste.bind(this);
      }

      componentWillUnmount() {
        const banners = this.state.adhocPasteBanners;
        Object.keys(banners).forEach(name => {
          if (banners[name] && banners[name].timerId) {
            clearTimeout(banners[name].timerId);
          }
        });
      }

      showPasteBanner(name, totalCount, kept, dropped) {
        const prev = this.state.adhocPasteBanners[name];
        if (prev && prev.timerId) clearTimeout(prev.timerId);
        const timerId = setTimeout(() => {
          this.setState(s => {
            const next = Object.assign({}, s.adhocPasteBanners);
            delete next[name];
            return { adhocPasteBanners: next };
          });
        }, 8000);
        this.setState(s => ({
          adhocPasteBanners: Object.assign({}, s.adhocPasteBanners, {
            [name]: { totalCount, kept, dropped, timerId },
          }),
        }));
      }

      handleStringPaste(filterName, event) {
        event.preventDefault();
        const pasted   = (event.clipboardData || window.clipboardData).getData('text');
        const target   = event.target;
        const existing = target.value;
        const selStart = target.selectionStart != null ? target.selectionStart : existing.length;
        const selEnd   = target.selectionEnd   != null ? target.selectionEnd   : existing.length;
        const merged   = existing.slice(0, selStart) + pasted + existing.slice(selEnd);
        const r = dedupAndCapValues(merged, ADHOC_STRING_MAX_VALUES);
        target.value = r.text;
        if (r.dropped > 0) {
          this.showPasteBanner(filterName, r.totalCount, r.kept, r.dropped);
        }
      }

      handleCollapse(e, filter) {
        this.props.handleCollapse(e, filter);
      }

      handleDeleteAdhocFilter(position) {
        console.log('delete adhoc', position);
        this.props.adhocFilterRemove(position);
        //this.props.onChange();
      }

      handleAddingAdhoc() {
        let adhocFilterAdd = this.props.adhocFilterAdd;
        let onChange       = this.props.onChange;

        let omtFields      = this.props.omtFields;
        let omtFields2int  = this.props.omtFields2int;
        let adhocFilters   = this.props.adhocFilters;

        $("#addAdhoc").tokenInput(
          omtFields,
          {
            hintText: "Start typing to find fields...",
            noResultsText: "nothing found",
            searchingText: "searching...",
            propertyToSearch: "name",
            makeSortable: "yes",
            tokenQuote: "",
            zindex: 9999,
            onAdd: function(item) {
              console.log('onAdd',item);

              var internalFieldName = item.id;
              var internalType = 'enum';  
              if (omtFields2int[ item.id]) {
                internalFieldName = omtFields2int[ item.id ].internalField;
                internalType      = omtFields2int[ item.id ].type;
              }
              var alreadyExists = false;
              adhocFilters.forEach( function(ae) {
                  if (ae.name == item.id) {
                      alreadyExists = true;
                  }
              });
              if (alreadyExists) {
                alert('\n\nAlready available !\n\n');
              } else {
                adhocFilterAdd({ name: item.id, internal: internalFieldName, values: [], type: internalType});
                //onChange();
              }  
              $("#addAdhoc").tokenInput('clear');
              $('#addAdhocCell').hide();
              $('.token-input-dropdown').hide();
            }
          }
        );
      }

      handleStartAddingAdhoc() {
        console.log('handleStartAddingAdhoc...');
        $('#addAdhocCell').show();
        $("#token-input-addAdhoc").focus();
        this.handleAddingAdhoc();
      }

      adhocHeaders() {
        return this.props.adhocFilters.map((afilter, i) => (
          <td key={afilter.name + "_hdr"} className="sliceHeader">
                          <a onClick={this.handleDeleteAdhocFilter.bind(this,i)} className="deleteIcon">
                            <i className="glyphicon glyphicon-remove" style={{"cursor": "pointer"}}></i>&nbsp;&nbsp;
                          </a>
                          {afilter.name}
                        </td>
        )) 
      }

      render() {

        //console.log("BMT_DEBUG AdhocFilters render");
        var caller    = this.props.caller
        var self = this;
        if (this.props.adhocFilters) {

            //callback functions
            let onChange            = this.props.onChange;

            //real props
            let omtFields2int       = this.props.omtFields2int;
            let cacheAdhocVals      = this.props.cacheAdhocVals;
            let cacheLoadingStatus  = this.props.cacheLoading;
            let repaint             = this.props.repaint;

            let loadedOMTVal = {};

            var adhocFiltersCollapsed = this.props.adhocFiltersCollapsed;
            var minimized = false;
            var minimizedFilters = [];
            var values = this.props.adhocFilters.map( function(afilter) {

              //console.log('adhoc filter:', afilter);

              if (caller == "salesConsole") {
                for (var i = 0; i < adhocFiltersCollapsed.length; i++) {
                  if (afilter.internal == adhocFiltersCollapsed[i].internal) {
                    minimized = adhocFiltersCollapsed[i].minimized
                    minimizedFilters.push({minimized:minimized});
                  }
                }
              }

              // if field isn't known anymore, ignore it
              if (!omtFields2int[ afilter.name ]) return;
              
              if (omtFields2int[ afilter.name ].type == 'date') {
                          
                if (minimized) {
                  return (
                    <ReadOnlyTextAreaBox afilter={afilter}/>
                  )
                }
                return (
                  <div className="sliceValue" key={'adhoc_val_td_'+afilter.name} >
                    <div style={{                                      
                        "width":"100%",
                        "height":"156px", 
                        "backgroundColor":"#fafafa",
                        "padding":"6px 3px", 
                        "color":"#777777",   
                        "boxShadow": "1px 1px 5px #888888"
                    }} key={'adhoc_val_div_'+afilter.name}>                                    
                      <DateFilterBox id={'adhoc_val_'+afilter.name} fldname={afilter.name} values={afilter.values} onChange={onChange} />
                    </div>  
                  </div>
                )
              }
              if (omtFields2int[ afilter.name ].type == 'bool') {
                
                if (!cacheAdhocVals[ afilter.name ] || (cacheAdhocVals[ afilter.name ] && cacheAdhocVals[ afilter.name ].length == 0)) {

                    var yesno = [
                        { name: 'Y', disabled: false, selected: false },
                        { name: 'N', disabled: false, selected: false },
                    ];

                    if (minimized) {
                      return (
                        <ReadOnlyTextAreaBox afilter={afilter}/>
                      )
                    }

                    return (
                      <div key={afilter.name} className="sliceValue" >
                            <SearchableMultiSelectBox id={'adhoc_val_'+afilter.name} 
                                                      onChange={onChange} 
                                                      values={yesno} 
                                                      repaint={repaint} />                            
                      </div>
                    )

                }

                if (minimized) {
                  return (
                    <ReadOnlyTextAreaBox afilter={afilter}/>
                  )
                }
                
                return (
                  <div key={afilter.name} className="sliceValue" >
                        <SearchableMultiSelectBox id={'adhoc_val_'+afilter.name} 
                                                  single="1"
                                                  onChange={onChange} 
                                                  values={cacheAdhocVals[ afilter.name ]} 
                                                  repaint={repaint} />
                  </div>
                )
              }
              if (omtFields2int[ afilter.name ].type == 'string') {

                if (minimized) {
                  return (
                    <ReadOnlyTextAreaBox afilter={afilter}/>
                  )
                }

                var banner = self.state.adhocPasteBanners[afilter.name];

                return (
                  <div key={afilter.name} className="sliceValue" >
                    <div className='lbjs' style={{ 'height': '156px'}}>
                    <select style={{ 'borderColor': '#eee', 'margin':'2px', 'minWidth':'120px'}} id={'adhoc_val_strcmp_'+afilter.name}>
                      <option>in</option>
                      <option>contains</option>
                      <option>starts with</option>
                      <option>not in</option>
                      <option>not contains</option>
                      <option>not starts with</option>
                      <option>is &lt;blank&gt;</option>
                      <option>is not &lt;blank&gt;</option>
                    </select>
                    <br/>
                    {banner && (
                      <div className="adhoc-paste-banner" style={{
                        fontSize: '11px', color: '#a06000', background: '#fff8e6',
                        border: '1px solid #f0d590', padding: '2px 6px', margin: '2px 3px 0 3px',
                        borderRadius: '2px'
                      }}>
                        Pasted {banner.totalCount} lines · kept {banner.kept} unique · dropped {banner.dropped}
                      </div>
                    )}
                    <textarea type='text' placeholder='enter text / or multiple lines...'
                      id={'adhoc_val_strval_'+afilter.name}
                      onPaste={(e) => self.handleStringPaste(afilter.name, e)}
                      style={{ 'width':'95%', 'border': '1px solid #f0f0f0', 'margin':'0px 3px 0px 3px', 'height':'130px', 'padding': '1px', 'paddingLeft': '2px'}}
                    />
                    </div>
                  </div>
                )
              }
              if (omtFields2int[ afilter.name ].type === 'int') {

                if (minimized) {
                  return (
                    <ReadOnlyTextAreaBox afilter={afilter}/>
                  )
                }

                return (
                  <div key={afilter.name} className="sliceValue" >
                    <div className='lbjs' style={{ 'height': '156px'}}>
                    <select style={{ 'borderColor': '#eee', 'margin':'2px', 'minWidth':'120px'}} id={'adhoc_val_strcmp_'+afilter.name}>
                      <option value="">Select</option>
                      <option value="=">=</option>
                      <option value=">">&gt;</option>
                      <option value="<">&lt;</option>
                      <option selected value=">=">&gt;=</option>
                      <option value="<=">&lt;=</option>
                    </select>
                    <br/>
                    <textarea type='text' placeholder='Enter value' 
                      id={'adhoc_val_strval_'+afilter.name}
                      style={{ 'width':'95%', 'border': '1px solid #f0f0f0', 'margin':'0px 3px 0px 3px', 'height':'130px', 'padding': '1px', 'paddingLeft': '2px'}}
                    />
                    </div>
                  </div>
                )
              }
              if (omtFields2int[ afilter.name ].type === 'double') {

                if (minimized) {
                  return (
                    <ReadOnlyTextAreaBox afilter={afilter}/>
                  )
                }

                return (
                  <div key={afilter.name} className="sliceValue" >
                    <div className='lbjs' style={{ 'height': '156px'}}>
                    <select style={{ 'borderColor': '#eee', 'margin':'2px', 'minWidth':'120px'}} id={'adhoc_val_strcmp_'+afilter.name}>
                      <option value="">Select</option>
                      <option value="=">=</option>
                      <option selected value=">">&gt;</option>
                      <option value="<">&lt;</option>
                    </select>
                    <br/>
                    <textarea type='text' placeholder='Enter value' 
                      id={'adhoc_val_strval_'+afilter.name}
                      style={{ 'width':'95%', 'border': '1px solid #f0f0f0', 'margin':'0px 3px 0px 3px', 'height':'130px', 'padding': '1px', 'paddingLeft': '2px'}}
                    />
                    </div>
                  </div>
                )
              }
              if (omtFields2int[ afilter.name ].type != 'enum') {

                if (minimized) {
                  return (
                    <ReadOnlyTextAreaBox afilter={afilter}/>
                  )
                }

                return (
                  <div key={afilter.name} className="sliceValue" >
                    ... { omtFields2int[ afilter.name ].type } ...
                  </div>
                )            
              }
              if (cacheAdhocVals[ afilter.name ]) {

                if (minimized) {
                  return (
                    <ReadOnlyTextAreaBox afilter={afilter}/>
                  )
                }
               
                return (
                      <div key={afilter.name} className="sliceValue" >
                        <SearchableMultiSelectBox id={'adhoc_val_'+afilter.name} 
                                                  onChange={onChange} 
                                                  values={cacheAdhocVals[ afilter.name ]} 
                                                  repaint={repaint} />
                      </div>
                )
              } else {

                var loadingList = [ { name: "loading...", selected: false, disabled: true } ];
                return (
                      <div key={afilter.name} className="sliceValue">
                        <SearchableMultiSelectBox id={'adhoc_val_'+afilter.name} 
                                                  values={loadingList} 
                                                  repaint={repaint} />
                      </div>
                    )
              }
            });    
        }
                  
        // for classical bmt use flex nowrap
        var flexAlign = "";
        if (caller == "salesConsole") {
          flexAlign = "-vert"
        }

        return (
          <div className="adhoc-filters" id="sbLight" style={{ marginTop: "-6px" }}>
          <ul className={`flex-container${flexAlign}`}>
            {this.props.adhocFilters.map((afilter, i) => {

              if (minimizedFilters.length == 0) {
                var showCollapseIcon = null;
              } else {
                if (minimizedFilters[i].minimized) {
                  var icon = "glyphicon glyphicon-chevron-down";
                } else {
                  var icon = "glyphicon glyphicon-chevron-up";
                }
                var showCollapseIcon = <a onClick={e => this.handleCollapse(e, afilter)} className="deleteIcon">
                                        <i className={icon} style={{"float":"right", "cursor": "pointer"}}></i>&nbsp;&nbsp;
                                      </a>
              }

              return (
                <li className="flex-item" key={i}>
                  <div className="adhocFilterElement">
                    <div className="sliceHeader">
                      <a onClick={this.handleDeleteAdhocFilter.bind(this,i)} className="deleteIcon">
                        <i className="glyphicon glyphicon-remove" style={{"cursor": "pointer"}}></i>&nbsp;&nbsp;
                      </a>
                      {afilter.name}
                      {showCollapseIcon}
                    </div>
                    {values[i]}
                  </div>
                </li>
              )
            })}
            <li>
              <i className="glyphicon glyphicon-plus" onClick={this.handleStartAddingAdhoc} style={{"paddingTop":"5px", "color": "#0096d6", "cursor": "pointer"}}></i>
              <span style={{ marginLeft: "5px", color: "#777", fontSize: "12px" }} >add another filter</span>
              <button className="btn btn-primary"
                      title="Reset selection of all filters"
                      style={{ fontSize: '11px', float: 'right', margin: '2px 9px 0 0', fontWeight: '500', padding: '2px 10px' }}
                      onClick={this.props.clearAdhocFilters}
                      disabled={`${this.props.adhocFilters && this.props.adhocFilters.length > 0 ? '' : 'disabled'}`}
              >Reset</button>
              <div id='addAdhocCell' style={{ 'display': 'none', 'verticalAlign' :'top', 'minWidth': '130px'}}>
                <input type='text' id='addAdhoc' size="14"/>
              </div>
              <div id='toggleAll' className="flex-container-adhoc-operations">
                <button className='iconButton' 
                        title='minimize all filter boxes'
                        onClick={e => this.handleCollapse(e, "minimizeAll")} 
                        style={{ cursor: "pointer" }}
                ><CollapseAllIcon/></button>
                <button className='iconButton' 
                        title='maximize all filter boxes'  
                        onClick={e => this.handleCollapse(e, "maximizeAll")} 
                        style={{ cursor: "pointer" }}
                ><ExpandAllIcon/></button>
              </div>
            </li>
          </ul>
          </div>
        )

        return (
          <div className="col-md-12" style={{ "marginTop": "3px" }}>
          <table>
          <tbody>
            <tr>
              <td>Adhoc filter:</td>
            </tr>
            <tr>
              {this.adhocHeaders()}
              <td>
                <i className="glyphicon glyphicon-plus" onClick={this.handleStartAddingAdhoc} style={{"color": "#0096d6", "cursor": "pointer"}}></i>
              </td>
            </tr>
            <tr>
              {values}
              <td id='addAdhocCell' style={{ 'display': 'none', 'verticalAlign' :'top', 'minWidth': '170px'}} >
                add field:
                <input type='text' id='addAdhoc' size="14"/>
              </td>
            </tr>
          </tbody>
          </table>
          <br/>
          </div>
        )
    
      }
    };

    //------------------------------------------------------------------------
    //  MyOrders
    //
    //------------------------------------------------------------------------
    class MyOrders extends React.PureComponent {

      constructor(props) {
        super(props);
        this.selectProfile    = this.selectProfile.bind(this);
        this.selectDashboard  = this.selectDashboard.bind(this);
      }      

      selectProfile(i, name) {
        console.log("BMT_DEBUG selectProfile " + name + " (" + i + ")");
        this.props.updateRecentProfile(i, name);
      }

      selectDashboard(i, name) {
        console.log("BMT_DEBUG selectDashboard " + name + " (" + i + ")");
        var value_FakeEvent = {target : {value:i, selectedOptions : [{text:name}]}};
        this.props.handleDashboardChange(value_FakeEvent);
      }

      handleOtherProfile() {
        $('#profileListModal').modal( { backdrop: 'static'} );
      }

      render() {

        var self = this;
        if (this.props.recentlyUsed) {
          var recentlyUsed = this.props.recentlyUsed.map(function(pro) {

            return <li key={pro.id}><a style={{ "cursor": "pointer" }} onClick={self.selectProfile.bind(null,pro.id,pro.name)}>{pro.name}</a></li>
          });
        }

        if (this.props.recentlyUsedDashboards) {
          var recentlyUsedDashboards = this.props.recentlyUsedDashboards.map(function(pro) {

            return <li key={pro.id}><a style={{ "cursor": "pointer" }} onClick={self.selectDashboard.bind(null,pro.id,pro.name)}>{pro.name}</a></li>
          });
        }

        if (this.props.myFavourites) {
          var myFavourites = this.props.myFavourites.map(function(pro) {

            return <li key={pro.id}><a style={{ "cursor": "pointer" }} onClick={self.selectProfile.bind(null,pro.id,pro.name)}>{pro.name}</a></li>
          });
        }

        var profile_rule_descr = ""
        if (this.props.availableProfiles) {
          this.props.availableProfiles.map(function(elem) {
            if (elem.name == self.props.profileName) {
              if (elem.rule_descr == null || elem.rule_descr == "") {
                elem.rule_descr = "no description available"
              }
              profile_rule_descr = elem.rule_descr + "%0A%0A" + "Profile Rule:" + "%0A" + elem.rule;
            }
          });
        }

        /* List of all my_orders_* profile selections (need to be part of bm_alert_profile)
        All Names                 -100 (combination of all other my_orders profiles)
        CSR                       -101 (csr_fullname            icontains '<MYEMAILADDR>')
        BO CSR                    -102 (bo_csr                  icontains '<MYEMAILADDR>') --> deprecated
        Factory Coordinator       -103 (factory_coord           icontains '<MYEMAILADDR>')
        AOM                       -104 (aom                     icontains '<MYEMAILADDR>')
        AOM Manager               -105 (aom_manager             icontains '<MYEMAILADDR>')
        Sales Support             -106 (sales_support_email     icontains '<MYEMAILADDR>')
        Escalation Manager        -107 (escalation_manager      icontains '<MYEMAILADDR>')
        Escalation Requester      -108 (escalation_requester    icontains '<MYEMAILADDR>')
        Escalation Approver       -109 (escalation_approver     icontains '<MYEMAILADDR>')
        Escalation Rejecter       -110 (escalation_rejecter     icontains '<MYEMAILADDR>')
        Work Note Participant     -111 (worknote_participants   icontains '<MYEMAILADDR>')
        Order Desk Agent          -112 (odesk_agent_id          icontains '<MYEMAILADDR>')
        Planner Execution         -113 (planner_exec_emails     icontains '<MYEMAILADDR>')
        Planner Execution Manager -114 (planner_exec_mgr_emails icontains '<MYEMAILADDR>')
        Sales                     -115 (telew_agent_id          icontains '<MYEMAILADDR>')
        OM Personal Email         -116 (om_contact_person_email icontains '<MYEMAILADDR>')
        OM Team Email             -117 (om_contact_team_email   icontains '<MYEMAILADDR>')
        */

        return (
                <div id="MyOrders" className="btn-group">
                  <a className="btn btn-danger dropdown-toggle" data-toggle="dropdown" href="#">
                     <span className="title">my orders:</span>
                     <span title={decodeURI(profile_rule_descr)} className="option">{this.props.profileName}</span>
                     <span className="caret"></span>
                  </a>
                  <ul className="dropdown-menu">

                     <li className="dropdown-submenu">
                         <a tabIndex="-1" href="#">orders with my name</a>
                         <ul className="dropdown-menu">
                           <li key='All Names'><a style={{ "cursor": "pointer" }} onClick={this.selectProfile.bind(null,-100,'All Names')}>All Names</a></li>
                           <li key='CSR/COS'><a style={{ "cursor": "pointer" }} onClick={this.selectProfile.bind(null,-101,'CSR/COS')}>CSR/COS</a></li>
                           <li key='AOM'><a style={{ "cursor": "pointer" }} onClick={this.selectProfile.bind(null,-104,'AOM')}>AOM</a></li>
                           <li key='Sales Manager'><a style={{ "cursor": "pointer" }} onClick={this.selectProfile.bind(null,-103,'Sales Manager')}>Sales Manager</a></li>
                           <li key='eBiz Consultant'><a style={{ "cursor": "pointer" }} onClick={this.selectProfile.bind(null,-105,'eBiz Consultant')}>eBiz Consultant</a></li>
                           <li key='Planner Execution'><a style={{ "cursor": "pointer" }} onClick={this.selectProfile.bind(null,-113,'Planner Execution')}>Planner Execution</a></li>
                           <li key='Planner Execution Manager'><a style={{ "cursor": "pointer" }} onClick={this.selectProfile.bind(null,-114,'Planner Execution Manager')}>Planner Execution Manager</a></li>
                           <li key='Catalog Manager'><a style={{ "cursor": "pointer" }} onClick={this.selectProfile.bind(null,-106,'Catalog Manager')}>Catalog Manager</a></li>
                           <li key='Sales'><a style={{ "cursor": "pointer" }} onClick={this.selectProfile.bind(null,-115,'Sales')}>Sales</a></li>
                           <li key='Work Note Participant'><a style={{ "cursor": "pointer" }} onClick={this.selectProfile.bind(null,-111,'Work Note Participant')}>Work Note Participant</a></li>
                         </ul>
                     </li>
                     <li className='divider'></li>
                     <li className="disabled"><a href='#'>Recent Profiles:</a> </li>
                     {recentlyUsed}
                     <li className='divider'></li>
                     <li className="disabled"><a href='#'>Recent Dashboards:</a> </li>
                     {recentlyUsedDashboards}
                     <li className='divider'></li>
                     <li className="disabled"><a href='#'>My favourites:</a> </li>
                     {myFavourites}
                     <li className='divider'></li>
                     <MyFavouriteProfilesButton availableProfiles={this.props.availableProfiles} myFavourites={this.props.myFavourites}/>
                     <li><a style={{ "cursor": "pointer" }} onClick={this.handleOtherProfile}>select/search other profile</a></li>
                  </ul>

                </div>
        )
      }
    };


    //------------------------------------------------------------------------
    //  MyFavouriteProfilesButton
    //
    //------------------------------------------------------------------------
    class MyFavouriteProfilesButton extends React.PureComponent {

      constructor(props) {
        super(props);
        this.handleMyFavouriteProfiles = this.handleMyFavouriteProfiles.bind(this);
      }   

      handleMyFavouriteProfiles() {

        $("#profileAlertDashboardAlertList").tokenInput(
          this.props.availableProfiles, {
            hintText: "Start typing to find profiles ...",
            noResultsText: "nothing found",
            searchingText: "searching...",
            propertyToSearch: "name",
            makeSortable: "yes",
            zindex: 109999,
            prePopulate: this.props.myFavourites,
            tokenLimit: 10,
            minChars: 2
         }
        ); 

        console.log("handleMyFavouriteProfiles");
          $("#profileAlertDashboardAlertList").focus();
          $('#ossMyFavouriteProfileModal').modal( { backdrop: 'static'} );

      }
      render() {
       
        return (
          <li><a style={{ "cursor": "pointer" }} onClick={this.handleMyFavouriteProfiles}>manage my favourites</a> </li>
        );
      }
    };

    //------------------------------------------------------------------------
    //  SelectedDashboard
    //
    //------------------------------------------------------------------------
    export class SelectedDashboard extends React.PureComponent {

      constructor(props) {
        super(props);
      };

      render() {

        var EditLink = null;  
        let alertDashboards = this.props.alertDashboards;

        if (this.props.dashboardId == -1) {
          // for my personal dashboard show Edit button
          EditLink = <button type="button" onClick={this.props.handleMyPersonalDashboard} className="btn btn-info btn-sm"><i className="glyphicon glyphicon-cog"/></button>
        }

        if (!alertDashboards) {
          alertDashboards = [];
        }
        var dashboardNames = alertDashboards.sort( function(a,b) {
            if (a.dashboard_name > b.dashboard_name) return 1;
            if (a.dashboard_name < b.dashboard_name) return -1;
            return 0;
        }).map(function(dashboard) {
            return (
              <option key={dashboard.dashboard_id} value={dashboard.dashboard_id}>
                {dashboard.dashboard_name}
              </option>
            );
        });

        dashboardNames.push(
           <option key="-1" value="-1">my personal dashboard</option>
        );

        // for classical bmt use horizontal flex 
        var flexType = "flex-container"
        if (this.props.caller == "salesConsole") {
          flexType = "flex-container-vert"
        }

        return (
          <ul className={flexType}>
            <li className="flex-item" style={{ "display": "inline-flex"}}>
              <select className="form-control" style={{ minWidth: "185px", padding: "3px", fontSize: "13px"}}
                          value={this.props.dashboardId} onChange={this.props.handleDashboardChange}
                      >{dashboardNames}
              </select>
              {EditLink}
            </li>
            <li className="flex-item">
              <MyOrders updateRecentProfile={this.props.updateRecentProfile}
                        handleDashboardChange={this.props.handleDashboardChange}
                        recentlyUsed={this.props.recentlyUsed}
                        recentlyUsedDashboards={this.props.recentlyUsedDashboards}
                        profileName={this.props.profileName}
                        availableProfiles= {this.props.availableProfiles}
                        myFavourites={this.props.myFavourites}/>
            </li>
          </ul>
        )
        return (
            <table style={{ "marginTop": "8px", "width": "100%" }}>
              <tbody>
                <tr>
                 <td style={{ "width": "10%", "whiteSpace" : "nowrap" }}>Dashboard: &nbsp; </td>
                 <td style={{ "align": "left", "width": "50%", "whiteSpace" : "nowrap" }}>
                     <select className="form-control" style={{ "minWidth": "185px"}}
                        value={this.props.dashboardId} onChange={this.props.handleDashboardChange}
                     >{dashboardNames}</select>
                 </td>
                 <td style={{ "padding": "0px 10px 0px 4px"}}>{EditLink}</td>
                 <td>
                  <MyOrders updateRecentProfile={this.props.updateRecentProfile}
                            recentlyUsed={this.props.recentlyUsed}
                            profileName={this.props.profileName}
                            availableProfiles= {this.props.availableProfiles}
                            myFavourites={this.props.myFavourites}/>
                 </td>
               </tr>
             </tbody>
           </table>
        )
      }
    };

window.SetWatched = function(e, elem, os) {
  e.preventDefault();
  e.stopPropagation()
  var watchStatus = "off"
  if (elem.className.baseVal == "noti_icon_off") watchStatus = "on";

  var xhttp = new XMLHttpRequest();
  xhttp.onreadystatechange = function() {
      if (this.readyState == 4 && this.status == 200) {
          elem.className.baseVal = 'noti_icon_'+watchStatus
      }
  };
  xhttp.open("POST",   "/os/ws/osvHelper.tcl?type=ajax&watched="+watchStatus+"&os_no="+os, true);
  xhttp.send();      
};

window.SetPinned = function (e, elem, os) {
  e.preventDefault();
  e.stopPropagation()
  // console.log('SetPinned', os, elem.className);
  var pinnedStatus = "off"
  if (elem.className.baseVal == "pinned_icon_off") pinnedStatus = "on";

  var xhttp = new XMLHttpRequest();
  xhttp.onreadystatechange = function() {
      if (this.readyState == 4 && this.status == 200) {
          elem.className.baseVal = 'pinned_icon_'+pinnedStatus
      }
  };
  xhttp.open("POST",   "/os/ws/osvHelper.tcl?type=ajax&pinned="+pinnedStatus+"&os_no="+os, true);
  xhttp.send();      
};

window.HandleShowNotes = function(e, legacy_order_no ) {
  console.log('standalone handleShowNotes:',legacy_order_no, e);
  e.preventDefault();
  e.stopPropagation();
  OrderNotes_Open(legacy_order_no);
  return true;
};

window.HandleShowSandy = function(e, legacy_order_no, order_no ) {
  console.log('standalone handleShowSandy:',legacy_order_no, e);
  e.preventDefault();
  e.stopPropagation();
  var LegacyIntURL = UserSettings.config.links.LegacyIntURL;
  var sandyUrl = LegacyIntURL+"?o="+legacy_order_no+"&os_no="+order_no;        
  window.open(sandyUrl, "_blank");
  return true;
};


window.ShowPunchMenu = function(ev, order_no, legacy_order_no, type) {
    ClosePunchMenu(ev)
    var p = byId('PrefMenu');
    var brect = p.getBoundingClientRect();

    if (  ev.clientX >= Math.floor(brect.left) && ev.clientX <= Math.floor(brect.left + brect.width)
       && ev.clientY >= Math.floor(brect.top ) && ev.clientY <= Math.floor(brect.top  + brect.height)
    ) {

       return;
      }

    if (type == "ai" && UserSettings.config?.GenAICfg?.prompts?.hdr && Array.isArray(UserSettings.config.GenAICfg.prompts.hdr)) {
      var menu = ""
      UserSettings.config.GenAICfg.prompts.hdr.map((prompt) => (
        menu += "<li onClick='window.promptChatbot(\"" + prompt.v + " " + order_no + "\")'>" + prompt.l + "</li>"
      ));

    } else {
      var menu = " <li onclick='HandlePunchOut(event,\""+ order_no +"\", \"display\")'> Display Sales Order"
               + " <li onclick='HandlePunchOut(event,\""+ order_no +"\", \"change\")' > Change Sales Order"
               + " <li onclick='Open3WCasesModal(event,\""+ legacy_order_no +"\", \"3W\")'> 3W Cases";
    }

    p.insertAdjacentHTML('beforeend', menu);
    var brect = ev.target.getBoundingClientRect();

    p.style.left = (brect.left + 3)+'px';
    p.style.top  = (brect.top + brect.height - 13 )+'px';
    p.style.display = 'block';
    p.addEventListener('mouseout', HidePunchMenu);
}

window.HandlePunchOut = function(e, order_no , punch_type) {
  e.preventDefault();
  e.stopPropagation();
  ClosePunchMenu(e)

  fetch("/os/ossui/v1/in/punchouturl/" + order_no + "/" + punch_type , {method: 'GET'})
    .then(function(response) {
      if (response.ok)
        return response.json();
      else
        throw Error(response.statusText);

    }).then(function(res) {
      if (res.status == 'S') {
        console.log("response date", JSON.stringify(res.data))
        window.open(res.data, "_blank");
      }  else {
        console.log("response date", JSON.stringify(res.data))
        toast.error("SAP Order not found");
        return true;
      }

  });

  return true;
};

window.HidePunchMenu = function(ev) {

    var evp = ev;
    var p = byId('PrefMenu');
    var brect = p.getBoundingClientRect();

    if (  (ev.clientX + 0.25) >= Math.floor(brect.left) && (ev.clientX + 0.25) <= Math.floor(brect.left + brect.width)
       && (ev.clientY + 0.25) >= Math.floor(brect.top ) && (ev.clientY + 0.25) <= Math.floor(brect.top  + brect.height)
    ) {
       //console.log('still inside');
    } else {
        ClosePunchMenu(ev)
    }
}

window.ClosePunchMenu = function(ev) {
  var p = byId('PrefMenu');
  if (!p) return;
  while(p.hasChildNodes() ){
    p.removeChild(p.lastChild);
  }
  p.style.display = 'none';
  p.removeEventListener('mouseout', HidePunchMenu);
}


//------------------------------------------------------------------------
//  DrillDownArea
//
//------------------------------------------------------------------------
export class DrillDownArea extends React.PureComponent {

  constructor(props) {
    super(props);
    this.handleCustomize = this.handleCustomize.bind(this);
  }

  handleRowClick( rowObject, freezeViewSo ) {
    console.log( 'handleRowClick:', rowObject );
    var fieldIndex = "f_0";
    if (freezeViewSo) {
      fieldIndex = "f_1";
    }
    ShowInternalWidget('drilldown', rowObject[fieldIndex].lno );
  }

  handleCustomize() {
    console.log( 'handleCustomize');
    if (this.props.onCustomize) {
         this.props.onCustomize();
    }
  }

  handleShowNotes( legacy_order_no ) {
    console.log('handleShowNotes:',legacy_order_no);
    OrderNotes_Open(legacy_order_no);
    return false;
  }

  render() {

    var freezeViewSo = this.props.freezeViewSo;

    if (this.props.loadingDrilldown) {
      return (
        <div>
          <div style={{"color": "#bbb", "textAlign":"center", "padding": "50px"}} id="loading">
            Loading...
            <div id="loadingDrilldown" style={{"paddingTop": "50px"}}>
            <img src={spinning_large}/>
            </div>
          </div>
          <div id="errorPane" style={{ display: "none", position: "relative" }}>
            <div id="errorPaneText" className="alert alert-danger"
                  role="alert">
              error text
            </div>
          </div>
        </div>
      )
    }
    if (Object.keys(this.props.drilldown).length != 0 &&  typeof(this.props.drilldownData.columns) !== 'undefined' ) {

        var drilldownHdr = this.props.drilldownData.columns.slice(3).map( function(column, i) {
            if(column == "Net Item Price (USD)"){ 
                return { name: column, right:1 };
            } else {
                return { name: column };
            }
        })

        var omtFields2HeadeProp = this.props.omtFields2Header;
        var alertName           = this.props.drilldownExportExcelReq.alertname;
        console.log("BMT_DEBUG load grid for " + this.props.drilldownExportExcelReq.type + " " + this.props.drilldownExportExcelReq.alertname);

        //sortbyIndex drives the first BMT column in the grid
        //below code will swap the index of the field that needs to be shown as first column
        var drilldownColumns;
        var sortbyIndex = 3;

        drilldownColumns = _.cloneDeep(this.props.drilldownData);
        if  (UserSettings.tenant == "HPICS") {
          if (freezeViewSo == false) {
            //sort by HPO
            sortbyIndex = 3;
            drilldownColumns.columns[3]             = "HP Order No"
            drilldownColumns.internalColumns[3]     = "hp_order_no"
            drilldownColumns.stdColumns[3]          = "HP Order No"
            drilldownColumns.stdInternalColumns[3]  = "hp_order_no"

            drilldownColumns.columns[4]             = "ServiceNotificationNo"
            drilldownColumns.internalColumns[4]     = "sn_no"
            drilldownColumns.stdColumns[4]          = "ServiceNotificationNo"
            drilldownColumns.stdInternalColumns[4]  = "sn_no"

          } else {
            //sort by SNNO and overwrite Template Order
            sortbyIndex = 4;
            drilldownColumns.columns[3]             = "ServiceNotificationNo"
            drilldownColumns.internalColumns[3]     = "sn_no"
            drilldownColumns.stdColumns[3]          = "ServiceNotificationNo"
            drilldownColumns.stdInternalColumns[3]  = "sn_no"

            drilldownColumns.columns[4]             = "HP Order No"
            drilldownColumns.internalColumns[4]     = "hp_order_no"
            drilldownColumns.stdColumns[4]          = "HP Order No"
            drilldownColumns.stdInternalColumns[4]  = "hp_order_no"
          }
        }

        drilldownColumns.rows = drilldownColumns.rows.sort(function(a, b) { return a[sortbyIndex] - b[sortbyIndex] });
        
        var omtFields2int = this.props.omtFields2int;

        var drilldownColumnsRows = preFormatColumns(drilldownColumns.columns, omtFields2HeadeProp, omtFields2int);

        var lastOrder = '(none)';
        var exportexcelReq = this.props.drilldownExportExcelReq;

        var newRows = createCompactData(drilldownColumns, sortbyIndex);

        /*  <SimpleDataGrid id='drilldowndata' header={drilldownHdr} data={newRows} exportexcelreq={exportexcelReq}/> */
        return (
          <RDataGrid id='drilldowndata' exportexcelreq={exportexcelReq} columns={drilldownColumnsRows}
                     nrOfRealRows={this.props.drilldownData.nrOfRealRows} onClick={this.handleRowClick} 
                     compactData={newRows} 
                     embedInto="#drilldownPanel"
                     onCustomize={this.handleCustomize}
                     switchFreezeView={this.props.switchFreezeView}
                     freezeViewSo={this.props.freezeViewSo}
                     disableAutoResize={this.props.disableAutoResize}
                     drilldownDetails={this.props.drilldown}
                     omtFields2HeadeProp={omtFields2HeadeProp}
                     omtFields2int={omtFields2int}
          />
        );
    }
    return (
      <div className="drilldownPlaceholder">
        {!(this.props.newBmt) && <div className="newbmt-banner">
          <p>Check out the new BMT !</p>
          <div><img src={bmtBanner} alt="" /></div>
          <a className="overlay-link" href="bmt.html"></a>
        </div>}
      </div>
    )
  }
};

function HideRepeatedFormatter(row, cell, value, columnDef, dataContext) {
  var field = columnDef.field;
  if (row > 0) {
      if ( window.DrillDownData[row-1][field] == value) {
          return "<span style='color: #d8d8d8'>"+value+"</span>";
      }
  }  
  return value;
}

function HPOrderNoFormatter(row, cell, value, columnDef, dataContext) {

  var fieldIndex;

  if (value.sortBy == "sn_no") {
    fieldIndex = "f_1";
  } else {
    fieldIndex = "f_0";
  }

  if (row > 0) {
    if ( window.DrillDownData[row-1][fieldIndex].order == value.order) {
      return "<span style='color: #d8d8d8'>"+value.order+"</span>"
    }
  }  
  var LegacyIntURL = UserSettings.config.links.LegacyIntURL;
  var sandyUrl = LegacyIntURL+"?o="+value.lno+"&os_no="+value.order;

  var pinned;
  var subscribed;
  var sapPunchout;
  var sandyPrompts;

  if (value.pinned) {
    pinned =  "<span title='pinned for you' style='float:right'>"
              +"<svg onclick='return SetPinned(event, this,\""+ value.lno+"\");' class='pinned_icon_on'  style='cursor:pointer; margin-bottom: 2px; color:#c1401a;'><use xlink:href='#pin'/></svg>"
              +"</span>"
  } else {
    pinned =  "<span title='not pinned'style='float:right'>"
              +"<svg onclick='return SetPinned(event, this,\""+ value.lno+"\");' class='pinned_icon_off' style='cursor:pointer; margin-bottom: 2px';><use xlink:href='#pin'/></svg>"
              +"</span>"    
  }

  if (value.subscribed) {
    subscribed =  "<span title='event notification enabled' style='float:right'>"
                  +"<svg onclick='return SetWatched(event,this,\""+ value.lno+"\");' class='noti_icon_on'  style='cursor:pointer; margin-bottom: 3px; height: 14px'; color:#00AA00';><use xlink:href='#bell-ring'/></svg>"
                  +"</span>"
  } else {
    subscribed =  "<span title='event notification disabled' style='float:right'>"
                  +"<svg onclick='return SetWatched(event,this,\""+ value.lno+"\");' class='noti_icon_off' style='cursor:pointer; margin-bottom: 3px; height: 14px';><use xlink:href='#bell-ring'/></svg>"
                  +"</span>"
  }

  if (value.order.length < 10 ) {
    sapPunchout = "<a onMouseOver='ShowPunchMenu(event,\""+ value.order+"\",\""+ value.lno+"\",\"so\")' style='margin-left:4px;'><i class='glyphicon glyphicon-new-window' title='sales order' style='cursor:pointer;font-size:7.58pt;'></i></a>"
  } else {
    sapPunchout = ""
  }

  if (UserSettings.config?.GenAICfg?.prompts?.hdr) {
    sandyPrompts = "<span style='float: right'> \
                      <a onMouseOver='ShowPunchMenu(event,\""+ value.order+"\",\""+ value.lno+"\",\"ai\")' style='margin-left:4px;'> \
                        <svg class='sandy_icon_on' viewBox='0 0 24 24' style='-ms-transform: rotate(360deg); -webkit-transform: rotate(360deg); transform: rotate(360deg);'> \
                            <path d='M17.753 14c1.243 0 2.25 1.007 2.25 2.25v.905a4.004 4.004 0 0 1-1.307 2.845C17.13 21.344 14.89 22 12 22s-5.128-.656-6.691-2a4.004 4.004 0 0 1-1.306-2.843v-.907C4.003 15.007 5.011 14 6.254 14h11.499zM11.899 2.007a.75.75 0 0 1 .851.743v.75h3.5A2.25 2.25 0 0 1 18.5 5.75v4.505a2.25 2.25 0 0 1-2.25 2.25H7.75A2.25 2.25 0 0 1 5.5 10.255V5.75A2.25 2.25 0 0 1 7.75 3.5h3.5v-.75a.75.75 0 0 1 .649-.743zM9.749 6.5A1.25 1.25 0 1 0 11 7.749 1.25 1.25 0 0 0 9.749 6.5zm4.493 0a1.25 1.25 0 1 0 1.249 1.249A1.25 1.25 0 0 0 14.242 6.5z' fill='currentColor'/> \
                        </svg> \
                      </a> \
                    </span>"
  } else {
    sandyPrompts = ""
  }

  return "<span className='pref-popup' onMouseOver='ShowPrefMenu(event)' onMouseout='HidePrefMenu(event)'>"
         +"<a onclick='event.stopPropagation();return LaunchPreferredViewer(\""+ value.lno+"\");' style='float:left; cursor: pointer;'>"
         +value.order
         +"</a>"
         +"</span>"
         +sapPunchout
         +"<span style='float:right'>"
         +"<a onclick='return HandleShowNotes(event,\""+ value.lno+"\");'  style='margin-left:1px;color:"+value.noteColor+";'><i class='glyphicon glyphicon-tags' title='show notes' style='cursor:pointer; font-size: 11px;'></i></a>"
         +"</span>"
         +sandyPrompts
         +subscribed
         +pinned
}


function BlocksFormatter(row, cell, value, columnDef, dataContext) {

  if (typeof value != "string") return "";

  var BlockDescr = UserSettings.config.BlockDescription;

  var bs = value.split(" ");
  var cell = "<span style='color: #bb0000'>";
  for (var i = 0; i < bs.length; i++) {
      var descr = ''
      if (BlockDescr['SAP-SCP'] && BlockDescr['SAP-SCP'][bs[i]]) {    
          descr = BlockDescr['SAP-SCP'][bs[i]].itext
                + '&#10;'
                + '(category: '+BlockDescr['SAP-SCP'][bs[i]].cat +' )';
      }
      cell += "<span class='blockcode' title='"+descr+"'>"
            + bs[i]
            + "</span>&nbsp;"
  }
  cell += "</span>"
  return cell;
}

function B2BFormatter(row, cell, value, columnDef, dataContext) {
  var field = columnDef.field;

  if ( value == '' ) {
     return "<span style='color: #d8d8d8'>"+value+"</span>";
  } else {

        //Copying the DrillDownData into the tempRows
         var tempRows = this.props.drilldownData.rows;
         var legacyorderno;

        //Checking for the corresponding legacy_order_no for a given ParentOrderNo/ICOrderNo
         for (var i = 0; i < tempRows.length; i++ ) {
            if ( tempRows[i][3] == value ) {
               legacyorderno = tempRows[i][0];
               break;
            }
         }

        var LegacyIntURL = UserSettings.config.links.LegacyIntURL;
        var sandyUrl = LegacyIntURL+"?o="+legacyorderno+"&os_no="+value;
        return "<a onclick='return HandleShowOrder(event,\""+legacyorderno+"\");' style='float:left; cursor: pointer;'>"
               +value
               +"</a>"
               +"<span style='float:right'>"
               +"<a onclick='return HandleShowSandy(event,\""+legacyorderno+"\",\""+value+"\");' style='margin-left:5px;color:#0096d6;'><i class='glyphicon glyphicon-circle-arrow-right' title='show in SANDY' style='cursor:pointer;'></i></a>"
               +"</span>"
  }
}

    //------------------------------------------------------------------------
    //  BacklogPage
    //
    //------------------------------------------------------------------------
    class BacklogPage extends React.PureComponent {

      constructor(props) {
        super(props);

        this.state = {
          UserSettings            : this.props.UserSettings,
          alertDashboards         : [],
          alertNames              : [],
          alertNumbersLoading     : [],
          adhocFilters            : [],
          adhocFiltersCollapsed   : [],
          cacheAdhocVals          : {},
          cacheLoading            : {},
          dashboardId             : -1,
          displayValues           : 'items',
          drilldownTplName        : {},
          filterMode              : 'no',
          Loading                 : [],
          myFavourites            : [],
          omtFields               : [],
          omtFields2Header        : {},
          omtFields2int           : {},
          profileId               : -100,
          profileName             : 'my_orders_all_names',
          recentlyUsed            : [],
          updNestedTimeout        : [],
          repaint                 : new Date(),
          alertList               : [],
          myPersonalDashboard     : [],
          drilldown               : {},
          loadingDrilldown        : false,
          drilldownExportExcelReq : {},
          drilldownData           : {},
          cachedAlerts            : {},
          showFieldCustomization  : false,
          logParams               : [{t:'BMTEvent',e:'BMT_onInit', time: new Date()}],
          freezeViewSo            : false,
          searchInitiator         : "initial",
          showObsoleteMsg         : true,
          obsoleteClickCounter    : 15,
        };

        this.standardColumnList = null;
        this.selectedColumnList = null;   
        this.availableColumnList = null;   

        this.handleCustomizeFieldsChange  = this.handleCustomizeFieldsChange.bind(this);
        this.handleCustomizeFieldsCancel  = this.handleCustomizeFieldsCancel.bind(this);
        this.handleCustomize              = this.handleCustomize.bind(this);

        this.handleMassUpdPlannerNotes    = this.handleMassUpdPlannerNotes.bind(this);
        this.handleMassUpdCSRNotes        = this.handleMassUpdCSRNotes.bind(this);
        this.handleMassUpdBackOfficeNotes = this.handleMassUpdBackOfficeNotes.bind(this);
        this.handleMassUpdCustomerNotes   = this.handleMassUpdCustomerNotes.bind(this);

        this.handleMassUpdUserStatus           = this.handleMassUpdUserStatus.bind(this);
        this.handleMassUpdUserStatusHdrSet     = this.handleMassUpdUserStatusHdrSet.bind(this);
        this.handleMassUpdUserStatusHdrRemove  = this.handleMassUpdUserStatusHdrRemove.bind(this);
        this.handleMassUpdUserStatusItemSet    = this.handleMassUpdUserStatusItemSet.bind(this);
        this.handleMassUpdUserStatusItemRemove = this.handleMassUpdUserStatusItemRemove.bind(this);

        this.handleMassUpdStartMigrationReserve = this.handleMassUpdStartMigrationReserve.bind(this);
        this.handleMassUpdStartMigration        = this.handleMassUpdStartMigration.bind(this);
        this.handleMassUpdStartMigrationReject  = this.handleMassUpdStartMigrationReject.bind(this);

        this.handleAdhocFilterChange      = this.handleAdhocFilterChange.bind(this);
        this.handleSaveMyFavs             = this.handleSaveMyFavs.bind(this);
        this.handleDashboardChange        = this.handleDashboardChange.bind(this);
        this.handleSaveDashboardDetails   = this.handleSaveDashboardDetails.bind(this);
        this.handleMyPersonalDashboard    = this.handleMyPersonalDashboard.bind(this);
        this.handleFilterModeChange       = this.handleFilterModeChange.bind(this);
        this.handleDisplayValueChange     = this.handleDisplayValueChange.bind(this);

        this.getNestedFilters             = this.getNestedFilters.bind(this);
        this.getCurrentAdhocFilters       = this.getCurrentAdhocFilters.bind(this);
        this.getOMTFields                 = this.getOMTFields.bind(this);
        this.getAndShowDashboard          = this.getAndShowDashboard.bind(this);
        this.handleGetAndShowDashboard    = this.handleGetAndShowDashboard.bind(this);
        this.getOMTValues                 = this.getOMTValues.bind(this);
        this.getOMTAlertNumbers           = this.getOMTAlertNumbers.bind(this);

        this.adhocFilterAdd               = this.adhocFilterAdd.bind(this);
        this.adhocFilterRemove            = this.adhocFilterRemove.bind(this);
        this.updateNestedFilters          = this.updateNestedFilters.bind(this);
        this.updateAdhocFilters           = this.updateAdhocFilters.bind(this);
        this.drillDownStateChange         = this.drillDownStateChange.bind(this);
        this.addToFavourite               = this.addToFavourite.bind(this);
        this.removeFromFavourite          = this.removeFromFavourite.bind(this);
        this.updateRecentProfile          = this.updateRecentProfile.bind(this);
        this.eraseCachedAlerts            = this.eraseCachedAlerts.bind(this);
        this.alertQueueLoader             = this.alertQueueLoader.bind(this);
        this.switchFreezeView             = this.switchFreezeView.bind(this);
        this.handleObsoleteMessageClick   = this.handleObsoleteMessageClick.bind(this);
      }

      componentDidMount() {

        window.BMTRedirectTimeout = setTimeout( function() {
          window.location.replace("/static/dist/bmt.html");
        }, 30000);

        console.log("fill state");
        var getOMTFields = this.getOMTFields;
        var self = this;
        
          window.CurrentPref = UserSettings.get('global.preferredViewer');
          var bm = UserSettings.get('bm');

          //some basic initialization for users without existing usersettings
          let bmAdhocFilters        = (bm.adhocFilters        ? bm.adhocFilters        : this.state.adhocFilters);
          let bmMyPersonalDashboard = (bm.myPersonalDashboard ? bm.myPersonalDashboard : this.state.myPersonalDashboard);
          let bmMyFavourites        = (bm.myFavourites        ? bm.myFavourites        : this.state.myFavourites);
          let bmRecentlyUsed        = (bm.recentlyUsed        ? bm.recentlyUsed        : this.state.recentlyUsed);
          let bmFilterMode          = (bm.filterMode          ? bm.filterMode          : this.state.filterMode);
          let bmDisplayValues       = (bm.displayValues       ? bm.displayValues       : this.state.displayValues);
          let bmDashboardId         = (bm.dashboardId         ? bm.dashboardId         : this.state.dashboardId);
          let bmProfileName         = (bm.profileName         ? bm.profileName         : this.state.profileName);
          let bmProfileId           = (bm.profileId           ? bm.profileId           : this.state.profileId);
          let bmFreezeViewSo        = (bm.freezeViewSo        ? bm.freezeViewSo        : this.state.freezeViewSo);

          //As strings can not be rendered into the adhocfilter, we remove them initially
          var i = bmAdhocFilters.length;
          while (i--) {
            if (bmAdhocFilters[i].type == "string") { 
              bmAdhocFilters[i].values = [];
            } 
          }             

          this.setState({
            UserSettings        : UserSettings,
            recentlyUsed        : bmRecentlyUsed,
            myFavourites        : bmMyFavourites,
            myPersonalDashboard : bmMyPersonalDashboard,
            dashboardId         : bmDashboardId,
            displayValues       : bmDisplayValues,
            adhocFilters        : bmAdhocFilters,
            filterMode          : bmFilterMode,
            profileName         : bmProfileName,
            profileId           : bmProfileId,
            freezeViewSo        : bmFreezeViewSo,
          }, () => {
            getOMTFields();
          })

          if (!this.state.UserSettings.memberOf('BMTUser')) {
            console.log('Either not a memberOf BMTUser or unauthorized access. Showing denied message');
            ReactDOM.render(
              <div>
                <div id="errorPane" >
                  <div id="errorPaneText" className="alert alert-danger errorPaneWidget2" role="alert">
                    Access Denied – You are not authorized to view this page.
                    <br/>
                    OSS access is restricted. You are seeing this message because you are not authorized to access the requested page.
                    <ul>
                        <li>If you already have a profile in OSS please step back to the previous page and check your profile rights on the menu bar at the far right and check <b><a href="https://hp.sharepoint.com/:b:/r/teams/pcbits/bitshomepage/OSS%20Document%20Library/OSS%20General%20training/SANDY%20(Sales%20Admin%20Display%20Tool)/OSS%20User%20Access%20Manual.pdf?csf=1&e=11Hf8g">here</a></b> for the access rights related to the profile.</li>
                        <li>If you do not yet have a profile in OSS, please click <b><a href="https://hp.sharepoint.com/:b:/r/teams/pcbits/bitshomepage/OSS%20Document%20Library/OSS%20General%20training/SANDY%20(Sales%20Admin%20Display%20Tool)/OSS%20User%20Access%20Manual.pdf?csf=1&e=11Hf8g">here</a></b>  to review OSS profiles and to select the right access level for you. You can request access to OSS via UAM <b><a href="https://accessmanager.austin.hp.com/uam/">here</a></b></li>
                    </ul>

                    If you feel you have received this message in error, please contact our <b><a href="https://techdirect.corp.hpicloud.net/techdirect/SubmitRequest?p=sr">support team</a></b>. 
                  </div>
                </div>
    
                <div style={{ 'padding': '20px'}}>
                  Screenshot of the new OSS Backlog Management UI:
                  <br/>
                  <br/>
                  <img src={bmui_sampleScreen}/>
                </div>
              </div>,
              document.getElementById('main')
            );
            return;
          }

      }

      updateRecentProfile(profile_id, profile_name) {
        console.log("BMT_DEBUG updateRecentProfile");
        var ru = [];

        let recentlyUsedUpdated = [...this.state.recentlyUsed];

        if (recentlyUsedUpdated) {
          recentlyUsedUpdated.forEach( function(entry,i) {
            if (entry.id != profile_id && ru.length < 5 ) {
              ru.push(entry);
            }
          });
        }
        ru.unshift( { id  : profile_id,
                      name: profile_name } );

        recentlyUsedUpdated = ru.slice(0, 5);
        //console.log(ru);

        let newEvent = [...this.state.logParams, {t:'BMTEvent',e:'BMT_onSelectProfile', time: new Date()}];

        this.setState({
          recentlyUsed: recentlyUsedUpdated,
          profileId   : profile_id,
          profileName : profile_name,
          logParams   : newEvent,
          searchInitiator: "updateRecentProfile",
        }, () => {
          this.getAndShowDashboard();
        }) 
      }

      eraseCachedAlerts() {
       console.log("BMT_DEBUG eraseCachedAlerts");
       let newEvent = [...this.state.logParams, {t:'BMTEvent',e:'BMT_updateDashboard', time: new Date()}];
 
       this.setState({
         cachedAlerts : {},
         logParams   : newEvent,
         searchInitiator: "eraseCachedAlerts",
       }, () => {
         this.getAndShowDashboard();
       })
 
      }

      drillDownStateChange(drilldown, drilldownData, loadingDrilldown, drilldownExportExcelReq) {
        console.log("BMT_DEBUG drillDownStateChange");

        if (drilldownData) {
          console.log("BMT_DEBUG drilldown loading finished");
          let newEvent = [...this.state.logParams, {t:'BMTEvent',e:'BMT_onSelectDrilldown', time: new Date()}];
          //console.log("drillDownStateChange JOLO:", drilldown, drilldownData);
          this.setState(prevState => ({ 
            drilldown: drilldown,
            drilldownData: drilldownData,
            loadingDrilldown : loadingDrilldown,
            drilldownExportExcelReq: drilldownExportExcelReq,
            logParams: newEvent
          }))
        } else {
          console.log("BMT_DEBUG drilldown loading ...");
          this.setState(prevState => ({ 
            loadingDrilldown : loadingDrilldown,
          }))          
        }

      }

      /*----------------------------------------------------------------------
      |   alertQueueLoader   --  triggers new OMT fetch
      |
      \---------------------------------------------------------------------*/
      alertQueueLoader(slotID) {

        //console.log("BMT_alertQueueLoader slotID=", slotID, "enter, window.legacystate.alertQueue=", JSON.stringify(window.legacystate.alertQueue) );

        if (window.legacystate.alertQueue == null) {
          console.log("BMT_alertQueueLoader alertQueue slotID=", slotID,  "alertQueue empty, stopping");
          if (window.legacystate.alertQueueLoaderIDs[slotID] != null) {
            clearTimeout(window.legacystate.alertQueueLoaderIDs[slotID] );
            window.legacystate.alertQueueLoaderIDs[slotID] = null;
          }
          return 0
        }

        var self = this;

        var cleanConditionJSON  = window.legacystate.alertQueue.shift();

        if (cleanConditionJSON == undefined) {
            cleanConditionJSON = "{}"
        } 

        //console.log("BMT_alertQueueLoader slotID=", slotID, "enter, cachedAlerts=", JSON.stringify(this.state.cachedAlerts));

        //console.log("BMT_alertQueueLoader slotID=", slotID, "got new queue entry:", JSON.stringify(cleanConditionJSON));
        //console.log("BMT_alertQueueLoader slotID=", slotID, "rest queue len=", window.legacystate.alertQueue.length, JSON.stringify(window.legacystate.alertQueue) );
        if (window.legacystate.alertQueue.length == 0) {
          window.legacystate.alertQueue = null;
        }

        if (this.state.cachedAlerts[ cleanConditionJSON ]) {

            self.setState( (oldState) => {

                var cachedAlerts        = {...oldState.cachedAlerts        };
                var alertNumbersLoading = {...oldState.alertNumbersLoading }; 

                alertNumbersLoading[ cleanConditionJSON ] = false;

                return {
                  cachedAlerts: cachedAlerts,
                  alertNumbersLoading: alertNumbersLoading
                }
            }, () => {
              window.legacystate.alertQueueLoaderIDs[slotID] = null;
              if (window.legacystate.alertQueue != null) {             
                //console.log("BMT_alertQueueLoader alertQueue slotID=", slotID,  "cached, continuing");
                window.legacystate.alertQueueLoaderIDs[slotID] = setTimeout( 
                                                            (function(other_slotID) {  
                                                               self.alertQueueLoader(other_slotID)
                                                            })(slotID),
                                                            10
                                                          );
              }  
            })          

        } else {
          // console.log('NOT in cache:', omtConditions);          
          // console.log("BMT_alertQueueLoader slotID=", slotID, "start POST with", JSON.stringify(cleanConditionJSON));
          if (Object.keys(JSON.parse(cleanConditionJSON)).length > 0) {
            POST('/os/ossui/v1/in/omtNumbersAll', JSON.parse(cleanConditionJSON), function(resp) {

              console.log("BMT_alertQueueLoader alertQueue slotID=", slotID,  "POST return", JSON.stringify(cleanConditionJSON));

              var alertbucket = [];
              if(resp.data){
                let trigger = resp.data[0];
                let red     = resp.data[1];
                let yellow  = resp.data[3];
                let green   = resp.data[5];
                alertbucket.push(trigger,red,yellow,green)
              }

              if (resp.nrRows) {
                  // hand over to AlertRow as nested array
                let nrRows = [];
                let nrRowTrigger = resp.nrRows[0];
                let nrRowRed     = resp.nrRows[1];
                let nrRowYellow  = resp.nrRows[3];
                let nrRowGreen   = resp.nrRows[5];
                nrRows.push(nrRowTrigger,nrRowRed,nrRowYellow,nrRowGreen);
                alertbucket[4] = nrRows;
              }

              if (resp.props && resp.props.alertType) {
                alertbucket[5] = resp.props.alertType;
              }
              //console.log("BMT_alertQueueLoader alertQueue slotID=", slotID,  "POST returned", self.state.cachedAlerts );

              self.setState( (oldState) => {

                var cachedAlerts        = {...oldState.cachedAlerts        };
                var alertNumbersLoading = {...oldState.alertNumbersLoading }; 

                cachedAlerts       [ cleanConditionJSON ] = alertbucket;
                alertNumbersLoading[ cleanConditionJSON ] = false;

                return {
                  cachedAlerts: cachedAlerts,
                  alertNumbersLoading: alertNumbersLoading
                }
              }, () => {
                window.legacystate.alertQueueLoaderIDs[slotID] = null;
                if (window.legacystate.alertQueue != null) {
                  //console.log("BMT_alertQueueLoader alertQueue slotID=", slotID,  "after POST continuing");
                  window.legacystate.alertQueueLoaderIDs[slotID] = setTimeout( 
                                                              (function(s,other_slotID) {  
                                                                 s.alertQueueLoader(other_slotID)
                                                              })(self,slotID),
                                                              10
                                                            );
                } else {
                  //console.log("BMT_alertQueueLoader alertQueue slotID=", slotID,  "after POST done (alertQueue empty)");
                }
              })

          }, function(err, errText) {

              console.log("BMT_alertQueueLoader alertQueue slotID=", slotID,  "error POST)", err, JSON.stringify(cleanConditionJSON));
              if (err == 'timeout') {
                var indError = 'TO'
              } else {
                var indError = 'E'
              }

              self.setState( (oldState) => {

                var cachedAlerts        = {...oldState.cachedAlerts        };
                var alertNumbersLoading = {...oldState.alertNumbersLoading }; 

                cachedAlerts[ cleanConditionJSON ] = [
                  { indError: indError, errText: errText },
                  { indError: indError, errText: errText },
                  { indError: indError, errText: errText },
                  { indError: indError, errText: errText }
                ]
                alertNumbersLoading[cleanConditionJSON] = false;

                return {
                  cachedAlerts: cachedAlerts,
                  alertNumbersLoading: alertNumbersLoading
                }
              }, () => {
                window.legacystate.alertQueueLoaderIDs[slotID] = null;
                if (window.legacystate.alertQueue != null) {             
                  window.legacystate.alertQueueLoaderIDs[slotID] = setTimeout( 
                                                              (function(other_slotID) {  
                                                                 self.alertQueueLoader(other_slotID)
                                                              })(slotID),
                                                              10
                                                            );
                }  
              }) 

            });
          } else {
            //console.log("no condition for omtNumbersAll (empty alert list)");
          }
        }

      }

      getOMTFields (){

        //arrays
        let omtFields          = [...this.state.omtFields];
        let alertDashboards    = [...this.state.alertDashboards];
        let alertNames         = [...this.state.alertNames];

        //objects  
        let omtFields2int      = {...this.state.omtFields2int};
        let omtFields2Header   = {...this.state.omtFields2Header};
        let drilldownTplName   = {...this.state.drilldownTplName}; 

        var self = this;

        GET('/os/ossui/v1/in/omtFields', '', function(response) {

          var Params = {};
          OSWidgetLib.setJSONforGETRequestValue(Params, 'lprms', ['t',window.legacystate.logParams.t], ['e',window.legacystate.logParams.e]);
    
          GET('/os/ossui/v1/in/alertDashboard', Params, function(response2) {
            alertDashboards = response2.data;
            window.legacystate.logParams = JSON.parse(decodeURIComponent(Params.lprms));
            console.log('alertDashboard loaded!', alertDashboards);

            GET('/os/ossui/v1/in/alertInfo','', function(response3) {
              $.each(response3.data,function(key,val){
                  alertNames.push({
                    name:     val.alert_profile_name,
                    id: val.alert_profile_id
                  });
                  drilldownTplName[val.alert_profile_id] = val.drilldown_tpl_name;
              });

              console.log('alertInfo loaded!', alertNames);

              omtFields = response.data.map( function(omtfield) {
                omtFields2int[ omtfield.columnName ] = { type: omtfield.type, internalField: omtfield.value };
                omtFields2Header[ omtfield.columnName ] = omtfield.columnHeader;
                return { id: omtfield.columnName, name: omtfield.columnName, internal: omtfield.value, columnHeader: omtfield.columnHeader } ;
              });
              console.log('omtFields loaded!', omtFields);

             if (0) {
              document.addEventListener("mouseover", function(ev) {
                 if (   ev.target 
                     && ev.target.nodeName == "SPAN"
                     && ev.target.className == "blockcode"
                 ) {
                     console.log(ev.target, ev.target.nodeName);
                     var tt = document.getElementById('blockTooltip');
                     tt.style.top  = (ev.clientY + 5 )+'px';
                     tt.style.left = (ev.clientX + 2 )+ 'px'; 
                     tt.style.display = 'block';
                     console.log(ev);
                 }
              });

              document.addEventListener("mouseout", function(ev) {
                 if (   ev.target 
                     && ev.target.nodeName == "SPAN"
                     && ev.target.className == "blockcode"
                 ) {
                     console.log(ev.target, ev.target.nodeName);
                     var tt = document.getElementById('blockTooltip');
                     tt.style.display = 'none';
                 }
              });
             }

              self.setState({
                omtFields,
                omtFields2int,
                omtFields2Header,
                alertDashboards,
                alertNames,
                drilldownTplName,
              }, () => {
                self.getOMTValues();
              })

            });
      
          });
  
        });
        
      }

      getOMTAlertNumbers(alerts, dashboardId, searchInitiator) {

        console.log("BMT_DEBUG getOMTAlertNumbers");
        var self = this;

        var bm = UserSettings.get('bm');
        bm.adhocFilters = this.state.adhocFilters;
        bm.profileId = this.state.profileId;
        bm.profileName = this.state.profileName;
        bm.dashboardId = this.state.dashboardId;
        bm.myPersonalDashboard  = this.state.myPersonalDashboard;
        bm.myFavourites = this.state.myFavourites;
        bm.displayValues = this.state.displayValues;
        bm.filterMode = this.state.filterMode;
        bm.recentlyUsed = this.state.recentlyUsed;
        bm.lprms = this.state.logParams;

        if (searchInitiator != "initial" && searchInitiator != "ShowAlers_componentDidMount" ) {
          UserSettings.update('bm', bm, function() {
            console.log("BMT_DEBUG UserSettings Update Sucess!");
            console.log("BMT_DEBUG audit written before deletion, ", self.state.logParams);
            self.setState({
              logParams: [],
            })
          })
        }

        let profileId     = this.state.profileId;
        let adhocFilters  = this.state.adhocFilters;
        let displayValues = this.state.displayValues;

        let alertQueue = [];

        let cachedAlerts  = {...this.state.cachedAlerts};

        let alertNumbersLoading = {};

        var alertRows = alerts.map(function(alert) {

          // OMT/dashboard values depend on this input:
          var omtConditions = {
            profile:       profileId,
            alert:         alert.alert_id,
            adhoc:         adhocFilters,
            displayValues: displayValues
          }          

          //If we have adhocfilters that have no values selected, we remove them from the OMT Condition
          //explnation for below: omtConditions should not be referenced by cleanCondition !! 
          let cleanCondition = JSON.parse( JSON.stringify( omtConditions ) );
          var i = cleanCondition.adhoc.length;
          while (i--) {
              if (cleanCondition.adhoc[i].values.length == 0) { 
                cleanCondition.adhoc.splice(i, 1);
              } 
          }          
          var cleanConditionJSON = JSON.stringify(cleanCondition);

         alertNumbersLoading[cleanConditionJSON] = true;

         //GEGA Maybe already render here cached stuff?
         //if (cachedAlerts[ cleanConditionJSON ]) {
         // alertNumbersLoading[cleanConditionJSON] = false;
         // self.setState(prevState => ({ 
         //   cachedAlerts: cachedAlerts,
         //   //alertList: [...alerts],
         //   alertNumbersLoading: alertNumbersLoading
         // }));           
         //} else {
          alertQueue.push(cleanConditionJSON);
         //}

        });

        this.setState({
          alertNumbersLoading: alertNumbersLoading,
          alertList : [...alerts],
        }, () => {
          window.legacystate.alertQueue = alertQueue;
          for (var i = 0; i < window.legacystate.alertQueueLoaderIDs.length ; i++) {
              if (window.legacystate.alertQueueLoaderIDs[i] == null) {
                  window.legacystate.alertQueueLoaderIDs[i] =  setTimeout( 
                                                           (function(slotID) {  
                                                               self.alertQueueLoader(slotID)
                                                           })(i),
                                                           10
                                                        );
              }
          }
        })
      }

      getOMTValues() {

        console.log("BMT_DEBUG getOMTValues ");

        let self = this;
        let filtersFetched = 0;
        let cachedVals = {};

        let adhocFilters = [...this.state.adhocFilters];

        let amountOfFilters = adhocFilters.length;

        var values = adhocFilters.map( function(afilter) {
          //console.log('adhoc filter:', afilter);
          if (afilter.type == 'enum') {
            GET('/os/ossui/v1/in/omtValuesOf/'+afilter.internal, null, function(resp) {
              var values = [];
              var hadEmpty = 0;
              for (var i = 0; i < resp.data.length; i++) {
                if (resp.data[i] != "") {
                  values.push(resp.data[i]);
                } else {
                  hadEmpty  = 1;      
                }
              }
              var selValues = [];
              values.sort().forEach( function( v ) {
                  if (afilter.values.indexOf(v) >= 0) {
                      selValues.push( { name: v, selected: true,  disabled: false} );
                  } else {
                      selValues.push( { name: v, selected: false, disabled: false} );
                  } 
              });

              if (hadEmpty) {
                  selValues.push( { name: '<blank>', selected: false, disabled: false} );
              }
  
              cachedVals[afilter.name] = selValues;
              filtersFetched++;
  
              if (filtersFetched == amountOfFilters) {
                //So if we are on a dynamic mode, we will pass cached values directly so they can be filtered before rendered
                if(self.state.filterMode != "no" ) {
                  self.updateNestedFilters(cachedVals);
                } else {
                  self.setState({
                    cacheAdhocVals: cachedVals,
                  })
                }
              }
            });             

          } else
          if (afilter.type == 'bool') {
            console.log("BMT_DEBUG skip bool field");

            var values = ['Y', 'N'];
            var selValues = [];
            values.sort().forEach( function( v ) {
              if (afilter.values.indexOf(v) >= 0) {
                selValues.push( { name: v, selected: true,  disabled: false} );
              } else {
                selValues.push( { name: v, selected: false, disabled: false} );
              }
            });


            cachedVals[afilter.name] = selValues;
            filtersFetched++;

            if (filtersFetched == amountOfFilters) {
              //So if we are on a dynamic mode, we will pass cached values directly so they can be filtered before rendered
              if(self.state.filterMode != "no" ) {
                self.updateNestedFilters(cachedVals);
              } else {
                self.setState({
                  cacheAdhocVals: cachedVals,
                })
              }   
            }  

          } else {
            console.log("BMT_DEBUG skip string or date field");

            cachedVals[afilter.name] = [];
            filtersFetched++
            if (filtersFetched == amountOfFilters) {
              //So if we are on a dynamic mode, we will pass cached values directly so they can be filtered before rendered
              if(self.state.filterMode != "no" ) {
                self.updateNestedFilters(cachedVals);
              } else {
                self.setState({
                  cacheAdhocVals: cachedVals,
                })
              }
            }           
          }
        });
      }

      handleObsoleteMessageClick() {
          console.log("handleObsoleteMessageClick: ", this.state.obsoleteClickCounter);
          if (this.state.obsoleteClickCounter <= 1) {
              this.setState({
                  showObsoleteMsg: false,
                  obsoleteClickCounter: 0
              });    
              if (window.BMTRedirectTimeout) {
                  clearTimeout(window.BMTRedirectTimeout);
              }
          } else {
              this.setState({
                  obsoleteClickCounter: this.state.obsoleteClickCounter - 1
              });    
          }
      };


      handleGetAndShowDashboard() {
        this.setState({
          searchInitiator: "ShowAlers_componentDidMount",
        }, () => {
          this.getAndShowDashboard();
        }) 
      }
 
      getAndShowDashboard(dashboardId) {
         console.log("BMT_DEBUG getAndShowDashboard initiator: ", this.state.searchInitiator)

         let alertListArray = [...this.state.alertList];
         let myPersonalDashboard = [...this.state.myPersonalDashboard];
         let searchInitiator = this.state.searchInitiator;
         
         if (dashboardId == undefined ) {
           dashboardId = this.state.dashboardId;
         }

         var self = this;

         if (dashboardId == -1) {

          window.legacystate.logParams.e = "";
          var newAlertArr = [];
          var temp=[];
          var newAlertTemp = [];

          for (var prop in myPersonalDashboard) {
            var uniqueAlert = {};
            var entry = myPersonalDashboard[prop];
            if (temp.indexOf(entry.id)!= -1) {
                newAlertTemp = [];
                uniqueAlert["name"] = entry.name;
                uniqueAlert["alert_id"] = entry.id;
                newAlertTemp.push(uniqueAlert);
              } else {
                temp.push(entry.id);
                uniqueAlert["name"] = entry.name;
                uniqueAlert["alert_id"] = entry.id;
                newAlertTemp.push(uniqueAlert);
              }
              newAlertArr = newAlertTemp;
          }

          alertListArray = newAlertArr;
          if (this.state.filterMode != "no") {
            this.updateNestedFilters();
          }          
          this.getOMTAlertNumbers(newAlertArr, dashboardId, searchInitiator );

         } else {

           var dashboardAlertsInfoUrl = '/os/ossui/v1/in/alertDashboard/'+dashboardId;
           GET(dashboardAlertsInfoUrl,'', function(response) {
            alertListArray = []; // reset it and create empty array
             $.each( response.data.alerts ,function( key, val ) {

               if (val != null) {

                if (val.alert_id == '0') {
                  alertListArray.push({
                    name            : val.alert_name,
                    alert_id        : val.alert_id,
                    collapsed       : true
                  });
                } else {
                  alertListArray.push( {
                    name            : val.alert_name,
                    alert_id        : val.alert_id,
                    show            : true
                  });
                }
                
               }
             });
             //console.log("GET alertListArray: ", alertListArray);

             if (self.state.filterMode != "no") {
              self.updateNestedFilters();
             }       
             self.getOMTAlertNumbers(alertListArray, dashboardId, searchInitiator);
           });
      
         }

      }

      getCurrentAdhocFilters() {
        console.log('BMT_DEBUG getCurrentAdhocFilters');

        let adhocFilters   = [...this.state.adhocFilters];
        let omtFields2int  = this.state.omtFields2int;
        let cacheAdhocVals = this.state.cacheAdhocVals

        var adhocValuesChanged = false;
        // get current selection of each adhoc filter:

          adhocFilters = adhocFilters.map( function(afilter, index) {
            var idName = 'adhoc_val_'+afilter.name;
            var values = [];

            //console.log('ShowAlerts ', idName, ' values:', $('#'+idName).val() );

            if (omtFields2int[ afilter.name ].type == 'date') {

                var m = $('#adhoc_val_'+afilter.name+'_mode').val();
                var a = $('#adhoc_val_'+afilter.name+'_date1').val();
                var b = $('#adhoc_val_'+afilter.name+'_date2').val();

                //console.log('ShowAlerts date m=',m);

                if (m == undefined) {
                   values = afilter.values
                } else {
                   values = '##date:'+a+':'+b+':'+m;
                }
                afilter.values = values;       
            } else
            if (omtFields2int[ afilter.name ].type == 'string') {
                var strcmpType = $('#adhoc_val_strcmp_'+afilter.name).val();
                var strvalRaw  = $('#adhoc_val_strval_'+afilter.name).val();
                var dedupResult = dedupAndCapValues(strvalRaw, ADHOC_STRING_MAX_VALUES);
                var strval     = dedupResult.text;
                if (dedupResult.dropped > 0) {
                  $('#adhoc_val_strval_'+afilter.name).val(strval);
                }
                //console.log('type string', afilter.name );
                //console.log(strcmpType, strval);
                values = '';
                if (strval != '' || (strcmpType == 'is <blank>' || strcmpType == 'is not <blank>')) {
                  values = '##str:' + strcmpType + ':' + strval;
                }
                afilter.values = values;
            } else
            if (omtFields2int[ afilter.name ].type === 'int' || omtFields2int[ afilter.name ].type === 'double') {
                var numCmpType = $('#adhoc_val_strcmp_'+afilter.name).val();
                var numVal     = $('#adhoc_val_strval_'+afilter.name).val();
                //console.log('type string', afilter.name );
                //console.log(strcmpType, strval);
                values = '';
                if (strval != '') {
                    values = '##' + omtFields2int[ afilter.name ].type + ':' + numCmpType + ':' + numVal;
                    console.log(values);
                }
                afilter.values = values;
              } else {
                if (cacheAdhocVals[ afilter.name ]) {
                
                   //console.log(afilter, cacheAdhocVals[afilter.name]);
                
                   cacheAdhocVals[afilter.name].forEach( function(afEntry) {
                  
                      if (afEntry.selected) {
                         values.push(afEntry.name);
                      }
                   });                             
                }
            }
            var internalFieldName = afilter.name;
            afilter.type = 'unknown';
            if (omtFields2int[afilter.name]) {
              internalFieldName = omtFields2int[afilter.name].internalField;
              afilter.type      = omtFields2int[afilter.name].type;
            }
            if (cacheAdhocVals[ afilter.name ]) {
              if (  afilter.values.length     != values.length
                 || afilter.values.toString() != values.toString()
              ) {
                adhocValuesChanged = true;
              }
            }

            // select aready exists, hence values contain the real selection
            if (cacheAdhocVals[ afilter.name ]) {
              afilter.values = values;
            }
            //self.setState({ Loading });
            return afilter;
          });
          
        if (adhocValuesChanged) {
          this.setState({ adhocFilters : adhocFilters });
        }
        return adhocFilters;
      }

      getNestedFilters(opt_cacheVals) {
    
        console.log('BMT_DEBUG getNestedFilters ...');

        var adhocFilters = this.getCurrentAdhocFilters();
        //console.log( this.getCurrentAdhocFilters() );
    
        if (typeof adhocFilters != "undefined" && adhocFilters != null && adhocFilters.length > 0) {  
        
          $('#matchingRows').css('color','#ddd');      
          $('#spinning_nested').show();
          
          var filterConditions = {
              profile: this.state.profileId,
              adhoc:   adhocFilters
          }

          var self = this;
          POST('/os/ossui/v1/in/omtNestedValues', filterConditions, function(resp) {
          
              console.log('omtNestedValues: resp=', resp);
  
              var filterMode = self.state.filterMode;
              
              if (opt_cacheVals === undefined || opt_cacheVals == null) {
                var cacheAdhocVals = {...self.state.cacheAdhocVals};
              } else {
                var cacheAdhocVals = {...opt_cacheVals};
              }
          
              for (var fld in resp.data) {
                  for (var cachefld in cacheAdhocVals) {
                      if (self.state.omtFields2int[cachefld] && self.state.omtFields2int[cachefld].internalField == fld) {
                          for (var i=0; i < cacheAdhocVals[cachefld].length; i++) {
                              var found = 0;
                              for (var j=0; j < resp.data[fld].length; j++) {
                                  if (cacheAdhocVals[cachefld][i].name == resp.data[fld][j]) {
                                      found = 1;
                                      break;
                                  }
                              }
                              if (filterMode == 'grey') {
                                  if (found) {
                                      cacheAdhocVals[cachefld][i].hide = false;    
                                      cacheAdhocVals[cachefld][i].disabled = false;    
                                  } else {
                                      cacheAdhocVals[cachefld][i].disabled = true;    
                                      cacheAdhocVals[cachefld][i].hide = false;    
                                  }
                              } else if (filterMode == 'no') {
                                      cacheAdhocVals[cachefld][i].hide = false;    
                                      cacheAdhocVals[cachefld][i].disabled = false; 
                              } else {
                                  if (found) {
                                      cacheAdhocVals[cachefld][i].hide = false;    
                                      cacheAdhocVals[cachefld][i].disabled = false;    
                                  } else {
                                      cacheAdhocVals[cachefld][i].hide = true;    
                                      cacheAdhocVals[cachefld][i].disabled = false;    
                                  }
                              }
                          }
                      }
                  }
              }
              var repaint = { repaint: new Date()};
              
              self.setState({ 
                cacheAdhocVals,
                repaint 
              });
                  
              $('#matchingRows').css('color','#777');
              if (resp.status == 'W') {
                $('#matchingRows').text(resp.message);
              } else {
                $('#matchingRows').text(numeral(resp.nrOfRealRows).format('0,0')  + ' rows');
              }
              
              $('#spinning_nested').hide();
          }, function(err, errText) {
              console.log('omtNestedValues: err/errText=', err, errText);
              $('#matchingRows').css('color','#f77');
              $('#spinning_nested').hide();
          });
  
        } else {
        
          $('#matchingRows').css('color','#777');    
          $('#matchingRows').text('all rows');                             
          $('#spinning_nested').hide();    
        } 
      }

      getSelectedOrders(includeItem) {

        var selected =  window.MainGrid.getSelectedRows();

        var lnoFieldIndex = "f_0"
        if (window.DrillDownData && window.DrillDownData[0] && window.DrillDownData[0]["f_1"] && window.DrillDownData[0]["f_1"].lno ) {
            var lnoFieldIndex = "f_1"
        }
        console.log('this.state.freezeViewSo=', this.state.freezeViewSo, lnoFieldIndex, includeItem, selected);

        if (includeItem) {
        
            var item_sln_col = -1;
            for (var j=0; j < this.state.drilldownData.internalColumns.length; j++) { 
                if (this.state.drilldownData.internalColumns[j] == "item_sln") {
                    item_sln_col = j-3;  // factor in hidden columns
                }
            }
            if (item_sln_col ==-1) {
                alert("You have to configure the 'Item No' column for the drilldown");
                return null;
            }
            var selOrders = {};
            for (var j=0; j < selected.length; j++) {
                var lno      = window.DrillDownData[selected[j]][lnoFieldIndex].lno;
                var item_sln = window.DrillDownData[selected[j]]['f_'+item_sln_col];
                if (typeof selOrders[lno] == "undefined") {
                    selOrders[lno] = []
                }
                if (selOrders[lno].indexOf(item_sln) == -1) {
                   selOrders[lno].push(item_sln);
                }
                
            }
            var orderList = Object.keys(selOrders);
            console.log('selOrders=', JSON.stringify(selOrders));
            return { orders: orderList, orderItems: selOrders };
            
        
        } else {
            var selOrders = {};
            for (var j=0; j < selected.length; j++) {
                selOrders[ window.DrillDownData[selected[j]][lnoFieldIndex].lno ] = 1;
            }
            var orderList = Object.keys(selOrders);
            console.log('orderList=', orderList);
            return { orders: orderList };
        }          
      }

      adhocFilterAdd(newFilter){
        console.log("BMT_DEBUG adhocFilterAdd newFilter added ", newFilter.name);

        let newEvent = [...this.state.logParams, {t:'BMTEvent',e:'BMT_onAddAdhocFilter', time: new Date()}];
        let adhocFilters = [...this.state.adhocFilters, newFilter];

        this.setState({
          adhocFilters: adhocFilters,
          logParams: newEvent
        }, () => {
          this.getOMTValues();
        })

      }

      adhocFilterRemove(i){
        console.log('BMT_DEBUG adhocFilterRemove', i);
        let newEvent = [...this.state.logParams, {t:'BMTEvent',e:'BMT_onRemoveAdhocFilter', time: new Date()}];
        let adhocFilters = [...this.state.adhocFilters];
        adhocFilters.splice(i, 1);
        this.setState({ 
          adhocFilters ,
          logParams: newEvent
        }, () => {
          this.getOMTValues();
        })
      }

      addToFavourite(newFilter){
        console.log("BMT_DEBUG addToFavourite, testing needed");

        if (this.state.myFavourites.length >= 10 ) {
           alert('Sorry, the maximum number of my favourites was already reached!');
           return;
        }
        let newEvent = [...this.state.logParams, {t:'BMTEvent',e:'BMT_onAddFavourite', time: new Date()}];
        this.setState(prevState => ({ 
          myFavourites: [...prevState.myFavourites, newFilter],
          logParams: newEvent
        }))
      }

      removeFromFavourite(i){
        console.log('delete favourite', i);

        let myFavourites = [...this.state.myFavourites];
        myFavourites.splice(i, 1);
        let newEvent = [...this.state.logParams, {t:'BMTEvent',e:'BMT_onRemoveFavourite', time: new Date()}];
        this.setState({ 
          myFavourites,
          logParams: newEvent
        });

      }

      updateAdhocFilters() {
        console.log("BMT_DEBUG updateAdhocFilters");
        let updNestedTimeout = setTimeout( this.getCurrentAdhocFilters, 3000);
      }

      updateNestedFilters(opt_cacheVals) { 
        console.log("BMT_DEBUG updateNestedFilters")
        $('#matchingRows').css('color','#eaa');
        this.getNestedFilters(opt_cacheVals);
      }

      handleDashboardChange(event) {
        console.log("BMT_DEBUG handleDashboardChange");
        
        let newEvent = [...this.state.logParams, {t:'BMTEvent',e:'BMT_onSelectDashboard', time: new Date()}];
        let newdashboardId = event.target.value

        this.setState({
          dashboardId: newdashboardId,
          logParams: newEvent,
          searchInitiator: "handleDashboardChange",
        }, () => {
          this.getAndShowDashboard();
        })

      }

      handleFilterModeChange(newMode) {
        console.log("BMT_DEBUG handleFilterModeChange to " + newMode);
        let oldMode = this.state.filterMode;
        let newEvent = [...this.state.logParams, {t:'BMTEvent',e:'BMT_onChangeFilterMode', time: new Date()}];
        this.setState({
          filterMode:newMode,
          logParams: newEvent
        }, () => {
          this.handleAdhocFilterChange(oldMode);
        }) 
      }

      handleDisplayValueChange(newDisplayValue) {
        console.log("BMT_DEBUG handleDisplayValueChange to " + newDisplayValue);
        let newEvent = [...this.state.logParams, {t:'BMTEvent',e:'BMT_onChangeDisplayMode', time: new Date()}];
        this.setState({
          displayValues:newDisplayValue,
          logParams: newEvent,
          searchInitiator: "handleDisplayValueChange",
        }, () => {
          this.getAndShowDashboard();
        }) 
      }

      handleMyPersonalDashboard() {

        if (this.state.myPersonalDashboard.length == 0){
          var myPersonalDashboard = [];
        } else {
          var myPersonalDashboard = [...this.state.myPersonalDashboard];
        }

        $("#myPersonalDashboardAlertList").tokenInput(
          this.state.alertNames, {
            hintText: "Start typing to find alert ...",
            noResultsText: "nothing found",
            searchingText: "searching...",
            propertyToSearch: "name",
            makeSortable: "yes",
            tokenQuote: "",
            zindex: 109999,
            //prePopulate: this.state.alertList
         }
        );

        $.each( myPersonalDashboard ,function( key, val ) {
          $('#myPersonalDashboardAlertList').tokenInput("add", {id: val.id, name: val.name});
        });
        $('#ossMyPersonalDashboardModal').modal( { backdrop: 'static'} );
      }

      handleSaveDashboardDetails() {
            console.log("handleSaveDashboardDetails");
            var selectedAlertValues = $('#myPersonalDashboardAlertList').tokenInput("get");
            console.log("selectedAlertValues : ");
            console.log(selectedAlertValues);
            var alerts = Object.keys(selectedAlertValues).sort().map(
                         function(elem) {
                             return {
                                name: selectedAlertValues[elem].name,
                                id:   selectedAlertValues[elem].id
                             }
                         }
                       );
            UserSettings.update('bm.myPersonalDashboard', alerts);
            $('#ossMyPersonalDashboardModal').modal('hide');

            let newEvent = [...this.state.logParams, {t:'BMTEvent',e:'BMT_onSaveDashboard', time: new Date()}];

            this.setState({
              myPersonalDashboard: [...alerts],
              logParams: newEvent,
              searchInitiator: "handleSaveDashboardDetails",
            }, () => {
              this.getAndShowDashboard();
            })
      }

      handleSaveMyFavs() {

          var inputList = $("#profileAlertDashboardAlertList").val();
          var selectedAlertValues = $('#profileAlertDashboardAlertList').tokenInput("get");

          console.log('selectedAlertValues', selectedAlertValues);

          let myFavourites = [...this.state.myFavourites]
          var alerts = Object.keys(selectedAlertValues).map(
                         function(elem) {
                             return {
                                id:   selectedAlertValues[elem].id,
                                name: selectedAlertValues[elem].name
                             }
                         }
                       );

          console.log(alerts);

          myFavourites = alerts;
          var profileList=[];
          $.each(myFavourites,function(key,val){
              profileList.push({
                name:     val.name,
                id:     val.id
              });
          });

          let newEvent = [...this.state.logParams, {t:'BMTEvent',e:'BMT_onChangeFavourite', time: new Date()}];
          this.setState({
            myFavourites: profileList,
            logParams: newEvent
          }, () => {
            UserSettings.update('bm.myFavourites', alerts);
            $('#ossMyFavouriteProfileModal').modal('hide');
          })

      }

      handleAdhocFilterChange(oldFilterMode) {
          console.log('BMT_DEBUG adhoc filters changed');

          if (this.state.filterMode == "no") {
            $('#matchingRows').text('');
           }

          if (this.state.filterMode == "no" && (oldFilterMode == "no" || typeof(oldFilterMode) == "object")) {
           // GEGA for now we dont do anything here, only when refresh button is pressed
           //this.updateAdhocFilters();
          } else if (event.type == 'react-click' || event.type == 'react-invokeguardedcallback') {
            //Case immediately update 
            console.log('BMT_DEBUG Case immediately update', event.type);
            this.updateNestedFilters();
          } else if (event.type == 'mousedown' && event.ctrlKey == true) {
            //Case multi select (5s wait time)
            $('#matchingRows').css('color','#ddd');
            $('#spinning_nested').show();
            console.log('BMT_DEBUG Case multi select with CTRL', event.type);
            if ( window.legacystate.userInputSession != null) {
              clearTimeout(window.legacystate.userInputSession); 
              window.legacystate.userInputSession = null;
            } 
            window.legacystate.userInputSession = setTimeout( this.updateNestedFilters, 5000);
          } else {//if (event.type == 'mousedown' && event.ctrlKey == false)  {
            //Case drag and drop (1s wait time)
            console.log('BMT_DEBUG Case drag and drop (1s wait time) / single handleSearchClick', event.type);
            if ( window.legacystate.userInputSession != null) {
              clearTimeout(window.legacystate.userInputSession); 
              window.legacystate.userInputSession = null;
            } 
            window.legacystate.userInputSession = setTimeout( this.updateNestedFilters, 1000);
          } 
      }

      handleMyPersonalClose() {
          $('#ossMyPersonalDashboardModal').modal('hide');
      }

      handleMyFavDialogClose() {
          $('#ossMyFavouriteProfileModal').modal('hide');
      }



      handleCustomizeFieldsChange(fields) {
          //console.log('handleCustomizeFieldsChange fields=',fields);

          var selected = [];

          selected.push('order_no');
          selected.push('overall_notes_lupd');
          selected.push('has_customer_notes');
          fields.map(function(elem) {
              selected.push(elem.value);
          });

          this.setState({
              drilldown: selected,
              showFieldCustomization: false
          });

          var bm = UserSettings.get('bm');
          var templateName = this.state.drilldownData ? this.state.drilldownData.templateName : "n\a";
          if (!bm.drilldownColumns) {
              bm.drilldownColumns = {};
          }
          bm.drilldownColumns[templateName] = selected;
          UserSettings.update('bm.drilldownColumns',bm.drilldownColumns);
          
          let drilldownDetails, drilldownExportExcelReqDetails, omtConditionsDetails;

          omtConditionsDetails           = {
            'adhoc'          : bm.adhocFilters,
            'profile'        : bm.profileId,
            'alert'          : this.state.drilldownExportExcelReq.alertid,
            'displayValues'  : bm.displayValues
          }
          drilldownDetails               = {
            'dashboardId'    : bm.dashboardId,
            'omtConditions'  : omtConditionsDetails,
            'tplName'        : templateName,
            'type'           : this.state.drilldownExportExcelReq.type,
          }
          drilldownExportExcelReqDetails = {
            'alertid'        : this.state.drilldownExportExcelReq.alertid,
            'alertname'      : this.state.drilldownExportExcelReq.alertname,
            'dilldownTplName': templateName,
            'type'           : this.state.drilldownExportExcelReq.type
          }

          var drillDownStateChange = this.drillDownStateChange;
          drillDownStateChange(drilldownDetails, null, true, drilldownExportExcelReqDetails);
          window.setTimeout(() => {
             POST('/os/ossui/v1/in/omtDetail', drilldownDetails, function(resp) {

               drillDownStateChange(drilldownDetails, resp.data, false, drilldownExportExcelReqDetails);

             });
          }, 2000)
      }

      handleCustomizeFieldsCancel() {
          console.log('handleCustomizeFieldsCancel');
          this.setState({
              showFieldCustomization: false 
          });
      }

      handleCustomize() {
          console.log('handleCustomize');
          this.setState({
              showFieldCustomization: true
          });
      } 

      handleMassUpdateCancel() {
          $('#ossMassUpdateModal').modal('hide');
      }

      handleMassUpdPlannerNotes() {
          var selection = this.getSelectedOrders(true);
          var massUpdateRequest = {
             action: 'plannerNotes',
             text: $('#mass_plannerNotes').val(),
             selection: selection,
             nextActionDate: $('#mass_nextPlannerActionDate').val(),
             replace: $('#replaceExistingPlannerNotes').prop('checked')
          }          
          $('#doingMassUpdate_plannerNotes').show();
          $('#massUpdateResult_plannerNotes').hide();        
          POST('/os/ossui/v1/in/runMassUpdate', massUpdateRequest, function(resp) {        
              console.log('massUpdateResponse=', resp);
              $('#doingMassUpdate_plannerNotes').hide();
              $('#massUpdateResult_plannerNotes').show();           
              $('#massUpdateResult_plannerNotes').html(resp.message);
          }); 
      }

      handleMassUpdCSRNotes() {

          var selection = this.getSelectedOrders(false);
          this.getSelectedOrders(false);
          var massUpdateRequest = {
             action: 'csrNotes',
             text: $('#mass_singleCsrNote').val(),
             selection: selection,
             nextActionDate: $('#nextActionDate').val(),
             replace: $('#replaceExistingCsrNotes').prop('checked')
          }
          $('#doingMassUpdate_csrNotes').show();
          $('#massUpdateResult_csrNotes').hide();        
          POST('/os/ossui/v1/in/runMassUpdate', massUpdateRequest, function(resp) {        
              console.log('massUpdateResponse=', resp);
              $('#doingMassUpdate_csrNotes').hide();
              $('#massUpdateResult_csrNotes').show();           
              $('#massUpdateResult_csrNotes').html(resp.message);
          }); 
      }

      handleMassUpdBackOfficeNotes() {

          var selection = this.getSelectedOrders(false);
          this.getSelectedOrders(false);
          var massUpdateRequest = {
             action: 'backOfficeNotes',
             text: $('#mass_singleBackOfficeNote').val(),
             selection: selection,
             nextActionDate: $('#mass_nextBackOfficeActionDate').val(),
             replace: $('#replaceExistingBackOfficeNotes').prop('checked')
          }
          $('#doingMassUpdate_backOfficeNotes').show();
          $('#massUpdateResult_backOfficeNotes').hide();
          POST('/os/ossui/v1/in/runMassUpdate', massUpdateRequest, function(resp) {
              console.log('massUpdateResponse=', resp);
              $('#doingMassUpdate_backOfficeNotes').hide();
              $('#massUpdateResult_backOfficeNotes').show();
              $('#massUpdateResult_backOfficeNotes').html(resp.message);
          });
      }

      handleMassUpdCustomerNotes() {

          var selection = this.getSelectedOrders(false);
          this.getSelectedOrders(false);
          var massUpdateRequest = {
             action: 'customerNotes',
             text: $('#mass_custNote').val(),
             selection: selection
          }
          $('#doingMassUpdate_customerNotes').show();
          $('#massUpdateResult_customerNotes').hide();        
          POST('/os/ossui/v1/in/runMassUpdate', massUpdateRequest, function(resp) {        
              console.log('massUpdateResponse=', resp);
              $('#doingMassUpdate_customerNotes').hide();
              $('#massUpdateResult_customerNotes').show();           
              $('#massUpdateResult_customerNotes').html(resp.message);
          }); 
      }
 
      handleMassUpdUserStatus(action, userStatus, selection, resultDiv) {

          this.getSelectedOrders(false);
          var massUpdateRequest = {
             action: action,
             user_status: userStatus,
             selection: selection
          }
          if (resultDiv != null) {
              $('#massMigration_result').html('triggering ...');
              $('#massMigration_result').show();
              POST('/os/ossui/v1/in/runMassUpdate', massUpdateRequest, function(resp) {        
                  console.log('massUpdateResponse=', resp);
                  $('#massMigration_result').html(resp.message);
              }); 
          } else { 
              $('#massUserStatus_result').html('triggering ...');
              $('#massUserStatus_result').show();
              POST('/os/ossui/v1/in/runMassUpdate', massUpdateRequest, function(resp) {        
                  console.log('massUpdateResponse=', resp);
                  $('#massUserStatus_result').html(resp.message);
              }); 
          }
      }

      handleMassUpdUserStatusHdrSet() {
        this.handleMassUpdUserStatus('userstatus_hdr_set', $('#mass_userstatus_hdr').val(), this.getSelectedOrders(false) );
      }

      handleMassUpdUserStatusHdrRemove() {
        this.handleMassUpdUserStatus('userstatus_hdr_rem', $('#mass_userstatus_hdr').val(), this.getSelectedOrders(false)  );
      }    

      handleMassUpdUserStatusItemSet() {
        this.handleMassUpdUserStatus('userstatus_item_set', $('#mass_userstatus_item').val(), this.getSelectedOrders(true) );
      }

      handleMassUpdUserStatusItemRemove() {
        this.handleMassUpdUserStatus('userstatus_item_rem', $('#mass_userstatus_item').val(), this.getSelectedOrders(true) );
      }

      handleMassUpdStartMigrationReserve() {
        this.handleMassUpdUserStatus('migrateItem', 'res', this.getSelectedOrders(true) , "massMigration_result");
      }
      handleMassUpdStartMigration() {
        this.handleMassUpdUserStatus('migrateItem', 'mig', this.getSelectedOrders(true) , "massMigration_result");
      }
      handleMassUpdStartMigrationReject() {
        this.handleMassUpdUserStatus('migrateItem', 'rej', this.getSelectedOrders(true) , "massMigration_result");
      }

      switchFreezeView() {
        this.setState({
          freezeViewSo: !this.state.freezeViewSo
        });
      }

      render() {

        var omtFields = this.state.omtFields;
        var drilldownData = this.state.drilldownData;


console.log('this.state.drilldown = ', this.state.drilldown);


        if (Object.keys(this.state.omtFields2int).length < 1) {
          //console.log("still fetching omt init data");
          return (
            <div id="initialLoading">
              <div id="loader" style={{"width": "60px","height": "60px","position": "fixed","margin": "auto","top": "0","bottom": "0","right": "0","left": "0","zIndex": "1000","display":"block"}}>
                <img id="spinningIcon" src={spinning_large}/>
              </div>
            </div> 
          )
        } else {

        var loadCSS = function(href) {
            var cssLink = $("<link href='"+href+"' rel='stylesheet'>");
            $("head").append(cssLink); 
        };
         
        if (UserSettings.tenant == "HPE") { 
          loadCSS("/static/assets/css/HPE/ossmainpage.css");
        } else {
          loadCSS("/static/assets/css/HPI/ossmainpage.css");
        }

        var templateName = drilldownData ? drilldownData.templateName : "n\a";
        var selectedColumns = [];
        var drDownCols = null;

        if (drilldownData && drilldownData.internalColumns) {
            drDownCols = drilldownData.internalColumns;        
            drDownCols.map(function(stdCol, pos) {
                if (pos < 3) return;
                var fullName = stdCol;
                var found = 0;
                for (var i=0; i< omtFields.length; i++) {
                    if (omtFields[i].internal == stdCol) {
                        fullName = omtFields[i].name;
                        found = 1;
                    }
                }
                if (!found) {
                    for (var i=0; i< omtFields.length; i++) {
                        if (omtFields[i].name == stdCol) {
                            fullName = omtFields[i].name;
                            stdCol = omtFields[i].internal;
                        }
                    }
                }
                if (pos ==3) {
                    selectedColumns.push ( {
                      name:     fullName,
                      value:    stdCol,
                      disabled: true
                    });
                    return;
                }
                selectedColumns.push ( {
                    name:  fullName,
                    value: stdCol
                } );
            });
        }


        var stdInternalColumns = [];
        if (drilldownData && drilldownData.stdInternalColumns) {
            drilldownData.stdInternalColumns.map(function(stdCol, pos) {
                if (pos < 3) return;
                var fullName = stdCol;
                for (var i=0; i< omtFields.length; i++) {
                    if (omtFields[i].internal == stdCol) {
                        fullName = omtFields[i].name;
                    }
                }
                stdInternalColumns.push( {
                  name:  fullName,
                    value: stdCol
                } );
            });
        }

        var availableColumns = omtFields.sort(function(a,b) {
             var aName = a.id;
             var bName = b.id;
             return (aName == bName) ? 0 : (aName > bName) ? 1 : -1;            
        }).map( function(omtField) {
             return {
                 name:  omtField.name,
                 value: omtField.internal
             }
        });


        var massUpdHeaderStati = [];
        var massUpdItemStati   = [];

        if (UserSettings.memberOf("RemoveBlocks")) {
            for (var i=0; i < UserSettings.config.BlockManagementSetup.length; i++ ) {
              if (UserSettings.config.BlockManagementSetup[i].tenant == this.state.UserSettings.tenant) {

                var blk = UserSettings.config.BlockManagementSetup[i]; 
                if (blk.level == "EditableHeaderUserStati") {
                    massUpdHeaderStati.push( <option value={blk.user_status}>{blk.user_status} - {blk.user_status_text} ({blk.block_category})</option> );
                }
                if (blk.level == "EditableItemUserStati") {
                    massUpdItemStati.push( <option value={blk.user_status}>{blk.user_status} - {blk.user_status_text} ({blk.block_category})</option> );
                }
              }
            }
        }

        return (
          <div>
            <ToastContainer position='bottom-right' /> 
            <OSSMenu active='backlog' user_id={this.state.UserSettings.user_id} tenant={this.state.UserSettings.tenant} userSettings={this.state.UserSettings} heading="Backlog Management Tool"/>

            <div id="spinningIcon" style={{ "display": "none", "position":"absolute",
                                            "position":"absolute", "top": "0px", "right": "0px",
                                            "padding":"3px", "backgroundColor":"#f8f8f8"}}>
              <img height="28" src={spinning_small}/>
            </div>
            <div id='blockTooltip' style={{display: 'none', 
                                           padding: '2px',
                                           backgroundColor: '#ee8888',
                                           color: 'white', zIndex: '100', fontSize: '10px',
                                           position: 'absolute'}}></div>
            <table className="omtPanels">
             <tbody>
              <tr>
                <td className="omtPanelLeft">
                  <SelectedDashboard //onChange={this.handleAdhocFilterChange} 
                                     alertNames={this.state.alertNames}
                                     handleDashboardChange={this.handleDashboardChange}
                                     handleMyPersonalDashboard= {this.handleMyPersonalDashboard}
                                     updateRecentProfile={this.updateRecentProfile}
                                     dashboardId={this.state.dashboardId}
                                     myPersonalDashboard={this.state.myPersonalDashboard}
                                     alertDashboards={this.state.alertDashboards}
                                     recentlyUsed={this.state.recentlyUsed}
                                     profileName={this.state.profileName}
                                     myFavourites={this.state.myFavourites}/>

                  <AdhocFilters onChange ={this.handleAdhocFilterChange} 
                                cacheAdhocVals ={this.state.cacheAdhocVals} 
                                omtFields2int ={this.state.omtFields2int} 
                                omtFields ={this.state.omtFields}
                                cacheLoading ={this.state.cacheLoading} 
                                adhocFilters = {this.state.adhocFilters} 
                                adhocFilterAdd ={this.adhocFilterAdd} 
                                repaint ={this.state.repaint}
                                adhocFilterRemove ={this.adhocFilterRemove}/>

                  <ShowAlerts //onChange={this.handleAdhocFilterChange} 
                              dashboardId={this.state.dashboardId}
                              cachedAlerts={this.state.cachedAlerts}
                              eraseCachedAlerts={this.eraseCachedAlerts}
                              getCurrentAdhocFilters={this.getCurrentAdhocFilters}
                              getAndShowDashboard={this.handleGetAndShowDashboard}
                              alertNumbersLoading={this.state.alertNumbersLoading}
                              profileId={this.state.profileId}
                              displayValues={this.state.displayValues}
                              adhocFilters={this.state.adhocFilters}
                              filterMode={this.state.filterMode}
                              handleFilterModeChange={this.handleFilterModeChange}
                              handleDisplayValueChange={this.handleDisplayValueChange}
                              alertList={this.state.alertList}
                              drillDownStateChange={this.drillDownStateChange}
                              drilldown = {this.state.drilldown}
                              drilldownTplName={this.state.drilldownTplName}
                              drilldownExportExcelReq={this.state.drilldownExportExcelReq}
                              alertDashboards={this.state.alertDashboards} />
                </td>

                <td id='drilldownPanel' className="omtPanelRight">
                  <DrillDownArea loadingDrilldown={this.state.loadingDrilldown} 
                                 drilldown={this.state.drilldown}
                                 drilldownData={this.state.drilldownData}
                                 omtFields2Header={this.state.omtFields2Header}
                                 omtFields2int={this.state.omtFields2int}
                                 drilldownExportExcelReq={this.state.drilldownExportExcelReq}
                                 onCustomize={this.handleCustomize}
                                 drillDownStateChange={this.drillDownStateChange}
                                 switchFreezeView={this.switchFreezeView}
                                 freezeViewSo={this.state.freezeViewSo}
                  />
                </td>
              </tr>
             </tbody>
            </table>

            <div id="profileListModal" className="modal">
              <div className="modal-dialog modal-lg">
                <ProfilesList //onChange={this.handleAdhocFilterChange} 
                              addToFavourite={this.addToFavourite}
                              removeFromFavourite={this.removeFromFavourite}
                              updateRecentProfile={this.updateRecentProfile}
                              myFavourites={this.state.myFavourites}/>
              </div>
            </div>
            <ul id="PrefMenu" className="pref-popup-menu"></ul>
            <div id="notesbody" />
            <div id="remblockbody" />

            <GlobalFooter />

            <div className="modal" id="ossMyPersonalDashboardModal">
              <div className="modal-dialog modal-lg">
                  <div className="modal-content">
                      <div className="modal-header">
                          <button type="button" className="close" data-dismiss="modal" aria-hidden="true" onClick={this.props.handleClose}>x</button>
                          <h3 className="modal-title">My Personal Dashboard</h3>
                      </div>

                      <div className="modal-body">
                          <form className="form-horizontal" role="form">
                            <div className="form-group">
                                <label htmlFor="inputMyPersonalDashboardAlertList" className="col-sm-2 control-label">Alert list</label>
                                <div className="col-sm-5">
                                    <input type="text" id="myPersonalDashboardAlertList" name="myPersonalDashboardAlertList"/>
                                </div>
                            </div>
                          </form>
                      </div>
                      <div className="modal-footer">
                        <button type="button" onClick={this.handleSaveDashboardDetails} className="btn btn-danger">Save</button>
                        <button type="button" onClick={this.handleMyPersonalClose}      className="btn btn-info">Cancel</button>
                      </div>

                  </div>
              </div>
            </div>
            
            <div className="modal" id="remblockModal">
              <div className="modal-dialog modal-lg" style={{ "width": "905px", "marginTop": "45px" }}>
                  <div className="modal-content">
                     <div className="modal-header">
                          <button type="button" className="close" data-dismiss="modal" aria-hidden="true" onClick={this.props.handleClose}>x</button>
                          <h3 className="modal-title">Removing Block</h3>
                      </div>
                      <div className="modal-body">
                            <form className="form-horizontal" role="form" style={{ "padding": "20px 0px 20px 0px"}}>
                              <div className="form-group">
                                  <label id="removingBlock" htmlFor="inputProfileAlertDashboardAlertList" className="col-sm-4 control-label">Remove block 2BDB on item </label>
                                  &nbsp;&nbsp;
                                  <img id="spinningIconRemoveBlock" style={{ "display": "none"}} height="28" src={spinning_small}/>
                                  <label id="doneRemovingBlock" htmlFor="inputProfileAlertDashboardAlertList" className="col-sm-5 ">Done! </label>
                                  </div>
                                  <br/>
                                  <div className="form-group" id="spinningIconRefreshingOrder" style={{ "display": "none"}}>
                                    <label className="col-sm-4 control-label">
                                    refreshing order ... &nbsp;&nbsp;
                                    <img height="28" src={spinning_small}/>
                                    &nbsp;&nbsp;
                                   </label>
                                  </div>
                            </form>
                            <p>
                              <br/>
                              <br/>
                            </p>
                      </div>
                      <div className="modal-footer">
                         <button type="button" data-dismiss="modal" className="btn btn-info">Close</button>
                      </div>
                  </div>
               </div>
            </div>

            
            <div className="modal" id="reprocessIdocModal">
              <div className="modal-dialog modal-lg" style={{ "width": "800px", "marginTop": "140px" }}>
                  <div className="modal-content">
                     <div className="modal-header">
                          <button type="button" className="close" data-dismiss="modal" aria-hidden="true" onClick={this.props.handleClose}>x</button>
                          <h3 className="modal-title">Reprocess IDOC</h3>
                      </div>
                      <div className="modal-body">
                 
                              <div style={{ "padding": "10px"}}>
                                  <div id="reprocessIdocAwait" style={{ "display": "none"}}>
                                    <label className="col-sm-4 control-label">
                                    requesting IDOC reprocessing ... &nbsp;&nbsp;
                                    <img height="28" src={spinning_small}/>
                                    &nbsp;&nbsp;
                                   </label>
                                  </div>
                                  <div id="reprocessIdocResult" style={{"display": "none"}} >
                                      the result...
                                  </div>                                                      

                              </div>
                            <p>
                              <br/>
                              <br/>
                            </p>
                      </div>
                      <div className="modal-footer">
                         <button type="button" data-dismiss="modal" className="btn btn-info">Close</button>
                      </div>
                  </div>
               </div>
            </div>

            
            <div className="modal" id="ossMyFavouriteProfileModal">
              <div className="modal-dialog modal-lg" style={{ "width": "900px" }}>
                  <div className="modal-content">
                      <div className="modal-header">
                          <button type="button" className="close" data-dismiss="modal" aria-hidden="true" onClick={this.props.handleClose}>x</button>
                          <h3 className="modal-title">My Favourite Profiles</h3>
                      </div>
                      <div className="modal-body">
                            <form className="form-horizontal" role="form" style={{ "padding": "20px 0px 20px 0px"}}>
                                  <div className="form-group">
                                    <label htmlFor="inputProfileAlertDashboardAlertList" className="col-sm-2 control-label">Profile list</label>
                                    <div className="col-sm-8">
                                        <input type="text" id="profileAlertDashboardAlertList" name="profileAlertDashboardAlertList"/>
                                    </div>
                                    <div className="col-sm-2">
                                        Up to 10 favourites can be kept.
                                    </div>
                                  </div>
                            </form>
                            <p>
                              <br/>
                              <br/>
                            </p>
                      </div>
                      <div className="modal-footer">
                        <button type="button" onClick={this.handleSaveMyFavs}   className="btn btn-danger">Save</button>
                        <button type="button" onClick={this.handleMyFavDialogClose} className="btn btn-info">Cancel</button>
                      </div>
                  </div>
                </div>
            </div>
  
            { this.state.showFieldCustomization ? 
               <FieldsCustomizer caller="BMT"
                                 templateName={templateName}
                                 standardColumns={stdInternalColumns}
                                 selectedColumns={selectedColumns}
                                 availableColumns={availableColumns} 
                                 onChange={this.handleCustomizeFieldsChange}
                                 onCancel={this.handleCustomizeFieldsCancel}
                                 showValues={true}
               /> 
               : null
            }


            <div className="modal" id="ossMassUpdateModal">
              <div className="modal-dialog modal-lg" style={{ "width": "900px" }}>
                 <div className="modal-content">
                      <div className="modal-header">
                          <button type="button" className="close" data-dismiss="modal" aria-hidden="true">x</button>
                          <h3 className="modal-title">Mass Update for  Orders/Items</h3>
                      </div>
                      <div className="modal-body" style={{"height":"370px", "overflow":"auto", "maxHeight": "370px"}}>
                        <br/>
                        <TabBar id="massUpdateTab"> 

                           <Tab active name="massUpdatePlannerNotes" label={T('Planner Notes')}>
                              <br/>
                              <div className="row" style={{ "padding": "4px"}}> 
                                  <div className="col-sm-2">Planner Notes:</div>
                                  <div className="col-sm-8">                                                
                                    <textarea id="mass_plannerNotes" className="form-control" placeholder="Leave a planner note ..."
                                      rows="" ref="plannerNotes"                                                                 
                                      style={{ "fontSize": "12px", "height": "15ex",  "marginBottom": "0px"}}
                                    ></textarea> 
                                  </div>
                              </div>
                              <div className="row" style={{ "padding": "4px"}}> 
                                  <div className="col-sm-2">
                                  </div> 
                                  <div className="col-sm-8">
                                      <label style={{ "fontWeight": "500"}}>
                                          <input type="checkbox" id="replaceExistingPlannerNotes" value="1" style={{"marginRight":"4px"}}/>
                                          Replace (existing) note
                                      </label>
                                  </div>
                              </div>         
                              <div className="row" style={{ "padding": "4px"}}> 
                                  <div className="col-sm-2">
                                     next action date:
                                  </div> 
                                  <div className="col-sm-8">
                                        <DateChooser id="mass_nextPlannerActionDate" dateValue="" placeholder="" 
                                          style={{"display":"inline", "width":"12ex", "fontSize":"12px", "padding":"5px" }}/>
                                  </div>
                              </div>         
                              <div className="row" style={{ "padding": "4px"}}> 
                                  <div className="col-sm-2">
                                  </div> 
                                  <div className="col-sm-8">
                                      <button id="updatePlannerNotesBtn" 
                                              onClick={this.handleMassUpdPlannerNotes}
                                              className="btn btn-danger btn-sm">update Planner Notes</button>
                                  </div> 
                              </div>
                              <div style={{'paddingTop':'15px'}}>
                                  <div id="doingMassUpdate_plannerNotes">
                                     Updating order/items ... <img height="16" src={spinning_small} />
                                  </div>
                                  <div id="massUpdateResult_plannerNotes">
                                     the result...
                                  </div>                                                      
                              </div>
                           </Tab>

                           <Tab name="massUpdateCSRNotes" label={T('CSR Notes')}>
                              <br/>
                              <div className="row" style={{ "padding": "4px"}}> 
                                  <div className="col-sm-2">CSR Notes:</div>
                                  <div className="col-sm-8">                                                
                                    <textarea id="mass_singleCsrNote" className="form-control" placeholder="Leave an internal visible note (to CSRs ...)"
                                      rows="" ref="mass_singleCsrNote"                                                                 
                                      style={{ "fontSize": "12px", "height": "15ex",  "marginBottom": "0px"}}
                                    ></textarea> 
                                  </div>
                              </div>
                              <div className="row" style={{ "padding": "4px"}}>
                                  <div className="col-sm-2">
                                  </div>
                                  <div className="col-sm-8">
                                      <label style={{ "fontWeight": "500"}}>
                                          <input type="checkbox" id="replaceExistingCsrNotes" value="1" style={{"marginRight":"4px"}}/>
                                          Replace (existing) note
                                      </label>
                                  </div>
                              </div>
                              <div className="row" style={{ "padding": "4px"}}>
                                  <div className="col-sm-2">
                                     next action date:
                                  </div> 
                                  <div className="col-sm-8">
                                        <DateChooser id="nextActionDate" dateValue="" placeholder="" 
                                          style={{"display":"inline", "width":"12ex", "fontSize":"12px", "padding":"6px" }}/>
                                  </div>
                              </div>         
                              <div className="row" style={{ "padding": "4px"}}> 
                                  <div className="col-sm-2">
                                  </div> 
                                  <div className="col-sm-8">
                                      <button id="updateCSRNotesBtn" 
                                              onClick={this.handleMassUpdCSRNotes}
                                              className="btn btn-danger btn-sm">update CSR notes</button>
                                  </div> 
                              </div>
                              <div style={{'paddingTop':'15px'}}>
                                  <div id="doingMassUpdate_csrNotes">
                                     Updating order/items ... <img height="16" src={spinning_small} />
                                  </div>
                                  <div id="massUpdateResult_csrNotes">
                                     the result...
                                  </div>                                                      
                              </div>
                           </Tab>

                          <Tab name="massUpdateBackOfficeNotes" label={T('Back Office Notes')}>
                              <br/>
                              <div className="row" style={{ "padding": "4px"}}>
                                  <div className="col-sm-2">Back Office Notes:</div>
                                  <div className="col-sm-8">
                                    <textarea id="mass_singleBackOfficeNote" className="form-control" placeholder="Leave an internal visible note (to Back Office ...)"
                                      rows="" ref="mass_singleBackOfficeNote"
                                      style={{ "fontSize": "12px", "height": "15ex",  "marginBottom": "0px"}}
                                    ></textarea>
                                  </div>
                              </div>
                              <div className="row" style={{ "padding": "4px"}}>
                                  <div className="col-sm-2">
                                  </div>
                                  <div className="col-sm-8">
                                      <label style={{ "fontWeight": "500"}}>
                                          <input type="checkbox" id="replaceExistingBackOfficeNotes" value="1" style={{"marginRight":"4px"}}/>
                                          Replace (existing) note
                                      </label>
                                  </div>
                              </div>
                              <div className="row" style={{ "padding": "4px"}}>
                                  <div className="col-sm-2">
                                     next action date:
                                  </div>
                                  <div className="col-sm-8">
                                        <DateChooser id="mass_nextBackOfficeActionDate" dateValue="" placeholder=""
                                          style={{"display":"inline", "width":"12ex", "fontSize":"12px", "padding":"6px" }}/>
                                  </div>
                              </div>
                              <div className="row" style={{ "padding": "4px"}}>
                                  <div className="col-sm-2">
                                  </div>
                                  <div className="col-sm-8">
                                      <button id="updateBackOfficeNotesBtn"
                                              onClick={this.handleMassUpdBackOfficeNotes}
                                              className="btn btn-danger btn-sm">update Back Office notes</button>
                                  </div>
                              </div>
                              <div style={{'paddingTop':'15px'}}>
                                  <div id="doingMassUpdate_backOfficeNotes">
                                     Updating order/items ... <img height="16" src={spinning_small} />
                                  </div>
                                  <div id="massUpdateResult_backOfficeNotes">
                                     the result...
                                  </div>
                              </div>
                           </Tab>


                           <Tab name="massUpdateCustomerNotes" label={T('Customer Notes')}>
                              <br/>
                              <div className="row" style={{ "padding": "4px"}}> 
                                  <div className="col-sm-2">Customer Notes:</div>
                                  <div className="col-sm-8">                                                
                                    <textarea id="mass_custNote" className="form-control" placeholder="Leave an external visible note to the customer"
                                      rows="" ref="mass_custNote"                                                                 
                                      style={{ "fontSize": "12px", "height": "15ex",  "marginBottom": "0px"}}
                                    ></textarea> 
                                  </div>
                              </div>
                              <div className="row" style={{ "padding": "4px"}}> 
                                  <div className="col-sm-2">
                                  </div> 
                                  <div className="col-sm-8">
                                      <button id="updateCustomerNotesBtn"
                                              onClick={this.handleMassUpdCustomerNotes} 
                                              className="btn btn-danger btn-sm">update Customer Notes</button>
                                  </div> 
                              </div>
                              <div style={{'paddingTop':'15px'}}>
                                  <div id="doingMassUpdate_customerNotes">
                                     Updating order/items ... <img height="16" src={spinning_small} />
                                  </div>
                                  <div id="massUpdateResult_customerNotes">
                                     the result...
                                  </div>                                                      
                              </div>
                           </Tab>

                           <Tab name="massUpdateUserStatus" label={T('Set / Remove User Status')}>
                              <br/>                                                               
                              <div className="row" style={{ "padding": "4px"}}>
                                  <div className="col-sm-2">User Status:</div> 
                                  <div className="col-sm-8">                  
                                    <TabBar id="userStatusLevel">
                                      <Tab active name="hdrUserStatus" label={T('Header User Status')}>
                                        <div style={{padding: "30px", "backgroundColor": "#f4f4f4"}}>
                                            <select id="mass_userstatus_hdr">
                                               {massUpdHeaderStati}
                                            </select>                                                                    
                                            <br/>
                                            <br/>
                                            <button id="setMassHdrUserStatus" onClick={this.handleMassUpdUserStatusHdrSet}
                                                        className="btn btn-danger btn-sm">Set Header Status</button>
                                            &nbsp;&nbsp;&nbsp;                                                  
                                            <button id="remMassHdrUserStatus" onClick={this.handleMassUpdUserStatusHdrRemove}
                                                        className="btn btn-danger btn-sm">Remove Header Status</button>
                                        </div>                                                                     
                                      </Tab>  
                                            
                                      <Tab name="itemUserStatus" label={T('Item User Status')}>
                                        <div style={{padding: "30px", "backgroundColor": "#f4f4f4"}}>
                                            <select id="mass_userstatus_item">                          
                                               {massUpdItemStati}
                                            </select>                                                                    
                                            <br/>
                                            <br/>
                                            <button id="setMassItemUserStatus" onClick={this.handleMassUpdUserStatusItemSet}
                                                        className="btn btn-danger btn-sm">Set Item Status</button>
                                             &nbsp;&nbsp;&nbsp;                                                
                                             <button id="remMassItemUserStatus" onClick={this.handleMassUpdUserStatusItemRemove} 
                                                        className="btn btn-danger btn-sm">Remove Item Status</button>
                                        </div>                                                                   
                                      </Tab>  
                                    </TabBar>
                                    <br/>
                                    <br/>
                                    <div id="massUserStatus_result">
                                      the result...
                                    </div>                                                      
                                    
                                  </div>     
                              </div>    
                           </Tab>                                     
                        </TabBar>
                                 
                        
                        
                      </div>
                      <div className="modal-footer">
                         <button type="button" onClick={this.handleMassUpdateCancel} className="btn btn-info">Close</button>
                      </div>
                 </div>
                </div>
            </div>
             { this.state.showObsoleteMsg 
             ? <div onClick={this.handleObsoleteMessageClick} style={{
                  padding: "80px 120px",
                  position: "fixed",
                  top: "37px", left: "4px", right: "4px", bottom: "20px",
                  backgroundColor: "#0096d6", color: "#fff",
                  fontWeight: 300,
                  fontSize: "22px"
                }}>
                  To OSS General  users,  
                  <br/>
                  <br/>
                  As part of the continuous transformation efforts led by the Order to Cash
                  Center of Excellence team we have rolled out our latest BMT UI version.
                  <br/>
                  You can access the new version directly through this
                  &nbsp;
                  <a href="/static/dist/bmt.html" style={{color:"#fef"}}><b>LINK</b></a>
                  &nbsp;
                  or same as before via the OSS main menu under the backlog section. 
                  <br/>
                  <br/>
                  The new UI offers you many advantages:  new graphical components that allow
                  automatic aggregation of one or several data points, enhanced flexibility on
                  the UI elements, a new layout that maximizes screen usage and overall a
                  higher level of customization. 
                  <br/>
                  <br/>
                  Have a look and let us know if you need any support via tech direct or
                  through your OSS SMEs. 
                  <br/>
                  <br/>  
                  Best Regards<br/>
                  <br/>
                  OSS WW OTC CoE. 
                </div>
             : null 
             }
             </div>

        )
        }
      }
    };


    //------------------------------------------------------------------------
    //  Profile List
    //
    //------------------------------------------------------------------------
    export class ProfilesList extends React.PureComponent {

      constructor(props) {
        super(props);
    
        this.state = {
          folderPath: "",
          previousStructure: {},
          parent: "",
          search: false,
          searchProfileName: "",
          searchResult: [],
          profile_name: "",
          treeStructureChange: null,
          treeStructure: {},
          initialStructure: {},
          profileResult: [],
          profileInfoLoading: true
        };
    
        this.handleClick                = this.handleClick.bind(this);
        this.handleSingleClick          = this.handleSingleClick.bind(this);
        this.handleSearchClick          = this.handleSearchClick.bind(this);
        this.handleSaveProfile          = this.handleSaveProfile.bind(this);
        this.handleImageClick           = this.handleImageClick.bind(this);
        this.handleClose                = this.handleClose.bind(this);
        this.handleText                 = this.handleText.bind(this);
        this.handleSearchInFolder       = this.handleSearchInFolder.bind(this);
        this.handleRemoveFromFavourite  = this.handleRemoveFromFavourite.bind(this);
        this.handleAddToFavourite       = this.handleAddToFavourite.bind(this);
        this.handleInfo                 = this.handleInfo.bind(this);
        this.handleBrowse               = this.handleBrowse.bind(this);
        this.handleSearch               = this.handleSearch.bind(this);
      };

      componentDidMount() {

        console.log("ProfilesList Mount")
        var profileNames = [];
        var self = this;

        GET('/os/ossui/v1/in/profileInfo',{caller:"profileSearchModal"}, function(response4) {
          let treeStructure = OSWidgetLib.formDataStructure(response4.data);
          let initialStructure = treeStructure;
          let profileResult = response4.data;
        
          $.each(response4.data,function(key,val){
            profileNames.push({
                name:     val.alert_profile_name,
                id: val.alert_profile_id
              });
          });
        
          console.log('profileInfo loaded!', profileNames);
        
          self.setState({
            profileNames: profileNames,
            profileResult:profileResult,
            profileInfoLoading: false,
            treeStructure: treeStructure ,
            initialStructure: initialStructure
          }, () => {
            self.props.availableProfiles(profileNames);
          });

        });

      }
    
      handleTreeStructureChange(value){
        console.log("BMT_DEBUG handleTreeStructureChange");
        //this.props.treeStructureChange(e);
        this.setState(prevState => ({ 
          treeStructure: value
        }))    
      }
    
      split( val ) {
        return val.split( /,\s*/ );
      }      
    
      handleClick(e,key) {
        console.log("BMT_DEBUG handleClick");
          if (this.state.treeStructure[e]!=undefined) {
            this.handleTreeStructureChange(this.state.treeStructure[e]);
          } else {
            this.handleTreeStructureChange(this.state.previousStructure);
          }

          let folderPath = this.state.folderPath+"/"+e
    
          this.setState({
            folderPath: folderPath,
            parent: e,
          });
      }
    
      handleSingleClick(e,index,folders,initialStructure) {
        console.log("BMT_DEBUG handleSingleClick");
          var folders = folders.splice(0,index);
          let folderPath = folders.join("/");
          let previousStructure = {...this.state.previousStructure}
        
          //alert(folders.length);
          //alert(JSON.stringify(state.initialStructure));
    
          if(folders.length == 1) {
              this.handleTreeStructureChange(this.state.initialStructure)
          }else if(folders.length == 2) {
              previousStructure = this.state.initialStructure;
              this.handleTreeStructureChange(this.state.initialStructure[folders[1]]);
    
          }else if(folders.length == 3) {
              previousStructure = this.state.initialStructure[folders[1]];
              this.handleTreeStructureChange(this.state.initialStructure[folders[1]][folders[2]]);
    
          }else if(folders.length == 4) {
              previousStructure = this.state.initialStructure[folders[1]][folders[2]];
              this.handleTreeStructureChange(this.state.initialStructure[folders[1]][folders[2]][folders[3]]);
          }
    
          this.setState({
            folderPath:folderPath,
            previousStructure:previousStructure
          });
      }
    
      handleSearchClick(e,index,folders,initialStructure) {
        console.log("BMT_DEBUG handleSearchClick");
          if (this.state.search) {
            var search = false;
          }
    
          var folders = folders.splice(0,index);
          let folderPath="/"+folders.join("/");
          let previousStructure = {...this.state.previousStructure}
    
          if(folders.length == 1) {
              previousStructure = this.state.initialStructure
              this.handleTreeStructureChange(this.state.initialStructure[folders[0]]);
    
          }else if(folders.length == 2) {
    
              previousStructure = this.state.initialStructure[folders[0]];
              this.handleTreeStructureChange(this.state.initialStructure[folders[0]][folders[1]]);
    
          }else if(folders.length == 3) {
              previousStructure = this.state.initialStructure[folders[0]][folders[1]];
              //alert(folders[1]+"==="+folders[2]);
    
              this.handleTreeStructureChange(this.state.initialStructure[folders[0]][folders[1]][folders[2]]);
               //alert(JSON.stringify(state.treeStructure));
    
          }else if(folders.length == 4) {
              previousStructure = this.state.initialStructure[folders[0]][folders[1]][folders[2]];
              this.handleTreeStructureChange(this.state.initialStructure[folders[0]][folders[1]][folders[2]][folders[3]]);
          }
    
          this.setState({
            folderPath:folderPath,
            search:search,
            previousStructure:previousStructure
          });
       
          $('#folderStructure').removeClass('hide');
    
      }
    
      handleSaveProfile(e, profile_id, profile_name, key) {
        console.log("BMT_DEBUG handleSaveProfile");
        this.props.updateRecentProfile(profile_id, profile_name);
        $('#profileListModal').modal('hide');
      }
    
      handleImageClick(e){
        console.log("BMT_DEBUG handleImageClick");
    
          var folders = this.state.folderPath.split(/\//);
          folders = folders.splice(0,folders.length-1);
          let folderPath = folders.join("/");
    
          if(folders.length == 1) {
    
            this.handleTreeStructureChange(this.state.initialStructure);
    
          }else if(folders.length == 2) {
    
            this.handleTreeStructureChange(this.state.initialStructure[folders[1]]);
    
          }else if(folders.length == 3) {
    
            this.handleTreeStructureChange(this.state.initialStructure[folders[1]][folders[2]]);
    
          }else if(folders.length == 4) {
    
            this.handleTreeStructureChange(this.state.initialStructure[folders[1]][folders[2]][folders[3]]);
          }
    
          this.setState({folderPath:folderPath});
      }
    
      handleClose(e) {
        console.log("BMT_DEBUG handleClose");
        $('#profileListModal').modal('hide');
      }
    
      handleText(e) {
        console.log("BMT_DEBUG handleText");
        this.setState({profile_name:e.target.value})
      }
    
      handleSearchInFolder(e) {
        console.log("BMT_DEBUG handleSearchInFolder");
        let searchProfileName = e.target.value.toLowerCase();
    
        if(this.state.folderPath != "") {
          let folders = this.state.folderPath.split(/\//);
          let folderPath = folders.join("/");
          this.setState({
            folderPath: folderPath,
          });          
        }
        if (searchProfileName.length > 2) {
          this.setState({searchProfileName:searchProfileName});
        } else {
          //setTimout( rerender, 3000);
          console.log("BMT_DEBUG DEAD END? handleSearchInFolder 2");
        }
      }
    
      handleRemoveFromFavourite(profile_id, profile_name) {
        console.log("BMT_DEBUG handleRemoveFromFavourite");
        this.props.removeFromFavourite({profile_id, profile_name});
      }
    
      handleAddToFavourite(profile_id, profile_name) {
        console.log("BMT_DEBUG handleAddToFavourite");
   
        let profile = {
                        id : profile_id,
                        name: profile_name
                      }
                      
        this.props.addToFavourite(profile);
      }
    
      handleInfo(key) {
        console.log("BMT_DEBUG handleInfo");
        console.log(key);
        var url = '/os/int/profileInfo.html';
        var form = document.createElement("form");
        var mapInput = document.createElement("input");
    
        mapInput.type = "hidden";
        mapInput.name = "id";
        mapInput.value = key;
        form.appendChild(mapInput);
        form.setAttribute("action",url);
        form.setAttribute("method","GET");
        form.setAttribute("target","_blank");
    
        document.body.appendChild(form);
        form.submit();
        document.body.removeChild(form);
      }
      handleBrowse(e) {
        console.log("BMT_DEBUG handleBrowse");
        if (this.state.search) {
          var search = false;
        }
    
        this.setState({
          folderPath:"",
          search:search,
        });
    
        $("#profilename").val('');
        $("#folderStructure").removeClass('hide');
        $("#profileTableId").addClass('hide');
        $("#profileSearchResult").addClass('hide');
    
      }
      handleSearch(e) {
        console.log("BMT_DEBUG handleSearch");
          var params = "name="+this.state.profile_name;
          let searchResult = [];
          var self = this;

          $("#folderStructure").addClass('hide');
    
          var i = 0;
          console.log(JSON.stringify(this.state.profile_name));
    
          if(this.state.profile_name != undefined && this.state.profile_name.length>=2) {
            let search = true;
            $('#searchAlert').html("");
            $('#searchAlert').removeClass("alert alert-danger");
    
            this.state.profileResult.map(function(row) {
                if(row.alert_profile_name.toLowerCase().indexOf(self.state.profile_name.toLowerCase()) > -1) {
                  i++;
                  $("#profileTableId").removeClass('hide');
                  $("#profileSearchResult").addClass('hide');
                    searchResult.push(row);
                    self.handleTreeStructureChange(OSWidgetLib.formDataStructure(searchResult));
                }
                if(i == 0){
                  $("#profileSearchResult").removeClass('hide');
                  $("#profileTableId").addClass('hide');
                }
            });
            this.setState({
              search:search,
              searchResult: searchResult,
            });
            $('#highlight-plugin').removeHighlight();
          } else {
            $("#profileTableId").addClass('hide');
            $('#searchAlert').html("Please enter minimum 2 characters to search.");
            $('#searchAlert').addClass("alert alert-danger");
          }
    
      }
    
      render() {

        if (this.state.profileInfoLoading) {
          return (
            <div className="modal-content">
              <div className="modal-header">
                <button type="button" className="close" data-dismiss="modal" aria-hidden="true" onClick={this.handleClose}>x</button>
                <h3 className="modal-title">Select / Search Profile</h3>
              </div>
              <div className="modal-body">
               Profile data is still loading. Please re-try in a few seconds!
              </div>
             <div className="modal-footer">
                <button type="button" className="btn btn-primary" data-dismiss="modal" onClick={this.handleClose}>Close</button>
             </div>
            </div>
          )
        }
    
          var profileFolders = [];
          var folders = [];
          if(this.state.folderPath != "") {
              folders = this.state.folderPath.split(/\//);
          }
          var previousStructure = this.state.previousStructure;
          var fpath = ""
          var table = "";
          var cpath = "";
          var firstPath = "";
    
          var upfolder=
                  <a href="#" onClick={this.handleImageClick}>
                  <i className="glyphicon glyphicon-chevron-left" style={{"color": "#0096d6" }}/></a>;
    
          var i = 0;
          cpath= folders.map(function(folder) {
              i = i+1
              return (
                <span>
                  <a href="#" onClick={this.handleSingleClick.bind(this,folder,i,folders,this.state.initialStructure)}>{folder}</a>
                  &nbsp;/&nbsp;
                </span>
              );
          }.bind(this));
    
          var sourcePath = Object.keys(this.state.treeStructure).map(function(key,index) {
    
          if(key.toLowerCase().indexOf(this.state.searchProfileName) > -1) {
    
            if(this.state.treeStructure[key].type==undefined) {
    
                return (
                  <tr key={key}>
                  <td colSpan="3"><i className="glyphicon glyphicon-folder-open" style={{ "color": "#0096d6", "fontSize": "13px", "marginRight": "8px"}}/>
                      <a href="#" onClick={this.handleClick.bind(this,key,index)}>
                    {key}</a></td>
                  </tr>
                );
            } else
            if (this.state.treeStructure[key].type != undefined) {
                var typeValue = key;
                var profile_id = this.state.treeStructure[key].profile_id;
                var profile_name = this.state.treeStructure[key].profile_name;
                //GEGA WHTS THIS URL?
                var url="/os/int/profileInfo.html?id="+profile_id;
    
                var fav = null;
                var favFound = false;
                if (this.props.myFavourites != undefined) {
                  for (var k=0; k < this.props.myFavourites.length; k++) {
                    if (  this.props.myFavourites[k].id   == profile_id
                      && this.props.myFavourites[k].name == profile_name
                    ) {
                      favFound = true;
                    }
                  }
                }
                if (favFound) {
                  var fav = <a href="#" title="remove from your favourite" onClick={this.handleRemoveFromFavourite.bind(this,profile_id,profile_name)}><i className="glyphicon glyphicon-ok" /></a>;
                } else {
                  var fav = <a href="#" title="add to your favourite" onClick={this.handleAddToFavourite.bind(this,profile_id,profile_name)}><i className="glyphicon glyphicon-ok" style={{ "color": "#ddd"}}/></a>;
                }
    
                if (this.state.treeStructure[key].type == "org_relation") {
                  return (
                      <tr key={key}>
                        <td><div className="badge badge-gray profileBadge">P</div><a href="#" onClick={this.handleSaveProfile.bind(this,key,profile_id,profile_name)}>{profile_name}</a></td>
                        <td>{fav}</td>
                        <td><a href={url} target="_blank"><i className="glyphicon glyphicon-question-sign"/></a></td>
                      </tr>
                  );
                } else
                if (this.state.treeStructure[key].type == "manual" || this.state.treeStructure[key].type == "ssc_roster" || this.state.treeStructure[key].type == "ice") {
                  return (
                    <tr key={key}>
                      <td><div className="badge badge-gray profileBadge">U</div><a href="#" onClick={this.handleSaveProfile.bind(this,key,profile_id,profile_name)}>{profile_name}</a></td>
                      <td>{fav}</td>
                      <td><a href={url} target="_blank"><i className="glyphicon glyphicon-question-sign"/></a></td>
                    </tr>
                  )
                }
            }
          }
        }.bind(this));
    
        if(this.state.search == true) {
    
            var searchHead =
              <thead><tr><th>Profile Name</th><th>Folder </th><th> &nbsp;</th></tr></thead>;
    
            var searchResp=this.state.searchResult.map(function(profileRow) {
                folders = [];
                if( profileRow.folder!=null )
                    folders = profileRow.folder.split(/\//);
                var i = 0;
    
                if(i == 0) {
                    firstPath = <a href="#" onClick={this.handleSearchClick.bind(this,"",i,folders,this.state.initialStructure)}>/</a>
                }
    
                var fpath = folders.map(function(folder) {
                  i = i+1;
                  return (<a href="#" onClick={this.handleSearchClick.bind(this,folder,i,folders,this.state.initialStructure)}>{folder}/</a>);
                }.bind(this));
    
                var url="/os/int/profileInfo.html?id="+profileRow.alert_profile_id;
    
                if(profileRow.source == "org_relation") {
    
                  return (
                      <tr>
                        <td className="profilehighlight"><div className="badge badge-gray profileBadge">P</div>&nbsp;
                            <a href="#" onClick={this.handleSaveProfile.bind(this,"",profileRow.alert_profile_id,profileRow.alert_profile_name)}>{profileRow.alert_profile_name}</a></td>
                        <td>{firstPath}{fpath}</td>
                        <td><a  href={url} target="_blank">info</a></td>
                      </tr>
                  )
                }else if(profileRow.source == "manual" || profileRow.source == "ssc_roster" || profileRow.source == "ice") {
    
                  return (
                      <tr>
                        <td className="profilehighlight"><div className="badge badge-gray profileBadge">U</div>&nbsp;
                            <a href="#" onClick={this.handleSaveProfile.bind(this,"",profileRow.alert_profile_id,profileRow.alert_profile_name)}>{profileRow.alert_profile_name}</a></td>
                        <td>{fpath}</td>
                        <td><a href={url} target="_blank">info</a></td>
                      </tr>
                  )
                }
            }.bind(this));
            table =
                <table border="1" width="50%" className="profileTable table" id="profileTableId">
                  {searchHead}
                  <tbody>
                    {searchResp}
                  </tbody>
                </table>
            }
    
          return (
    
            <div className="modal-content">
              <div className="modal-header">
                <button type="button" className="close" data-dismiss="modal" aria-hidden="true" onClick={this.handleClose}>x</button>
                <h3 className="modal-title">Select / Search Profile</h3>
              </div>
              <div className="modal-body">
              <div id="searchAlert"></div>
                <form  role="form">
                  <div className="form-group">
                    <label htmlFor="profileName" className="col-sm-2 control-label">Profile Name:</label>
                    <div className="col-sm-5" style={{ "marginLeft" : "-55px"}}>
                      <input type="text" className="form-control" id = "profilename" defaultValue="" onChange={this.handleText}/>
                    </div>
                  </div>
                  <div className="col-sm-2" style={{ "marginLeft" : "-21px"}}>
                    <button type="button" className="btn btn-primary" onClick={this.handleSearch}>Search</button>
                  </div>
                  <div className="col-sm-2" style={{ "marginLeft" : "-67px"}}>
                    <button type="button" className="btn btn-primary" onClick={this.handleBrowse}>Browse</button>
                  </div>
    
                  <br/>
                  <br/>
                  <div id = "profileSearchResult" className="form-group hide">
                    <div className="col-sm-12" style={{ "overflow": "auto", "height":  "400px !important" ,"marginLeft" : "-15px"}}>
                      <label htmlFor="profileName" className="col-sm-2 control-label" style={{ "color": "red"}}>Nothing found</label>
                    </div>
                  </div>
                  <div className="form-group" >
                    <div style={{ "overflow": "auto", "height": "400px !important", "paddingRight": "1px"}}>
                      <table className="table hide" id="folderStructure">
                        <thead className="header">
                          <tr>
                          <th colSpan="3" style={{"backgroundColor":"#f4f4f4", "color":"#777", "fontSize": "14px", "border":"0px", "borderRight": "1px solid #f4f4f4", "borderBottom": "2px solid #ccc"}}>
                            {upfolder}&nbsp;{cpath} &nbsp;
                              <input type="text"  className="form-control" style={{"width":"200px", "display":"inline"}} id="profile" placeholder="Search in Folder" defaultValue="" onChange={this.handleSearchInFolder}/>
                           </th>
                          </tr>
                        </thead>
                        <tbody>
                          {sourcePath}
                        </tbody>
                      </table>
                      {table}
                    </div>
                  </div>
                </form>
             </div>
             <div className="modal-footer">
                <button type="button" className="btn btn-primary" data-dismiss="modal" onClick={this.handleClose}>Close</button>
             </div>
          </div>
          );
      }
    };

    if (window.location.pathname == '/static/dist/backlog.html') {
      window.MainGrid = null;
      window.DrillDownData = null;

      var maxParallelLoaders = 3; 

      var alertQueueLoaderIDs = [];
      for (var i = 0 ; i < maxParallelLoaders; i++) {
          alertQueueLoaderIDs.push(null);
      }
      window.legacystate = {
        logParams: {t:'BMTEvent',e:'BMT_onInit', time: new Date()},
        queue: null,
        alertQueueLoaderIDs: alertQueueLoaderIDs,
        userInputSession: null
      }

      UserSettings.load( function(data) {
        //console.log("GEGA data: ", data);
        //console.log("GEGA UserSettings: ", UserSettings);

        ReactDOM.render( <BacklogPage UserSettings={UserSettings}/>,
          document.getElementById('main')
        );

      })
    }

  



